export function VIFGears(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.ValueTextBlack_line = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#000000').ss(2, 0, 1).p('AifAAIE/AA');

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#FFFFFF').ss(2, 0, 1).p('AihAAIFDAA');
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.1, -1, 34.3, 2);

  (lib.ValueText_glow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        [
          'rgba(255,255,255,0.502)',
          'rgba(255,255,255,0.8)',
          'rgba(255,255,255,0)',
        ],
        [0, 0, 1],
        0,
        0,
        0,
        0,
        0,
        20.8,
      )
      .s()
      .p(
        'AiRCSQg9g8ABhWQgBhVA9g8QA8g9BVAAQBVAAA9A9QA9A8gBBVQABBWg9A8Qg9A9hVAAQhVAAg8g9g',
      );
    this.shape.setTransform(0.0184, -0.0236, 1.4528, 1.4492);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueText_glow,
    new cjs.Rectangle(-30, -30, 60, 60),
    null,
  );

  (lib.comsuntexsymbolsValueText = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.smallText = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 23;
    this.smallText.lineWidth = 57;
    this.smallText.parent = this;
    this.smallText.setTransform(17.65, 2);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueText,
    new cjs.Rectangle(-13, 0, 61.3, 27.1),
    null,
  );

  (lib.subtractionTile16 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('10-5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('10-4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('9-4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('8-4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(3, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('10-3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('9-3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile10 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('8-3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile09 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('7-3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile08 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('3', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6-3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile07 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('10-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile06 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('9-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile05 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('8-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('7-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('3', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.subtractionTile01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('2', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4-2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.PostivieFeedback_bg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(153,0,153,0.2)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape.setTransform(-0.0024, -0.0204);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,51,51,0.247)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_1.setTransform(-0.0024, -0.0204);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,153,0,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_2.setTransform(-0.0024, -0.0204);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('rgba(153,204,0,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_3.setTransform(-0.0024, -0.0204);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('rgba(51,153,153,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_4.setTransform(-0.0024, -0.0204);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(0,102,204,0.247)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_5.setTransform(-0.0024, -0.0204);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('rgba(102,0,204,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_6.setTransform(-0.0024, -0.0204);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('rgba(204,51,153,0.298)')
      .s()
      .p('AtCkrIaFCWIhGCMI2LE1g');
    this.shape_7.setTransform(6.4, 0.55);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,51,51,0.298)')
      .s()
      .p('Av7gaICtkfIJgIDIIWn1ILUG4IlFCKIlWmIIo9Grg');
    this.shape_8.setTransform(0.075, -0.075);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('rgba(255,153,0,0.298)')
      .s()
      .p('Av7gaICtkfIJ+EoIKsjeIIgF8IlFCKIlWmIIo9Grg');
    this.shape_9.setTransform(0.075, -0.075);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('rgba(153,204,0,0.298)')
      .s()
      .p('AvdjRIOXAxIGJEBIFWmJIFFCLIo+FyIqsjeIpgExg');
    this.shape_10.setTransform(3.075, 1.6);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(102,51,204,0.298)')
      .s()
      .p('AtvCbICgjHIWBjIIC+Hpg');
    this.shape_11.setTransform(-1.5, -1.05);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('rgba(51,153,153,0.298)')
      .s()
      .p('ADvjJIoWH1IrUm4IFFiKIFWGIII9mrIMfFUIitEfg');
    this.shape_12.setTransform(0.025, -0.125);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('rgba(0,51,204,0.298)')
      .s()
      .p('Av7ghIKhjZIBsG9IIWn1ILUG4IlFCKIlMiZIpHC8g');
    this.shape_13.setTransform(0.075, 0.625);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('rgba(204,51,153,0.298)')
      .s()
      .p('Av7iFIFFiKIFgEQIIzkzIMfFUIqhCxIhsmVIoWH1g');
    this.shape_14.setTransform(0.025, 0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 13)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_12 }] }, 1)
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-102, -38.8, 204.1, 77.6);

  (lib.PostitiveFeedback_text = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape.setTransform(-3.425, 2.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_1.setTransform(-7.025, 0.425);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AhOBuQgMgTAAgFQAAAAAAAAQAAgBABAAQAAAAAAAAQAAgBABAAIAYgEQAQgFAAgLQAAgIgJgKIgRgTQgIgNgBgOQABgZAagTQAYgQAcAAQACAAAKATQAMATAAADQAAACgEADIgJgBQgJAAgIAEQgIAFAAAJQAAAGAJAKQANAOACAFQAKANgBAQQABAIgEALQgEALgGAFQgMALgSAIQgSAIgQAAQgDAAgNgTgAI4BnQgagZAAgpQAAgoAXgaQAYgaAoAAQAjAAAXAYQAXAZAAAhQABASgMACIglAEIg9AFQACAMANAGQAKAFANAAQAQAAAPgJIANgIQAFACAIAQQAJAQAAAEQAAACgDACQgVAXguAAQgpAAgagYgAJdgBQgHAIAAALQAAAFAEAAQANAAAcgEQAGgBAAgCQAAgLgIgHQgIgIgKAAQgMAAgGAJgAj1BnQgagZAAgpQAAgoAYgaQAYgaAoAAQAiAAAXAYQAYAZAAAhQAAASgLACIglAEIg9AFQABAMANAGQALAFAMAAQAQAAAQgJIANgIQAEACAIAQQAJAQAAAEQAAACgDACQgUAXguAAQgqAAgagYgAjQgBQgHAIABALQgBAFAFAAQANAAAcgEQAFgBAAgCQABgLgJgHQgHgIgLAAQgLAAgHAJgALnB1QgJgKAAgPQAAgOAJgKQAKgJAOAAQAPAAAJAJQAKAKgBAOQABAPgKAKQgJAKgPAAQgOAAgKgKgAA9BlQgZgYAAgnQAAgoAYgZQAYgaAoAAQAoAAAZAZQAZAZgBAnQABAogZAZQgZAZgoAAQgmAAgZgZgABmAMQgIAKAAAOQAAAOAIAKQAJALAOAAQANAAAKgLQAIgKAAgOQAAgOgIgLQgKgKgNAAQgOAAgJALgApuB6QgGgBgCgHQgGgZgDgCQgCgBgtAAQgeAAgBACQgEACgDAQQgEAPgFABQgFACgiAAQgbAAAAgFQAAgFAnhsIAvh/QACgHADAAIAOABIAPABIAPAAIANgBQAEAAADAGQAIASApBrQAqBtAAAFQAAADgEABQgFACgbAAQgaAAgHgCgAqxgIQgKAbAAAEQAAAEALAAIASAAQALAAABgCIAAgDQAAgGgIgZQgHgZgEgHQgEAHgIAagAHKB6QgGgBABgHIAAgYIABgZIgBgrQgBgVgTAAQgIAAgIAHQgJAGAAAJIgBArIABAZIAAAZQAAAGgFAAIg2AAQgEAAAAgHIAAgZIABgZIAAgTIgBgUQAAgZgTAAQgIAAgJAGQgJAGAAAHIAAAwIAAAwQAAAEgBABIgGACIgZAAIgZgBIgFgBQgBgBAAgEIABgqIAAgqQAAgdgFgjIAAgDQAAgDADgCQADgBALgBIAPgCIAPgDQAIgDAFAAQAEAAAAAMQAAANACAAIADgDQAQgMAKgFQANgGAQAAQAQAAAMAHQAPAIAEAPQAKgNAPgJQARgIAQAAQAWAAAQAKQAQANAAAWIAAAbIgBAcIABAiIAAAhQAAAGgGABIgaAAQgVAAgFgBgAl7B6IgGgDQgKgKgVgnQgWAogIAJQgFAEgSAAQgNAAgFgBQgIgCgVgkQgRgdgIgSQgEgLAAgaQAAggABgIQACgEAFAAIAYAAIAYABQAEAAABAGIgBAPIgBAQQAAAUACAKQAAAEAKAQQAIAQADAAQACAAAJgQQAHgNACgGQACgHAAgYIgBgQIgBgPQAAgGAEAAIAUAAIAMAAIATAAQAEABAAAFIAAAUIgBATQAAASABAFQACAGAGANQAIAQAEAAQACAAAJgQQAIgPABgFIAAg9QABgGADAAIAYgBIAZAAQAEAAACAEQABAIABAgQAAAbgFAKQgFAMgRAeQgTAggHAHQgFAFgTAAQgPAAgEgBgALvAlQgRg4AAgIIABgVIAAgVIAAgYIgBgYQAAgGADAAIAPAAIAPABIAPgBIAPAAQADAAAAAqQAAAggFAcIgPA5QgBAGgMAAQgOAAgCgFg',
      );
    this.shape_2.setTransform(-6.75, -0.625);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_3.setTransform(-4, 3.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_4.setTransform(-5.075, 0.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_5.setTransform(-5.85, 0.675);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_6.setTransform(-6.35, 1.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'Ag/CXQgjgGAAgJIAIgkQACgFADAAIACAAQAcAOAZAAQANAAANgGQAPgIAAgMIAAgNQgSASgeAAQgiAAgXgZQgVgYgBgjQABgjAUgXQAWgYAjAAQAcAAAOAUIAEAEQABAAAAgHQAAgPAEAAIAgADIAeAEQADABAAADIAAAnIgBAlIAAAXIAAAXQAAA0gWAXQgXAYg0AAQgQAAgbgFgAgogRQgJAKAAAMQAAAOAJAKQAJAKANAAQAOAAAIgKQAJgKAAgOQAAgMgJgKQgIgKgOAAQgNAAgJAKgAMrBjQgKgKAAgQQAAgPAKgKQAKgKAPAAQAPAAALAKQAJAKAAAPQAAAQgJAKQgLAKgPAAQgPAAgKgKgAKVBDIABglIABgkQAAgIgKAAIgCAAIgDAAQgHAAAAgFIABgJIAAgJIAAgMIgBgLQAAgEAMgBQAHAAABgDQAAgHAAgQIAAgWQAAgWADAAIAPACIAOADIAdAEQAEAAABADIgBAWIgCAXQAAAJAFAAIAUgBIAUAAQAEAAAAADIgBAMIAAANIAAANIAAANQAAAEgGAAIgMAAIgMAAIgPAAQgCAAAAAIIAAAMIAAANQAAAQADAGQAGAIAOAAIAOgCIALgDQAFAAAAAEIgCARIgCARQAAAFgBACIgFAEQgYANgdAAQg2AAAAgpgAE+BDIABglIABgkQAAgIgKAAIgDAAIgCAAQgHAAAAgFIABgJIAAgJIAAgMIgBgLQAAgEAMgBQAHAAABgDQABgHgBgQIAAgWQAAgWAEAAIAOACIAOADIAdAEQAEAAABADIgBAWIgCAXQAAAJAFAAIAUgBIAUAAQAEAAAAADIgBAMIAAANIAAANIAAANQAAAEgGAAIgMAAIgMAAIgPAAQgCAAAAAIIAAAMIAAANQAAAQADAGQAFAIAPAAIAOgCIALgDQAEAAABAEIgCARIgCARQAAAFgBACIgGAEQgXANgdAAQg2AAAAgpgAB+BSQgagZAAgpQAAgqAZgbQAagbArAAQAqAAAaAaQAaAbAAAoQAAArgaAaQgaAagqAAQgpAAgbgagACqgLQgJALAAANQAAAPAJALQAJAMAQAAQANAAAKgMQAJgLAAgPQAAgNgJgLQgKgMgNAAQgQAAgJAMgApfBSQgagZAAgpQAAgqAZgbQAagbAqAAQAqAAAbAaQAaAbAAAoQAAArgaAaQgbAagqAAQgpAAgagagAozgLQgJALAAANQAAAPAJALQAJAMAPAAQAOAAAKgMQAJgLAAgPQAAgNgJgLQgKgMgOAAQgPAAgJAMgAkoBpQgDAAgBgEIgBgLQgBgIgCgBQABABgUAMQgVANgSAAQgxAAgIgtQgFgUAAgnQAAgqAHgYQACgIAGAAIAaAAIAZAAQAHAAgBAFIAAAEQgEAZAAAaQAAAgACAMQAEAUAVAAQAHAAALgHQAIgHABgIIABhcQAAgHABgBQABgCAFAAIAcABIAbAAQAGAAAAADIAAAEIgBApIgBAoIABApIABAnQAAAFgEACQgIACgXAAQgUAAgIgCgAItBpQgEgBgBgCIAAgFIAAgnIABgmQAAg0gFgfIAAgEQAAgEAFAAIAQABIAQABIAQgBIARgBQAEAAAAAEIgBAEQgDAkAAAvIAAAoIABAoQgBAEgEABQgGABgXAAQgWAAgGgBgAsZBpQgGgBAAgFIACgeIACgeQAAgGgFgHQgWgegqhCQgEgHAAgFIgBghIgBghQAAgHAEAAIAiABIAjABQABAAAAAAQABABABAAQAAAAAAABQAAAAAAABIAAAdIgBAcQAAAGAQAWIAVAbIAVgbQAPgWAAgFIAAgcIgCgcQAAgBAAgBQAAgBAAAAQABgBAAAAQAAgBABAAIAEAAIAiAAIAigCQADAAAAAIIAAAeIABAeQAAAIgDAGQgYAwgqA0QgHAIAAAGIACAdIABAeQAAABAAAAQAAABAAAAQgBABAAAAQAAABgBAAIgEABQgHABgbAAQgbAAgHgBgAMyAOQgRg6AAgIIABgXIAAgXIAAgZIgBgZQAAgHAEAAIAPABIAQABIAQgBIAQgBQADAAAAAtQAAAigGAeIgPA7QgCAHgNAAQgPAAgCgGgAIwhdQgLgJAAgPQAAgPAMgJQAKgJAPAAQAOAAALAJQALAJAAAPQAAAggkAAQgPAAgLgIg',
      );
    this.shape_7.setTransform(-7.4, 1.975);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgaCBQgJgLgBgQQABgRAJgKQALgLAPAAQAQAAAKALQAKAKAAARQAAAQgKALQgJAKgRABQgPgBgLgKgAgSAoQgSg/AAgIIABgYIABgXIgBgbIgBgaQAAgIAEABIARAAIAPABIAQgBIARAAQADAAAAAuQAAAkgFAgIgQA/QgCAGgNAAQgQAAgCgFg',
      );
    this.shape_8.setTransform(79.55, 0.8);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgyBVIABgnIABgmQAAgIgKAAIgDAAIgCAAQgIAAAAgFIABgKIAAgJIAAgMIgBgNQAAgEANAAQAHgBAAgDIABgXIgBgZQAAgWAFAAQAFAAAKACIAPADIAdAEQAFAAAAADIgBAYIgCAXQAAAKAGAAIAVgBIAVAAQAEAAAAADIgBANIgBAOIAAANIAAAOQAAADgFAAIgNAAIgNgBIgPAAQgDABAAAIIAAAOIAAAOQAAAQAEAHQAFAIAQAAIAOgCIAMgDQAFABAAAEIgCARIgBASQAAAGgCABIgGAFQgZAOgfgBQg3ABAAgsg',
      );
    this.shape_9.setTransform(66.225, 1.75);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCGQgEgBgBgCIgBgGIABgoIAAgpQAAg2gDghIgBgEQAAgEAFAAIARABIAQABIARgBIARgBQAFAAgBAEIAAAEQgEAmAAAxIABArIAAAqQAAAEgFABQgHABgXAAQgWAAgHgBgAgahLQgLgJAAgQQAAgPAMgKQALgJAOAAQAQAAALAJQAMAKAAAPQAAAignAAQgOAAgMgJg',
      );
    this.shape_10.setTransform(53.15, 0.875);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgyBVIABgnIABgmQAAgIgKAAIgDAAIgCAAQgIAAAAgFIABgKIAAgJIAAgMIgBgNQAAgEANAAQAHgBAAgDIABgXIgBgZQAAgWAFAAQAFAAAKACIAPADIAdAEQAFAAAAADIgBAYIgCAXQAAAKAGAAIAVgBIAVAAQAEAAAAADIgBANIgBAOIAAANIAAAOQAAADgFAAIgNAAIgNgBIgPAAQgDABAAAIIAAAOIAAAOQAAAQAEAHQAFAIAQAAIAOgCIAMgDQAFABAAAEIgCARIgBASQAAAGgCABIgGAFQgZAOgfgBQg3ABAAgsg',
      );
    this.shape_11.setTransform(30.125, 1.75);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AhGBIQgcgbAAgrQAAgsAbgcQAbgdAsAAQAsAAAbAcQAcAcAAArQAAAsgbAcQgcAcgsAAQgqAAgcgcgAgYgaQgJALAAAPQAAAPAJAMQAKAMAOAAQAQAAAKgMQAJgMAAgPQAAgPgKgLQgJgMgQAAQgOAAgKAMg',
      );
    this.shape_12.setTransform(11.975, 4.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AguB2QgkgGAAgJQAAgDAIgkQABgEADAAIACAAQAfAPAZAAQANAAAOgHQARgJAAgMIAAgNQgUASgeABQglgBgYgaQgXgZAAglQAAglAWgZQAXgZAlAAQAdAAAPAVQADAEACAAQABABAAgIQAAgPAEAAIAiADIAfADQAEACAAAEIgBAoIgBAoIAAAYIAAAXQAAA4gXAYQgYAZg4AAQgQAAgcgGgAgWg7QgKALAAAOQAAAPAKAKQAKAJANAAQAOAAAJgJQAKgKAAgPQAAgOgKgLQgJgKgOAAQgOAAgJAKg',
      );
    this.shape_13.setTransform(-10.475, 7.25);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AAiBdQgEgBgBgEIgBgMQgBgIgCgBIAAAAIAAAAQACABgVANQgWANgSAAQg0AAgJguQgFgXAAgnQAAgtAHgaQADgIAGAAIAbAAIAbAAQAGAAAAAGIAAADQgEAbAAAbQAAAiACAMQADAVAWABQAIAAAKgIQAKgIABgIIAAhhQAAgGABgCQABgCAGAAIAdAAIAdABQAFAAABADIABAEIgCAsIgBAqIABAqIABAqQAAAFgFACQgHACgYAAIgegBg',
      );
    this.shape_14.setTransform(-43.075, 5.05);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AhGBIQgcgbAAgrQAAgsAbgcQAbgdAsAAQAsAAAbAcQAcAcAAArQAAAsgbAcQgcAcgsAAQgqAAgcgcgAgYgaQgJALAAAPQAAAPAJAMQAKAMAOAAQAQAAAKgMQAJgMAAgPQAAgPgKgLQgJgMgQAAQgOAAgKAMg',
      );
    this.shape_15.setTransform(-65.325, 4.675);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgkCIQgGAAABgFIACggIABgfQAAgHgEgHQgYgigshDQgFgIABgFIgCgjIgBgjQAAgGAEAAIAkAAIAlABQAEAAAAADIgBAfIgBAdQAAAGARAXQAOATAIAKIAVgcQARgXAAgGIgBgdIgCgdQAAgFACgBIAEAAIAkgBIAjAAQAEAAAAAIIAAAfIABAgQAAAIgDAGQgaAzgsA2QgGAIAAAIIABAeIABAfQAAABAAABQAAAAAAABQgBAAAAABQAAAAAAAAIgGABQgGABgcAAQgcAAgIgBg',
      );
    this.shape_16.setTransform(-88.3, 0.6);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_17.setTransform(-5.95, 0.175);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_18.setTransform(-6.65, 0.45);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_19.setTransform(-6.625, 0.225);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_20.setTransform(-4.8, 1.125);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_21.setTransform(-4.425, 3.475);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_17 }] }, 11)
        .to({ state: [{ t: this.shape_18 }] }, 1)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .to({ state: [{ t: this.shape_20 }] }, 1)
        .to({ state: [{ t: this.shape_21 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-102.7, -24.4, 191.8, 51.2);

  (lib.multiiplicatonTile37 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('81', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('9×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile36 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('72', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('8×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile35 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('64', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('8×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile34 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('63', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('7×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile33 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('56', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('7×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile32 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('49', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('7×7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile31 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('54', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile30 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('48', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile29 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('42', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6×7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile28 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('36', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6×6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile27 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('45', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile26 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('40', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile25 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('35', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5×7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile24 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('30', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 22;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5×6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 103);

  (lib.multiiplicatonTile23 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('25', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5×5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile22 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('36', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile21 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('32', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile20 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('28', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4×7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile19 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('24', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4×6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile18 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('20', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4×5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile17 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('16', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4×4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('27', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('24', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('21', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('18', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.lineWidth = 33;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 77);

  (lib.multiiplicatonTile11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('15', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile10 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('12', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile09 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3×3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile08 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('18', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile07 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('16', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile06 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('14', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile05 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('12', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('10', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.multiiplicatonTile01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2×2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFCC44')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.Veil = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('EhK/BLAMAAAiV/MCV/AAAMAAACV/g');

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Veil,
    new cjs.Rectangle(-480, -480, 960, 960),
    null,
  );

  (lib.congratulations_button = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0.498)', 'rgba(255,255,255,0)'],
        [0, 1],
        6,
        -22.1,
        6,
        8,
      )
      .s()
      .p(
        'AmfCUQisg9AAhXQAAhWCsg9QCsg+DzABQD0gBCsA+QCtA9gBBWQABBXitA9QisA+j0gBQjzABisg+g',
      );
    this.shape.setTransform(0.05, -4);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // Layer 1
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgoArQgRgPAAgbQAAgbARgPQAQgQAcAAQAbAAAOAOQANANAAAZIAAAMIhQAAQACAMAIAIQAKAGAQAAQALAAALgEQAKgEAGgFIAEAAIAAAdIgWAHQgLACgNAAQgfAAgTgPgAgOgeQgHAFgBAMIAtAAQAAgLgFgGQgGgFgLAAQgJAAgGAFg',
      );
    this.shape_1.setTransform(43.95, 1.2);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgsAuQgKgLAAgUIAAhGIAjAAIAAA2IABANQAAAFACAEQACAEAEABQAEACAGAAIAJgCQAGgBAFgEIAAhMIAjAAIAABsIgjAAIAAgMQgKAIgIADQgHAEgLAAQgSAAgKgKg',
      );
    this.shape_2.setTransform(30.125, 1.375);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAUA4IAAg2IgBgMIgCgKQgCgEgEgBQgEgCgGAAQgEAAgFACQgFABgGAEIAABMIgjAAIAAhsIAjAAIAAAMQAJgIAJgEQAIgDAKAAQASAAAKAKQAKAKAAAVIAABGg',
      );
    this.shape_3.setTransform(15.975, 1.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p('AgRBMIAAhsIAjAAIAABsgAgSgxIAAgaIAlAAIAAAag');
    this.shape_4.setTransform(5.375, -0.9);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQBAQgKgJAAgUIAAgyIgOAAIAAgYIAOAAIAAgfIAjAAIAAAfIAgAAIAAAYIggAAIAAAlIAAAKQAAAFABADQACAEADACQAEACAGAAIAHgBIAHgCIACAAIAAAXIgMADIgPABQgUgBgKgHg',
      );
    this.shape_5.setTransform(-2.625, -0.25);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAUA4IAAg2IgBgMIgCgKQgCgEgEgBQgEgCgGAAQgEAAgFACQgFABgGAEIAABMIgjAAIAAhsIAjAAIAAAMQAJgIAJgEQAIgDAKAAQASAAAKAKQAKAKAAAVIAABGg',
      );
    this.shape_6.setTransform(-14.225, 1.075);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgrArQgQgQAAgbQAAgaAQgQQAQgPAbAAQAdAAAPAPQAQAQAAAaQAAAbgQAQQgPAPgdAAQgcAAgPgPgAgIgfQgEABgEAEQgCAEgCAGQgCAHgBAJQAAAJACAHQACAGADAEQADAEAEACQAFACAEAAQAFAAAEgCQAFgCADgDQAEgFABgFQACgGAAgLQAAgJgCgGQgBgHgEgDQgDgFgFgBQgEgCgFAAQgEAAgEACg',
      );
    this.shape_7.setTransform(-28.3, 1.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgRBGQgOgEgKgJQgKgKgFgOQgGgPAAgSQAAgQAFgOQAGgOAKgLQAJgJAOgFQAOgGAQAAIAQABIAOADIAMAEIAJAEIAAAjIgEAAIgHgFIgKgGQgFgEgGgCQgGgCgIAAQgIABgHACQgGACgGAGQgGAGgDAJQgEAJAAAMQAAAOAEAJQAEAJAGAFQAGAFAGADQAHACAIAAQAGAAAHgCQAHgCAFgDIAJgHIAHgFIAEAAIAAAjIgKAFIgLADIgNAEIgRABQgQAAgNgGg',
      );
    this.shape_8.setTransform(-42.325, -0.55);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f()
      .ls(['#6600CC', '#330066'], [0, 1], 23.4, -24.3, -23.3, 24.3)
      .ss(3, 1, 1)
      .p(
        'AGGAAQAABmhyBHQhzBIihAAQihAAhyhIQhyhHAAhmQAAhkByhIQByhIChAAQChAABzBIQByBIAABkg',
      );
    this.shape_9.setTransform(-0.0006, -0.0118, 1.8205, 1.1531);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .lf(['#6600CC', '#330099'], [0.004, 1], -39, 0, 39, 0)
      .s()
      .p(
        'AkTCtQhyhHAAhmQAAhkByhJQBzhHCgAAQCiAABxBHQBzBJAABkQAABmhzBHQhxBIiiAAQigAAhzhIg',
      );
    this.shape_10.setTransform(-0.0006, -0.0118, 1.8205, 1.1531);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.congratulations_button,
    new cjs.Rectangle(-77.9, -29.7, 156.9, 59.5),
    null,
  );

  (lib.sb = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FF7D32').s().p('AlvCeIAAk7ILfAAIAAE7g');
    this.shape.setTransform(36.75, 15.75);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#66FF00').s().p('AlvCeIAAk7ILfAAIAAE7g');
    this.shape_1.setTransform(36.75, 15.75);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 73.5, 31.5);

  (lib.curtain = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('A4cPPIAA+dMAw5AAAIAAedg');
    this.shape.setTransform(0.5, 12.45);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.curtain,
    new cjs.Rectangle(-156, -85, 313, 195),
    null,
  );

  (lib.gear03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#414042')
      .s()
      .p(
        'AENPYIg7gxIgfgfIgpg4IgRgfIgIgVIgBgHIAAgBIgXieIjKgEIgcCcIgBACIAAADIgEAJIgSAjIglAyIgNAPIgzAtIhcA+Ig7AcIgXgGIgPgGIgUgOIgSg+IgQhUIgCgZIgBhEIAGg2IARg5IAKgSIABgBIBgiAIiNiSIiEBbIgMAGIglAMIg+AJIhXgCIg0gIIh2gjIgNgVIgGgPIgFgYIAvhSIBBhTIA8g2IAagSIApgUIARgGIACAAIABgBICfgWIADjKIicgdIgCAAIgTgHIgzgeIg5gyIgug4IguhIIgcg6IAGgYIAGgOIAOgVIAfgKIBYgUIBjgIIBZALIAjAKIAYAMICDBiICSiNIhbiDIgJgUIgGgSIgIgoIgFg2IABgrIAKhMIAYhXIALgfIAWgNIAOgGIAYgFIAdAPIBNAwIBLBBIAPAQIApA3IAMAWIANAeIABAHIAAACIAXCdIDKAEIAcicIAIgVIAPgcIAagkIA4g7IA9guIBtg7IAXAGIAPAGIAUAOIAfB3IAGBjIgGBLIgRA5IgKASIgBABIhgCAICNCSICEhbIADgBIAEgDIAqgOIA+gJIA/AAIBMAKIB2AjIANAVIAGAPIAFAYIgvBSIhBBTIgvArIgnAdIgpAUIgRAGIgCAAIgBABIifAWIgEDKICdAdIACAAIADABIAKADIAiASIBAAyIAuAyIAfArIA7BsIgGAYIgGAOIgOAVIg+ATIhUAPIhdADIgmgEIg3gNIgegMIgGgEIgCgBIh/hgIiSCNIBbCDIACAEIAHAQIAGASIAIAoIAFBLIgHBIIgLA2IgcBbIgWAMIgOAGIgYAFgABqJiIAZCuIAAABIABACIAAADIACAFIADAGIAMAaIAiAxIAoAsIBQA/IBLArIAPgDIALgFIAOgIIASg1IAWhqIACgXIgBhOIgKg0IgMgfIgBgBIAAgBIhkiRICrikICMBqIABAAIACABIAUAKIAuANIAzAGIBagDIBSgPIA2gQIAIgNIAFgLIAEgQIgohMIg7hSIgrgrIgagUIgngZIgWgJIgCgBIgBAAIisgfIAEjtICvgYIAAAAIAQgFIAQgIIAtgcIAOgKIA8g7IAwg/IAqhKIgEgPIgEgMIgIgNIgYgJIhUgXIhKgKIg8AAIg8AIIgmANIgCACIgDABIAAAAIiRBkIikirIBqiMIAAgBIADgFIAIgRIAQg9IADg4IgHhgIgbhuIgNgIIgLgFIgQgEIhjA2Ig7AtIgrArIgjAwIgSAkIgBAFIAAABIggCtIjsgFIgZiuIAAgBIgBgCIAAgDIgCgFIgJgWIgUghIgtg3Ig0gvIhfg+IgXgMIgPADIgLAFIgPAIIgZBSIgOBNIgDBBIAGBBIAGAXIAMAfIABABIAAABIBkCRIirCkIiMhqIAAAAIgKgFIgXgJIg0gMIhNgFIhlAMIhTAXIgIANIgFALIgEAQIAoBMIAtBAIArAwIAzAqIAcAQIAWAJIACABIAAAAICuAfIgFDtIiuAYIgBAAIgFACIglAQIgjAXIgrAkIg/BJIg6BhIAEAPIAEAMIAIANIBRAaIBOAOIBBADIBOgJIAhgLIAEgCIADgCIADgBIAAAAICRhkICkCrIhqCMIAAABIgBACIgCADIgIARIgMAuIgHAzIABBBIARBrIAQA2IANAIIALAFIAPAEIBkg2IBLg8IAwg1IAIgMIAWgqIADgKIAAgBIAgitgAhdIGQjVgmh+i0Qh8izAnjVQAii9CSh6QCSh7C/AAQAtAAAxAJQDVAmB+C0QB8CzgnDVQgiC9iSB6QiSB7i/AAQgtAAgxgJgAlCmFQiOB2giC2QglDOB4CsQB4CtDOAlQAsAIAuAAQC1AACNh1QCPh2Ahi2QAljOh4isQh4isjOgmQgsgIguAAQi1AAiNB1g',
      );
    this.shape.setTransform(104.7, 104.675);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .rf(
        [
          'rgba(0,0,0,0)',
          'rgba(147,152,157,0)',
          '#93989D',
          '#8C9297',
          '#BCBEC0',
          '#58595B',
        ],
        [0, 0.733, 0.733, 0.741, 0.749, 0.89],
        0,
        0,
        0,
        0,
        0,
        104.7,
      )
      .s()
      .p(
        'AE+P4IhGgxIhFg/Igpg4IgRgfIgJgcIAAgBIgXieIjKgEIgcCcIgBACIAAADIgPAhIgXAiIgiAqIgzAtIhCAvIhVArIgXgGIgPgGIgUgOIgSg+IgQhUIgCgZIgBhEIAGg2IARg5IAKgSIABgBIBgiAIiNiSIiEBbIgMAGIglAMIg+AJIhXgCIg0gIIh2gjIgNgVIgGgPIgFgYIAvhSIBBhTIA8g2IAagSIApgUIARgGIACAAIABgBICfgWIADjKIicgdIgCAAIgTgHIgngWIgngeIg8g/IgQgVIguhIIgcg6IAGgYIAGgOIAOgVIAfgKIBYgUIBjgIIBZALIAjAKIAYAMICDBiICSiNIhbiDIgJgUIgGgSIgIgoIgFg2IADhDIAOhQIAdhaIAWgNIAOgGIAYgFIAdAPIBNAwIBLBBIAbAeIAkA0IAFALIANAeIABAHIAAACIAXCdIDKAEIAcicIAIgVIAPgcIAlgyIAtgtIA9guIBtg7IAXAGIAPAGIAUAOIAfB3IAGBjIgGBLIgRA5IgKASIgBABIhgCAICNCSICEhbIADgBIAEgDIAqgOIA+gJIA/AAIBMAKIB2AjIANAVIAGAPIAFAYIgvBSIhBBTIgvArIgnAdIgpAUIgRAGIgCAAIgBABIifAWIgEDKICdAdIACAAIADABIAKADIAiASIAyAlIAsAtIAvA9IA7BsIgGAYIgGAOIgOAVIhbAZIhpANIhRgFIgrgJIgMgEIgegMIgGgEIgCgBIh/hgIiSCNIBbCDIAJAUIAOA6IAFBLIgHBIIgcBxIgLAgIgWAMIgOAGIgYAFgAkgmfQisB4gmDOQglDOB4CsQB4CtDOAlQDNAlCth4QCsh4AmjOQAljOh4isQh4isjOgmQgxgJguABQiXAAiEBbg',
      );
    this.shape_1.setTransform(104.7, 104.675);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        104.7,
      )
      .s()
      .p(
        'AE+P4IhHgxIhDg/Igqg4IgRgfIgKgcIAAgBIgWieIjKgEIgdCcIAAACIAAADIgQAhIgVAiIgjAqIgzAtIhCAvIhUArIgYgGIgPgGIgUgOIgTg+IgPhUIgDgZIAAhEIAHg2IARg5IAJgSIABgBIBgiAIiNiSIiFBbIgLAGIglAMIg+AJIhXgCIg0gIIh3gjIgMgVIgGgPIgFgYIAvhSIBBhTIA9g2IAagSIAogUIARgGIACAAIABgBICfgWIADjKIicgdIgBAAIgUgHIgngWIgngeIg8g/IgPgVIgvhIIgcg6IAGgYIAGgOIANgVIAggKIBYgUIBjgIIBZALIAiAKIAZAMICDBiICTiNIhbiDIgKgUIgGgSIgIgoIgFg2IADhDIAOhQIAehaIAVgNIAOgGIAYgFIAdAPIBNAwIBLBBIAbAeIAjA0IAGALIAMAeIACAHIAAACIAXCdIDKAEIAdicIACgJIAFgMIAOgcIAmgyIAtgtIA9guIBsg7IAZAGIANAGIAVAOIAfB3IAHBjIgCApIgFAiIgSA5IgJASIgBABIhgCAICNCSICFhbIACgBIADgDIANgFIAegJIAcgGIAigDIA/AAIBMAKIB3AjIAMAVIAGAPIAFAYIgvBSIhBBTIguArIgpAdIgnAUIgRAGIgDAAIgCABIidAWIgFDKICeAdIABAAIACABIAKADIAPAHIAUALIAzAlIAsAtIAuA9IA7BsIgGAYIgGAOIgNAVIhcAZIhoANIhRgFIgsgJIgMgEIgegMIgGgEIgCgBIh/hgIiTCNIBbCDIAKAUIAPA6IAEBLIgGBIIgdBxIgMAgIgUAMIgPAGIgYAFgAkgmfQitB4glDOQgkDOB3CsQB4CtDOAlQDOAlCsh4QCsh4AljOQAljOh3isQh3isjPgmQgxgIguAAQiXAAiEBbg',
      );
    this.shape_2.setTransform(104.7, 104.675);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        104.7,
      )
      .s()
      .p(
        'AE+P4IhHgxIhDg/Igqg4IgRgfIgKgcIAAgBIgWieIjKgEIgdCcIAAACIAAADIgQAhIgVAiIgjAqIgzAtIhCAvIhUArIgYgGIgPgGIgUgOIgTg+IgPhUIgDgZIAAhEIAHg2IARg5IAJgSIABgBIBgiAIiNiSIiFBbIgLAGIglAMIg+AJIhXgCIg0gIIh3gjIgMgVIgGgPIgFgYIAvhSIBBhTIA9g2IAagSIAogUIARgGIACAAIABgBICfgWIADjKIicgdIgBAAIgUgHIgngWIgngeIg8g/IgPgVIgvhIIgcg6IAGgYIAGgOIANgVIAggKIBYgUIBjgIIBZALIAiAKIAZAMICDBiICTiNIhbiDIgKgUIgGgSIgIgoIgFg2IADhDIAOhQIAehaIAVgNIAOgGIAYgFIAdAPIBNAwIBLBBIAbAeIAjA0IAGALIAMAeIACAHIAAACIAXCdIDKAEIAdicIAHgVIAOgcIAmgyIAtgtIA9guIBsg7IAZAGIANAGIAVAOIAfB3IAHBjIgHBLIgSA5IgJASIgBABIhgCAICNCSICFhbIACgBIADgDIArgOIA+gJIA/AAIBMAKIB3AjIAMAVIAGAPIAFAYIgvBSIhBBTIguArIgpAdIgnAUIgRAGIgDAAIgCABIidAWIgFDKICeAdIABAAIACABIAKADIAjASIAzAlIAsAtIAuA9IA7BsIgGAYIgGAOIgNAVIhcAZIhoANIhRgFIgsgJIgMgEIgegMIgGgEIgCgBIh/hgIiTCNIBbCDIAKAUIAPA6IAEBLIgGBIIgdBxIgMAgIgUAMIgPAGIgYAFgAkgmfQitB4glDOQgkDOB3CsQB4CtDOAlQDOAlCsh4QCsh4AljOQAljOh3isQh3isjPgmQgxgIguAAQiXAAiEBbg',
      );
    this.shape_3.setTransform(104.7, 104.675);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#000066').s().p('A/KVfMAAAgq9MA+VAAAMAAAAq9g');
    this.shape_4.setTransform(100.0394, 97.775, 0.7521, 1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_3 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_3 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-50, -39.7, 300.1, 275);

  (lib.gear02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#414042')
      .s()
      .p(
        'ACVROIhHg/IgUgVIg6hPIgjhCIgQgxIgDgaIAAgFIALifIjGguIg9CUIgDAIIgIALIgdAhIgmAgIg1AiIhGAhIgbAKIhbAZIgWgLIgNgJIgRgRIgEh7IAMhjIAYhHIAFgOIASgfIATgZIB5hoIhsitIiXA/IgKACIgmAFIg/gFIgogHIhFgWIgzgVIhSgvIgIgYIgDgPIAAgYIAqgyIA+g7IAUgQIBKgtIA6gYIAsgJIAJAAICeAKIAvjGIiUg8IgIgEIgagTIgdgdIgggrIgig6IgqhoIgPg+IALgXIAJgNIARgRIB7gEIA1AEIBCAOIAkAMIApASIAhAUIALAKIBoB5ICthrIg9iUIgBgBIgBgDIgEgRIgCgTIABg5IAKg6IAWhFIAjhOIAhg3IAYgIIAPgDIAYAAIAaAVIBTBTIA0BNIAJARIAYA6IAGAWIAEAaIAAAFIgLCeIDGAvIA8iUIABgBIALgSIAdghIA1grIA7giIBLggIBbgZIAWALIANAJIASASIAEBAIgEBvIgPBDIgRAyIgXAtIgOASIgCAEIgCACIgBABIh5BpIBrCsICTg9IACgBIADAAIAEgCIANgDIAtgDIAxAEIBVAVIAxATIBQApIAcASIAIAXIADAQIgBAYIhTBaIgoAiIg5AkIg/AeIgyAMIgKABIgFAAIifgLIguDGICUA9IAaAQIAaAYIArA2IAXAlIArBhIAZBbIgLAWIgJANIgSARIheAFIhpgKIhOgUIgdgMIgfgSIgWgQIgDgDIhph5IisBsIA9CTIAAACIADAGIADAOIADAsIgIBEIgEAVIgWBFIgWAzIgvBSIgXAIIgQADgAgWJrIgMCvIAAADIAGAgIASAzIAPAfIAzBKIAkAoIBAA5IAQAAIAMgCIAPgFIAdgxIAYgzIAahFIAOhNIADgdIgCgiIgEgTIgBgFIAAgBIhEiiIDKh+IBzCFIABABIABABIACADIAiAVIAmASIBLAUIBmAJIBVgEIALgMIAHgKIAIgNIgXhTIgphdIgigzIgdgjIgSgRIgOgLIgJgGIgFgDIAAAAIijhDIA2joICwANIACAAIAIgBIAigHIAagJIAugWIA2gkIA8gzIA4hAIABgQIgCgMIgGgPIgwgdIhjgrIg/gRIgzgGIgmAAIgRACIgRAEIAAAAIijBEIh9jKICFhzIALgNIAVgkIAWg+IAOg/IAFhPIgEhVIgWgTIgOgHIhsAhIhEAfIgyAhIg0AwIgTAaIgBACIAAAAIhECjIjng2IANivIgBgMIgDgOIgOgtIggg/IgZglIgzg8IhAg5IgQAAIgNACIgOAFIgrBLIgkBeIgNA8IgEA7IAFAoIABADIABADIAAAAIBECjIjKB9Ih0iFIAAAAIgBgCIgMgJIgjgVIg+gWIhZgRIg2gCIhVAEIgLALIgHALIgHAOIAgBsIAgBEIAsBAIAcAfIAcAWIAIAFIABAAICjBEIg2DmIiwgMIgLABIgiAIIg3AXIg0AdIgmAdIg8A6IglAqIAAAQIACAMIAFAPIAxAdIBLAjIBDAUIA3AKIAqACIAjgEIAKgDIABAAICihEIB+DKIiFB0IgBAAIgBABIgGAHIgZAoIgWA+IgNBAIgFBOIAEBVIALAMIALAHIANAHIBTgXIBIgfIA5ggIAogfIAmgpIAGgKIACgDIABgBIAAgBIBDijgAjGHnQjKhShVjJQhUjKBSjIQA9iVCFhaQCFhYCggBQBnAABgAoQDJBSBVDJQBVDKhTDIQg9CWiEBZQiFBZihAAQhmAAhggogAkWmmQiDBWg7CSQhQDBBSDCQBRDBDDBPQBbAmBjAAQCXAACAhUQCChWA8iSQBPjBhRjBQhRjCjDhPQhcglhjAAQiXAAh/BTg',
      );
    this.shape.setTransform(110.2, 110.2);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .rf(
        [
          'rgba(0,0,0,0)',
          'rgba(147,152,157,0)',
          '#93989D',
          '#8C9297',
          '#BCBEC0',
          '#58595B',
        ],
        [0, 0.733, 0.733, 0.741, 0.749, 0.89],
        0,
        0,
        0,
        0,
        0,
        110.2,
      )
      .s()
      .p(
        'ACVROIhHg/IgUgVIg6hPIgjhCIgQgxIgDgaIAAgFIALifIjGguIg9CUIgGAMIgZAeIgvAqIg1AiIhGAhIh2AjIgWgLIgNgJIgRgRIgGhfIAKhpIAchdIAFgOIASgfIAQgWIADgDIB5hoIhsitIiTA9IgEACIgKACIgaAEIgpAAIhKgLIhFgWIgzgVIhSgvIgIgYIgDgPIAAgYIAqgyIA+g7IAUgQIBKgtIA6gYIAsgJIAJAAICeAKIAvjGIiUg8IgIgEIgagTIgdgdIgggrIgig6IgqhoIgPg+IALgXIAJgNIARgRIBBgFIBVADIBcAQIBNAeIAhAUIALAKIBoB5ICthrIg9iUIgBgBIgFgUIgDgfIACgtIAQhQIAlhiIAvhSIAYgIIAPgDIAYAAIAaAVIBTBTIA0BNIAJARIAYA6IAGAWIAEAfIgLCeIDGAvIA8iUIABgBIALgSIAdghIA1grIAmgXIBFghIB2gjIAWALIANAJIASASIAEBAIgEBvIgJAuIgXBHIgXAtIgOASIgCAEIgCACIgBABIh5BpIBrCsICTg9IACgBIADAAIAEgCIANgDIAtgDIAxAEIBVAVIAYAJIBpAzIAcASIAIAXIADAQIgBAYIg/BHIg8A1Ig5AkIg/AeIgrALIgRACIgEAAIiggLIguDGICUA9IAaAQIAaAYIArA2IAXAlIArBhIAZBbIgLAWIgJANIgSARIheAFIg4gDIhcgQIgygSIgOgFIgfgSIgWgQIgDgDIhph5IisBsIA9CTIAAACIADAGIADAOIADAsIgCAfIgQBQIgaBIIgMAaIgvBSIgXAIIgQADgAjEnSQjBBRhPDDQhQDBBSDCQBRDBDDBPQDBBPDBhRQDChRBPjDQBPjBhRjBQhRjCjDhPQhggnhfAAQhiAAhiApg',
      );
    this.shape_1.setTransform(110.2, 110.2);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        110.2,
      )
      .s()
      .p(
        'ACVROIhHg/IgUgVIg6hPIgjhCIgQgxIgDgaIAAgFIALifIjGguIg9CUIgGAMIgZAeIgvAqIg1AiIhGAhIh2AjIgWgLIgNgJIgRgRIgGhfIAKhpIAchdIAFgOIASgfIAQgWIADgDIB5hoIhsitIiTA9IgEACIgKACIgaAEIgpAAIhKgLIhFgWIgzgVIhSgvIgIgYIgDgPIAAgYIAqgyIA+g7IAUgQIBKgtIA6gYIAsgJIAJAAICeAKIAvjGIiUg8IgIgEIgagTIgdgdIgggrIgig6IgqhoIgPg+IALgXIAJgNIARgRIBBgFIBVADIBcAQIBNAeIAhAUIALAKIBoB5ICthrIg9iUIgBgBIgFgUIgDgfIACgtIAQhQIAlhiIAvhSIAYgIIAPgDIAYAAIAaAVIBTBTIA0BNIAJARIAYA6IAGAWIAEAfIgLCeIDGAvIA8iUIABgBIALgSIAdghIA1grIAmgXIBFghIB2gjIAWALIANAJIASASIAEBAIgEBvIgJAuIgXBHIgXAtIgOASIgCAEIgCACIgBABIh5BpIBrCsICTg9IACgBIADAAIAEgCIANgDIAtgDIAxAEIBVAVIAYAJIBpAzIAcASIAIAXIADAQIgBAYIg/BHIg8A1Ig5AkIg/AeIgrALIgRACIgEAAIiggLIguDGICUA9IAaAQIAaAYIArA2IAXAlIArBhIAZBbIgLAWIgJANIgSARIheAFIg4gDIhcgQIgygSIgOgFIgfgSIgWgQIgDgDIhph5IisBsIA9CTIAAACIADAGIADAOIADAsIgCAfIgQBQIgaBIIgMAaIgvBSIgXAIIgQADgAjEnSQjBBRhPDDQhQDBBSDCQBRDBDDBPQDBBPDBhRQDChRBPjDQBPjBhRjBQhRjCjDhPQhggnhfAAQhiAAhiApg',
      );
    this.shape_2.setTransform(110.2, 110.2);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#414042')
      .s()
      .p(
        'ACVROIhHg/IgUgVIg6hPIgjhCIgQgxIgDgaIAAgFIALifIjGguIg9CUIgDAIIgIALIgdAhIgmAgIg1AiIhGAhIgbAKIhbAZIgWgLIgNgJIgRgRIgEh7IAMhjIAYhHIAFgOIASgfIATgZIB5hoIhsitIiXA/IgKACIgmAFIg/gFIgogHIhFgWIgzgVIhSgvIgIgYIgDgPIAAgYIAqgyIA+g7IAUgQIBKgtIA6gYIAsgJIAJAAICeAKIAvjGIiUg8IgIgEIgagTIgdgdIgggrIgig6IgqhoIgPg+IALgXIAJgNIARgRIB7gEIA1AEIBCAOIBNAeIAhAUIALAKIBoB5ICthrIg9iUIgBgBIgBgDIgEgRIgCgTIABg5IAKg6IAWhFIAjhOIAhg3IAYgIIAPgDIAYAAIAaAVIBTBTIA0BNIAJARIAYA6IAGAWIAEAaIAAAFIgLCeIDGAvIA8iUIABgBIALgSIAdghIA1grIA7giIBLggIBbgZIAWALIANAJIASASIAEBAIgEBvIgPBDIgRAyIgXAtIgOASIgCAEIgCACIgBABIh5BpIBrCsICTg9IACgBIADAAIAEgCIANgDIAtgDIAxAEIBVAVIAxATIBQApIAcASIAIAXIADAQIgBAYIhTBaIgoAiIg5AkIg/AeIgyAMIgKABIgFAAIifgLIguDGICUA9IAaAQIAaAYIArA2IAXAlIArBhIAZBbIgLAWIgJANIgSARIheAFIhpgKIhOgUIg8geIgWgQIgDgDIhph5IisBsIA9CTIAAACIADAGIADAOIADAsIgIBEIgEAVIgWBFIgWAzIgvBSIgXAIIgQADgAgWJrIgMCvIAAADIAGAgIASAzIAPAfIAzBKIAkAoIBAA5IAQAAIAMgCIAPgFIAdgxIAYgzIAahFIAOhNIABg/IgEgTIgBgFIAAgBIhEiiIDKh+IBzCFIABABIABABIACADIAiAVIAmASIBLAUIBmAJIBVgEIALgMIAHgKIAIgNIgXhTIgphdIgigzIgdgjIgSgRIgXgRIgFgDIAAAAIijhDIA2joICwANIACAAIAIgBIAigHIAagJIAugWIA2gkIA8gzIA4hAIABgQIgCgMIgGgPIgwgdIhjgrIg/gRIgzgGIgmAAIgRACIgRAEIAAAAIijBEIh9jKICFhzIALgNIAVgkIAWg+IAOg/IAFhPIgEhVIgWgTIgOgHIhsAhIhEAfIgyAhIg0AwIgTAaIgBACIAAAAIhECjIjng2IANivIgBgMIgDgOIgOgtIggg/IgZglIgzg8IhAg5IgQAAIgNACIgOAFIgrBLIgkBeIgNA8IgEA7IAFAoIABADIABADIAAAAIBECjIjKB9Ih0iFIAAAAIgBgCIgMgJIgjgVIg+gWIhZgRIg2gCIhVAEIgLALIgHALIgHAOIAgBsIAgBEIAsBAIAcAfIAcAWIAIAFIABAAICjBEIg2DmIiwgMIgLABIgiAIIg3AXIg0AdIgmAdIg8A6IglAqIAAAQIACAMIAFAPIAxAdIBLAjIBDAUIA3AKIAqACIAjgEIAKgDIABAAICihEIB+DKIiFB0IgBAAIgBABIgGAHIgZAoIgWA+IgNBAIgFBOIAEBVIALAMIALAHIANAHIBTgXIBIgfIA5ggIAogfIAmgpIAGgKIACgDIABgBIAAgBIBDijgAjGHnQjKhShVjJQhUjKBSjIQA9iVCFhaQCFhYCggBQBnAABgAoQDJBSBVDJQBVDKhTDIQg9CWiEBZQiFBZihAAQhmAAhggogAkWmmQiDBWg7CSQhQDBBSDCQBRDBDDBPQBbAmBjAAQCXAACAhUQCChWA8iSQBPjBhRjBQhRjCjDhPQhcglhjAAQiXAAh/BTg',
      );
    this.shape_3.setTransform(110.2, 110.2);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(
        [
          'rgba(0,0,0,0)',
          'rgba(147,152,157,0)',
          '#93989D',
          '#8C9297',
          '#BCBEC0',
          '#58595B',
        ],
        [0, 0.733, 0.733, 0.741, 0.749, 0.89],
        0,
        0,
        0,
        0,
        0,
        110.2,
      )
      .s()
      .p(
        'ACVROIhHg/IgUgVIg6hPIgjhCIgQgxIgDgaIAAgFIALifIjGguIg9CUIgGAMIgZAeIgvAqIg1AiIhGAhIh2AjIgWgLIgNgJIgRgRIgGhfIAKhpIAchdIAFgOIASgfIAQgWIADgDIB5hoIhsitIiXA/IgKACIgaAEIgpAAIhKgLIhFgWIgzgVIhSgvIgIgYIgDgPIAAgYIAqgyIA+g7IAUgQIBKgtIA6gYIAsgJIAJAAICeAKIAvjGIiUg8IgIgEIgagTIgdgdIgggrIgig6IgqhoIgPg+IALgXIAJgNIARgRIBBgFIBVADIBcAQIBNAeIAhAUIALAKIBoB5ICthrIg9iUIgBgBIgFgUIgDgfIACgtIAQhQIAlhiIAvhSIAYgIIAPgDIAYAAIAaAVIBTBTIA0BNIAJARIAYA6IAGAWIAEAfIgLCeIDGAvIA8iUIABgBIALgSIAdghIA1grIAmgXIBFghIB2gjIAWALIANAJIASASIAEBAIgEBvIgJAuIgXBHIgXAtIgOASIgCAEIgCACIgBABIh5BpIBrCsICTg9IACgBIADAAIAEgCIANgDIAtgDIAxAEIBVAVIAYAJIBpAzIAcASIAIAXIADAQIgBAYIg/BHIg8A1Ig5AkIg/AeIgrALIgRACIgEAAIiggLIguDGICUA9IAaAQIAaAYIArA2IAXAlIArBhIAZBbIgLAWIgJANIgSARIheAFIg4gDIhcgQIgygSIgOgFIgfgSIgWgQIgDgDIhph5IisBsIA9CTIAAACIADAGIADAOIADAsIgCAfIgQBQIgaBIIgMAaIgvBSIgXAIIgQADgAjEnSQjBBRhPDDQhQDBBSDCQBRDBDDBPQDBBPDBhRQDChRBPjDQBPjBhRjBQhRjCjDhPQhggnhfAAQhiAAhiApg',
      );
    this.shape_4.setTransform(110.2, 110.2);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        110.2,
      )
      .s()
      .p(
        'ACVROIhHg/IgUgVIg6hPIgjhCIgQgxIgDgaIAAgFIALifIjGguIg9CUIgGAMIgZAeIgvAqIg1AiIhGAhIh2AjIgWgLIgNgJIgRgRIgGhfIAKhpIAchdIAFgOIASgfIAQgWIADgDIB5hoIhsitIiXA/IgKACIgaAEIgpAAIhKgLIhFgWIgzgVIhSgvIgIgYIgDgPIAAgYIAqgyIA+g7IAUgQIBKgtIA6gYIAsgJIAJAAICeAKIAvjGIiUg8IgIgEIgagTIgdgdIgggrIgig6IgqhoIgPg+IALgXIAJgNIARgRIBBgFIBVADIBcAQIBNAeIAhAUIALAKIBoB5ICthrIg9iUIgBgBIgFgUIgDgfIACgtIAQhQIAlhiIAvhSIAYgIIAPgDIAYAAIAaAVIBTBTIA0BNIAJARIAYA6IAGAWIAEAfIgLCeIDGAvIA8iUIABgBIALgSIAdghIA1grIAmgXIBFghIB2gjIAWALIANAJIASASIAEBAIgEBvIgJAuIgXBHIgXAtIgOASIgCAEIgCACIgBABIh5BpIBrCsICTg9IACgBIADAAIAEgCIANgDIAtgDIAxAEIBVAVIAYAJIBpAzIAcASIAIAXIADAQIgBAYIg/BHIg8A1Ig5AkIg/AeIgrALIgRACIgEAAIiggLIguDGICUA9IAaAQIAaAYIArA2IAXAlIArBhIAZBbIgLAWIgJANIgSARIheAFIg4gDIhcgQIgygSIgOgFIgfgSIgWgQIgDgDIhph5IisBsIA9CTIAAACIADAGIADAOIADAsIgCAfIgQBQIgaBIIgMAaIgvBSIgXAIIgQADgAjEnSQjBBRhPDDQhQDBBSDCQBRDBDDBPQDBBPDBhRQDChRBPjDQBPjBhRjBQhRjCjDhPQhggnhfAAQhiAAhiApg',
      );
    this.shape_5.setTransform(110.2, 110.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#000066').s().p('A/KVfMAAAgq9MA+VAAAMAAAAq9g');
    this.shape_6.setTransform(117.525, 97.775);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-81.9, -39.7, 398.9, 275);

  (lib.gear01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#414042')
      .s()
      .p(
        'AioRPIgPgDIgXgHIgSgcIg0hqIgVhFIgLg5IgCggIACgjIACgRIACgKIACgEIA8iTIishqIhpB4IgBABIgWASIgtAYIhIAXIhHAMIhWADIhBgFIgRgRIgJgNIgLgWIAQg/IAnhoIAjg6IArg2IAJgKIAjgbIAGgEIACAAICTg+IgvjFIifALIgBABIgEgBIgKAAIgagFIhGgbIgRgJIhNg0Ig/g7IgpgxIgBgZIADgPIAIgXIBsg8IBdggIAVgEIBEgIIAtADIAUAFIABAAICUA9IBritIh5hpIgBAAIgCgDIgDgDIgIgKIgRgbIgSgpIgRg4IgMhHIgDg4IAFheIASgSIAMgJIAWgLIBcAZIBgAqIBEAtIAhAeIAUAYIAKAPIABADIAAABIA+CTIDGgvIgMifIADgfIAGgVIAPgqIAohHIANgUIA1g9IBHhAIAZAAIAPADIAXAIIAvBSIAnBiIANA9IAFAyIgCAkIgCAQIgCAKIgCAEIg8CTICsBrIBph5IACgDIAVgQIAtgYIBIgXIBHgMIBWgDIBAAFIASARIAJANIALAWIgZBcIgfBLIgiA6IggArIgdAdIgVAQIgLAHIgCAAIiTA+IAvDFICfgLIAJAAIANABIArAMIAuATIBKAuIA+A0IA/BHIAAAZIgDAPIgIAXIhSAwIgaAMIheAgIg5AKIgtACIgsgFIgFgCIgCAAIgBgBIiUg9IhqCtIB4BpIAGAGIANASIASAfIAYBBIAOBCIAGBRIgFBfIgSARIgMAJIgWALIh3giIhFghIgTgLIhIg3IgYgaIgQgWIgBgCIgBgCIg9iTIjGAvIANCfIAAAEIgEAbIgFAWIgQAqIgcAzIgMATIgvA8IhABAIgaAVgAjYJEIhECjIAAAAIgEARIAAAIIgCAhIACAeIAQBMIAYBFIApBOIAOAWIAPAFIAMACIAPAAIBThOIA6hMIAkhNIAJggIADgXIAAgDIgMivIDng3IBDCiIAAABIAPAVIAWAYIAjAeIA0AhIBDAfIBsAgIAPgHIAKgHIAKgLIAFhWIgBgcIgJhJIgJgpIgdhJIgTgdIgDgEIgFgFIiEhzIB8jKICjBDIAAABIAZAEIAvABIAzgGIA/gRIBIgeIBLgrIAFgPIACgMIgBgQIg5g/IhOhBIg0geIgPgHIgpgPIgbgHIgGgBIgMAAIivANIg3jnICihEIABAAIAEgDIAKgGIAWgTIAyg8IAgg4IAnhlIAOg2IgHgPIgHgJIgLgMIhygDIheANIhRAcIgdAQIgNAJIgDADIgDACIgBACIgBAAIhyCGIjLh9IBEijIAAAAIADgRIACgcIgBgrIgQhMIgYhFIgphOIgOgWIgPgFIgMgCIgPAAIhAA6Ig0A7IgZAlIglBNIgJAgIgCAXIAAADIAMCvIjmA3IhEiiIAAgBIgGgJIgJgLIgggiIg6grIgngVIhkgnIg3gOIgPAHIgKAHIgKAMIgFBVIAGBOIAOBAIAWA9IAVAkIAHAJIAFAFICEBzIh8DKIiihDIgBAAIgCgBIgDgBIgdgEIgmAAIhGALIhbAfIhkA2IgFAPIgCAMIABAQIA4A/IBPBBIBSArIANAFIAoALIAPABIADAAICvgMIA3DmIiiBEIgBAAIgEADIgRALIgYAXIgpAzIgWAkIgfBDIgaBTIgGAZIAHAPIAHAKIALALIA4AEIBUgDIBEgLIA2gQIAmgSIAZgPIAGgEIADgDIAFgEIByiFgAkeG6QiChVhAiPQgrhggChoQgDhnAlhjQAmhiBIhLQBHhMBggrQBnguBvAAQCcAACDBVQCDBVA/CPQArBgADBoQACBnglBjQgmBihHBMQhIBLhgArQhoAuhvAAQiaAAiEhVgAjNnOQjABWhLDEQhLDDBVC/QA+CMCBBRQB8BQCTAAQBrAABjgsQDAhWBLjEQBLjDhVi/Qg/iMiAhRQh9hQiTAAQhrAAhiAsg',
      );
    this.shape.setTransform(110.3, 110.275);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .rf(
        [
          'rgba(0,0,0,0)',
          'rgba(147,152,157,0)',
          '#93989D',
          '#8C9297',
          '#BCBEC0',
          '#58595B',
        ],
        [0, 0.733, 0.733, 0.741, 0.749, 0.89],
        0,
        0,
        0,
        0,
        0,
        110.3,
      )
      .s()
      .p(
        'AinRPIgQgDIgXgHIgSgcIg0hqIgWhFIgKg5IgBhDIAGgbIA+iXIiuhqIhnB4IgZATIgtAYIhHAXIhiAOIhbgBIgggDIgSgRIgJgNIgLgWIAYhcIAghLIAhg6IArg2IAKgKIAjgbIAHgEIABAAICTg+IgvjFIifALIgCABIgCgBIgKAAIg0gNIg+gcIg4gkIg/g1Ig/hHIAAgZIACgPIAIgXIBsg8IBfggIA5gKIAfgCIAtADIAVAFIABAAICTA9IBqitIh4hpIgBAAIgCgDIgDgDIgJgKIgQgbIgehNIgOhCIgGhRIAFheIARgSIANgJIAWgLIBbAZIBhAqIBDAtIAhAeIAVAYIAJAPIABADIACABIA8CTIDGgvIgMifIAAgEIACgSIAHgeIAZg7IAJgRIAkg5IA1g9IBGhAIAYAAIAQADIAXAIIASAcIA0BpIAQAvIAOA9IAEAyIgBAkIgGAaIg+CXICuBrIBnh5IAEgDIAVgQIAtgYIBHgXIBHgMIA4gDIBeAFIASARIAJANIALAWIgYBcIggBLIghA6IghArIgdAdIgVAQIgMAHIgBAAIiTA+IAvDFICfgLIAOAAIA0ANIAtATIA2AgIBRBCIBABHIAAAZIgCAPIgIAXIhSAwIgaAMIhfAgIg5AKIgtACIgtgFIgDgCIgEAAIgBgBIiTg9IhrCtIB5BpIAKAKIAKAOIARAfIAYBBIAOBCIAGBRIgFBfIgRARIgNAJIgWALIh2giIhGghIgUgLIg8gsIgkglIgOgWIgBgCIgCgCIg8iTIjGAvIALCfIAAAEIgJAxIgQAqIgbAzIg7BPIhBBAIgZAVgAjNnOQjABWhLDEQhLDDBVC/QBWDADDBLQDEBLC/hVQDAhWBLjEQBLjDhVi/QhWjAjDhLQhcgjhaAAQhnAAhmAtg',
      );
    this.shape_1.setTransform(110.3, 110.275);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        110.3,
      )
      .s()
      .p(
        'AioRPIgPgDIgXgHIgSgcIg0hqIgVhFIgLg5IgCggIACgjIACgRIACgKIACgEIA8iTIishqIhpB4IgXATIgtAYIhIAXIhiAOIhagBIgigDIgRgRIgJgNIgLgWIAZhcIAehLIAjg6IArg2IAJgKIAjgbIAGgEIACAAICTg+IgvjFIifALIgBABIgEgBIgKAAIgagFIgYgIIg/gcIg5gkIg9g1Ig/hHIgBgZIADgPIAIgXIBsg8IBdggIA6gKIAfgCIAtADIAUAFIABAAICUA9IBritIh5hpIgBAAIgCgDIgDgDIgIgKIgRgbIgehNIgOhCIgGhRIAFheIASgSIAMgJIAWgLIBcAZIBgAqIBEAtIAhAeIAUAYIAKAPIABADIAAABIA+CTIDGgvIgMifIAAgEIACgSIAHgeIAXg7IAJgRIAkg5IA1g9IBHhAIAZAAIAPADIAXAIIASAcIA0BpIAQAvIANA9IAFAyIgCAkIgCAQIgCAKIgCAEIg8CTICsBrIBph5IACgDIAVgQIAtgYIBIgXIBHgMIA4gDIBeAFIASARIAJANIALAWIgZBcIgfBLIgiA6IggArIgdAdIgVAQIgLAHIgCAAIiTA+IAvDFICfgLIAPAAIAaAFIAYAIIAuATIA2AgIBSBCIA/BHIAAAZIgDAPIgIAXIhSAwIgaAMIheAgIg5AKIgtACIgsgFIgFgCIgCAAIgBgBIiUg9IhqCtIB4BpIAKAKIAJAOIASAfIAYBBIAOBCIAGBRIgFBfIgSARIgMAJIgWALIh3giIhFghIgTgLIg9gsIgjglIgQgWIgBgCIgBgCIg9iTIjGAvIANCfIAAAEIgJAxIgQAqIgcAzIg7BPIhABAIgaAVgAjNnOQjABWhLDEQhLDDBVC/QBVDADFBLQDCBLDAhVQDAhWBLjEQBLjDhVi/QhVjAjFhLQhbgjhaAAQhnAAhmAtg',
      );
    this.shape_2.setTransform(110.3, 110.275);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#414042')
      .s()
      .p(
        'AioRPIgPgDIgXgHIgSgcIg0hqIgVhFIgLg5IAAhDIAEgbIA+iXIishqIhpB4IgBABIgWASIgtAYIhIAXIhHAMIhWADIhBgFIgRgRIgJgNIgLgWIAQg/IAnhoIAjg6IArg2IAJgKIAjgbIAGgEIACAAICTg+IgvjFIifALIgBABIgEgBIgKAAIgagFIhGgbIgRgJIhNg0Ig/g7IgpgxIgBgZIADgPIAIgXIBsg8IBdggIAVgEIBEgIIAtADIAUAFIABAAICUA9IBritIh5hpIgBAAIgCgDIgDgDIgIgKIgRgbIgSgpIgRg4IgMhHIgDg4IAFheIASgSIAMgJIAWgLIBcAZIBgAqIBEAtIAhAeIAUAYIAKAPIABADIAAABIA+CTIDGgvIgMifIADgfIAGgVIAPgqIAohHIANgUIA1g9IBHhAIAZAAIAPADIAXAIIAvBSIAnBiIANA9IAFAyIgCAkIgEAaIg+CXICsBrIBph5IACgDIAVgQIAtgYIBIgXIBHgMIBWgDIBAAFIASARIAJANIALAWIgZBcIgfBLIgiA6IggArIgdAdIgVAQIgLAHIgCAAIiTA+IAvDFICfgLIAJAAIANABIArAMIAuATIBKAuIA+A0IA/BHIAAAZIgDAPIgIAXIhSAwIgaAMIheAgIg5AKIgtACIgsgFIgFgCIgCAAIgBgBIiUg9IhqCtIB4BpIAGAGIANASIASAfIAYBBIAOBCIAGBRIgFBfIgSARIgMAJIgWALIh3giIhFghIgTgLIhIg3IgYgaIgQgWIgBgCIgBgCIg9iTIjGAvIANCfIAAAEIgJAxIgQAqIgcAzIgMATIgvA8IhABAIgaAVgAjYJEIhECjIAAAAIgEARIAAAIIAAA/IAQBMIAYBFIApBOIAOAWIAPAFIAMACIAPAAIBThOIA6hMIAkhNIAJggIADgXIAAgDIgMivIDng3IBDCiIAAABIAPAVIAWAYIAjAeIA0AhIBDAfIBsAgIAPgHIAKgHIAKgLIAFhWIgBgcIgJhJIgJgpIgdhJIgTgdIgDgEIgFgFIiEhzIB8jKICjBDIAAABIAZAEIAvABIAzgGIA/gRIBIgeIBLgrIAFgPIACgMIgBgQIg5g/IhOhBIg0geIgPgHIgpgPIgbgHIgGgBIgMAAIivANIg3jnICihEIABAAIAEgDIAKgGIAWgTIAyg8IAgg4IAnhlIAOg2IgHgPIgHgJIgLgMIhygDIheANIhRAcIgdAQIgNAJIgDADIgDACIgBACIgBAAIhyCGIjLh9IBEijIAAAAIADgRIACgcIgBgrIgQhMIgYhFIgphOIgOgWIgPgFIgMgCIgPAAIhAA6Ig0A7IgZAlIglBNIgJAgIgCAXIAAADIAMCvIjmA3IhEiiIAAgBIgGgJIgJgLIgggiIg6grIgngVIhkgnIg3gOIgPAHIgKAHIgKAMIgFBVIAGBOIAOBAIAWA9IAVAkIAHAJIAFAFICEBzIh8DKIiihDIgBAAIgCgBIgDgBIgdgEIgmAAIhGALIhbAfIhkA2IgFAPIgCAMIABAQIA4A/IBPBBIBSArIANAFIAoALIAPABIADAAICvgMIA3DmIiiBEIgBAAIgEADIgRALIgYAXIgpAzIgWAkIgfBDIgaBTIgGAZIAHAPIAHAKIALALIA4AEIBUgDIBEgLIA2gQIAmgSIAZgPIAGgEIAIgHIByiFgAkeG6QiChVhAiPQgrhggChoQgDhnAlhjQAmhiBIhLQBHhMBggrQBnguBvAAQCcAACDBVQCDBVA/CPQArBgADBoQACBnglBjQgmBihHBMQhIBLhgArQhoAuhvAAQiaAAiEhVgAjNnOQjABWhLDEQhLDDBVC/QA+CMCBBRQB8BQCTAAQBrAABjgsQDAhWBLjEQBLjDhVi/Qg/iMiAhRQh9hQiTAAQhrAAhiAsg',
      );
    this.shape_3.setTransform(110.3, 110.275);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        110.3,
      )
      .s()
      .p(
        'AioRPIgPgDIgXgHIgSgcIg0hqIgVhFIgLg5IAAhDIAEgbIA+iXIishqIhpB4IgXATIgtAYIhIAXIhiAOIhagBIgigDIgRgRIgJgNIgLgWIAZhcIAehLIAjg6IArg2IAJgKIAjgbIAGgEIACAAICTg+IgvjFIifALIgBABIgEgBIgKAAIgygNIg/gcIg5gkIg9g1Ig/hHIgBgZIADgPIAIgXIBsg8IBdggIA6gKIAfgCIAtADIAUAFIABAAICUA9IBritIh5hpIgBAAIgCgDIgDgDIgIgKIgRgbIgehNIgOhCIgGhRIAFheIASgSIAMgJIAWgLIBcAZIBgAqIBEAtIAhAeIAUAYIAKAPIABADIAAABIA+CTIDGgvIgMifIAAgEIACgSIAHgeIAXg7IAJgRIAkg5IA1g9IBHhAIAZAAIAPADIAXAIIASAcIA0BpIAQAvIANA9IAFAyIgCAkIgEAaIg+CXICsBrIBph5IACgDIAVgQIAtgYIBIgXIBHgMIA4gDIBeAFIASARIAJANIALAWIgZBcIgfBLIgiA6IggArIgdAdIgVAQIgLAHIgCAAIiTA+IAvDFICfgLIAPAAIAyANIAuATIA2AgIBSBCIA/BHIAAAZIgDAPIgIAXIhSAwIgaAMIheAgIg5AKIgtACIgsgFIgFgCIgCAAIgBgBIiUg9IhqCtIB4BpIAKAKIAJAOIASAfIAYBBIAOBCIAGBRIgFBfIgSARIgMAJIgWALIh3giIhFghIgTgLIg9gsIgjglIgQgWIgBgCIgBgCIg9iTIjGAvIANCfIAAAEIgJAxIgQAqIgcAzIg7BPIhABAIgaAVgAjNnOQjABWhLDEQhLDDBVC/QBVDADFBLQDCBLDAhVQDAhWBLjEQBLjDhVi/QhVjAjFhLQhbgjhaAAQhnAAhmAtg',
      );
    this.shape_4.setTransform(110.3, 110.275);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#000066').s().p('A/KVfMAAAgq9MA+VAAAMAAAAq9g');
    this.shape_5.setTransform(117.525, 97.775);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_4 },
              { t: this.shape_1 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_4 },
              { t: this.shape_1 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_1 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-81.9, -39.7, 398.9, 275);

  (lib.Scoreboard_progressMeter_fill = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(['#FFCC00', '#FF9933'], [0, 1], -100, -5, 100, -5)
      .s()
      .p('AvnCWIAAkrIfPAAIAAErg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter_fill,
    new cjs.Rectangle(0, -15, 200, 30),
    null,
  );

  (lib.Scoreboard_changeRoundBtn = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgTAnIgNgEIAAgVIACAAIAEADIAGADIAIADIAJABQADAAAFgCQADgBABgDQAAgBgBgBQAAAAAAgBQAAAAgBgBQAAAAAAgBIgHgCIgGgBIgIgCQgIgDgFgFQgFgFAAgJQAAgFADgFQACgEAEgEQAGgEAGgBQAHgDAHAAQAJAAAGADIALADIAAATIgCAAIgDgCIgGgDIgHgCIgHgBQgEAAgDACQgFACAAADQAAAAABABQAAAAAAABQAAAAABABQAAAAAAAAIAHAEIAIABIAHACQAJADADAEQAFAFAAAIQAAAGgDAFQgDAEgEAEQgFADgHACQgGACgIAAQgJAAgHgBg',
      );
    this.shape.setTransform(20.75, 10.65);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgdAsQgIgLAAgTQAAgKADgGQADgHAEgGQAEgFAGgDQAGgDAHAAQAFAAAEACIAJAEIAAghIAYAAIAABpIgYAAIAAgIIgFAEIgGAEIgEACIgHAAQgNAAgIgKgAgIgCQgEAFAAALQAAAMADAFQAEAFAHAAIAGgCIAGgDIAAglIgFgBIgFgBQgHAAgFAGg',
      );
    this.shape_1.setTransform(12.375, 9.275);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#3366CC')
      .s()
      .p(
        'AAMAnIAAglIgBgJQAAgFgBgCQgBgCgDgBIgFgBIgGABIgGADIAAA1IgYAAIAAhLIAYAAIAAAIQAGgFAFgCQAFgEAHAAQALAAAHAIQAGAHAAAPIAAAwg',
      );
    this.shape_2.setTransform(3.8, 10.55);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgdAhQgGgIAAgPIAAgwIAYAAIAAAmIAAAJQAAADACADQAAABABAAQAAABAAAAQABABAAAAQABAAAAAAIAGABIAFgBQAEgBADgCIAAg1IAYAAIAABLIgYAAIAAgIIgLAIQgFACgHAAQgLAAgHgGg',
      );
    this.shape_3.setTransform(-5.2, 10.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgcAeQgLgLAAgTQAAgSALgLQAKgLASAAQATAAAKALQALALAAASQAAATgLALQgKALgTAAQgSAAgKgLgAgFgWQgCABgDADQgCADgBAEQgBAFAAAGQAAAHABAEQABAFACACQACADADABIAFABIAGgBQADgBACgCIADgHQABgFAAgHQAAgGgBgEIgDgIIgFgEIgGgBIgFABg',
      );
    this.shape_4.setTransform(-13.975, 10.675);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgZAmIAAhLIAYAAIAAALIAEgEIAFgEIAGgCIAHgBIACAAIADAAIAAAWIgCAAIgEgBIgGAAIgIABIgHADIAAAyg',
      );
    this.shape_5.setTransform(-20.875, 10.65);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgaAeQgLgKAAgUQAAgRALgLQAKgLATAAQARgBAJAKQAJAKAAARIAAAIIgzAAQAAAFACAEQACADADACIAGAEIAJABIAIgBIAIgDIAFgDIAEgCIADAAIAAATIgFACIgHACIgIACIgKABQgVAAgMgLgAgJgUQgEAEAAAHIAcAAQgBgHgDgEQgDgFgHAAQgGABgEAEg',
      );
    this.shape_6.setTransform(21.225, -6.25);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgRA1IgMgCIAAgTIADAAIAEABIAFACIAGAAIAGABIAJgBIAGgDQACgDABgDIABgJIAAgBQgEAEgGACQgEACgFAAQgPAAgIgKQgJgKAAgTQAAgIADgHQACgIAFgFQAEgFAGgCQAGgDAHAAQAFAAAEABIAJAFIABgEIAXAAIAABDQAAALgDAIQgDAGgGAFQgFAEgIACQgHACgIAAIgPgBgAgIgdQgEAFAAAKIABAIIACAGQACACADABQACACAEAAIAGgBIAGgDIAAgiIgFgCIgFAAQgHAAgFAGg',
      );
    this.shape_7.setTransform(12.375, -4.9);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#3366CC')
      .s()
      .p(
        'AAMAnIAAgmIgBgIQAAgFgBgCQgBgCgDgBIgFgBIgGABIgGADIAAA1IgYAAIAAhLIAYAAIAAAIQAGgFAFgCQAFgDAHAAQALgBAHAIQAGAHAAAPIAAAwg',
      );
    this.shape_8.setTransform(3.8, -6.35);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgdAiQgGgHAAgKQAAgJAEgGQADgDAGgEQAHgDAIgBIATgCIAAAAQAAgHgFgCQgFgDgHAAIgLACIgLAEIgCAAIAAgTIAMgCIAQgBQATgBAIAHQAKAGAAAPIAAAyIgYAAIAAgIIgFAEIgEADIgGACIgIACQgKgBgIgGgAACADIgGADQgEABgBABQgCADAAAEQAAAFADACQADACAFAAIAGgBIAGgFIAAgQIgKABg',
      );
    this.shape_9.setTransform(-5.15, -6.25);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#3366CC')
      .s()
      .p(
        'AAMA1IAAgmIgBgJQABgFgCgBQgBgCgCgCIgHgBIgFABIgGAEIAAA1IgYAAIAAhpIAYAAIAAAmQAGgFAFgDQAFgDAHAAQALAAAHAIQAGAHAAANIAAAyg',
      );
    this.shape_10.setTransform(-13.55, -7.725);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#3366CC')
      .s()
      .p(
        'AgHAmQgIgCgGgFQgGgFgDgIQgDgHAAgLQAAgJADgJQAEgHAGgFQAFgFAJgCQAGgCAIAAIAOABQAFACAHADIAAAVIgDAAIgEgEIgEgCIgGgDIgHgBQgKAAgDAGQgFAHgBAJQAAAMAGAFQAEAGAJABIAIgBIAGgDIAEgDIADgDIADAAIAAAVIgEABIgGACIgHACIgIABQgJAAgHgDg',
      );
    this.shape_11.setTransform(-21.7, -6.25);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgTAnIgNgEIAAgVIACAAIAEADIAGADIAIADIAJABQADAAAFgCQADgBABgDQAAgBgBgBQAAAAAAgBQAAAAgBgBQAAAAAAgBIgHgCIgGgBIgIgCQgIgDgFgFQgFgFAAgJQAAgFADgFQACgEAEgEQAGgEAGgBQAHgDAHAAQAJAAAGADIALADIAAATIgCAAIgDgCIgGgDIgHgCIgHgBQgEAAgDACQgFACAAADQAAAAABABQAAAAAAABQAAAAABABQAAAAAAAAIAHAEIAIABIAHACQAJADADAEQAFAFAAAIQAAAGgDAFQgDAEgEAEQgFADgHACQgGACgIAAQgJAAgHgBg',
      );
    this.shape_12.setTransform(20.75, 10.65);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgdAsQgIgLAAgTQAAgKADgGQADgHAEgGQAEgFAGgDQAGgDAHAAQAFAAAEACIAJAEIAAghIAYAAIAABpIgYAAIAAgIIgFAEIgGAEIgEACIgHAAQgNAAgIgKgAgIgCQgEAFAAALQAAAMADAFQAEAFAHAAIAGgCIAGgDIAAglIgFgBIgFgBQgHAAgFAGg',
      );
    this.shape_13.setTransform(12.375, 9.275);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AAMAnIAAglIgBgJQAAgFgBgCQgBgCgDgBIgFgBIgGABIgGADIAAA1IgYAAIAAhLIAYAAIAAAIQAGgFAFgCQAFgEAHAAQALAAAHAIQAGAHAAAPIAAAwg',
      );
    this.shape_14.setTransform(3.8, 10.55);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgdAhQgGgIAAgPIAAgwIAYAAIAAAmIAAAJQAAADACADQAAABABAAQAAABAAAAQABABAAAAQABAAAAAAIAGABIAFgBQAEgBADgCIAAg1IAYAAIAABLIgYAAIAAgIIgLAIQgFACgHAAQgLAAgHgGg',
      );
    this.shape_15.setTransform(-5.2, 10.75);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgcAeQgLgLAAgTQAAgSALgLQAKgLASAAQATAAAKALQALALAAASQAAATgLALQgKALgTAAQgSAAgKgLgAgFgWQgCABgDADQgCADgBAEQgBAFAAAGQAAAHABAEQABAFACACQACADADABIAFABIAGgBQADgBACgCIADgHQABgFAAgHQAAgGgBgEIgDgIIgFgEIgGgBIgFABg',
      );
    this.shape_16.setTransform(-13.975, 10.675);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgZAmIAAhLIAYAAIAAALIAEgEIAFgEIAGgCIAHgBIACAAIADAAIAAAWIgCAAIgEgBIgGAAIgIABIgHADIAAAyg',
      );
    this.shape_17.setTransform(-20.875, 10.65);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgaAeQgLgKAAgUQAAgRALgLQAKgLATAAQARgBAJAKQAJAKAAARIAAAIIgzAAQAAAFACAEQACADADACIAGAEIAJABIAIgBIAIgDIAFgDIAEgCIADAAIAAATIgFACIgHACIgIACIgKABQgVAAgMgLgAgJgUQgEAEAAAHIAcAAQgBgHgDgEQgDgFgHAAQgGABgEAEg',
      );
    this.shape_18.setTransform(21.225, -6.25);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgRA1IgMgCIAAgTIADAAIAEABIAFACIAGAAIAGABIAJgBIAGgDQACgDABgDIABgJIAAgBQgEAEgGACQgEACgFAAQgPAAgIgKQgJgKAAgTQAAgIADgHQACgIAFgFQAEgFAGgCQAGgDAHAAQAFAAAEABIAJAFIABgEIAXAAIAABDQAAALgDAIQgDAGgGAFQgFAEgIACQgHACgIAAIgPgBgAgIgdQgEAFAAAKIABAIIACAGQACACADABQACACAEAAIAGgBIAGgDIAAgiIgFgCIgFAAQgHAAgFAGg',
      );
    this.shape_19.setTransform(12.375, -4.9);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AAMAnIAAgmIgBgIQAAgFgBgCQgBgCgDgBIgFgBIgGABIgGADIAAA1IgYAAIAAhLIAYAAIAAAIQAGgFAFgCQAFgDAHAAQALgBAHAIQAGAHAAAPIAAAwg',
      );
    this.shape_20.setTransform(3.8, -6.35);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgdAiQgGgHAAgKQAAgJAEgGQADgDAGgEQAHgDAIgBIATgCIAAAAQAAgHgFgCQgFgDgHAAIgLACIgLAEIgCAAIAAgTIAMgCIAQgBQATgBAIAHQAKAGAAAPIAAAyIgYAAIAAgIIgFAEIgEADIgGACIgIACQgKgBgIgGgAACADIgGADQgEABgBABQgCADAAAEQAAAFADACQADACAFAAIAGgBIAGgFIAAgQIgKABg',
      );
    this.shape_21.setTransform(-5.15, -6.25);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AAMA1IAAgmIgBgJQABgFgCgBQgBgCgCgCIgHgBIgFABIgGAEIAAA1IgYAAIAAhpIAYAAIAAAmQAGgFAFgDQAFgDAHAAQALAAAHAIQAGAHAAANIAAAyg',
      );
    this.shape_22.setTransform(-13.55, -7.725);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('rgba(51,102,204,0.706)')
      .s()
      .p(
        'AgHAmQgIgCgGgFQgGgFgDgIQgDgHAAgLQAAgJADgJQAEgHAGgFQAFgFAJgCQAGgCAIAAIAOABQAFACAHADIAAAVIgDAAIgEgEIgEgCIgGgDIgHgBQgKAAgDAGQgFAHgBAJQAAAMAGAFQAEAGAJABIAIgBIAGgDIAEgDIADgDIADAAIAAAVIgEABIgGACIgHACIgIABQgJAAgHgDg',
      );
    this.shape_23.setTransform(-21.7, -6.25);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_23 },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // Layer 2
    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#FFFFFF').s().p('AmPCWIAAkrIMfAAIAAErg');
    this.shape_24.setTransform(-0.4, 0.6);

    this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-40.4, -18.4, 80, 37.8);

  (lib.redX = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(204,0,51,0.498)')
      .ss(5, 0, 0, 3)
      .p('ACWCWIiWiWIiVCWAAAAAICWiVAiViVICVCV');
    this.shape.setTransform(0, 0.0029);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.5, -17.5, 35, 35);

  (lib.roundBtnshine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.2)'],
        [0, 1],
        0,
        22.5,
        0,
        -22.5,
      )
      .s()
      .p('AiuDhQgyAAAAgyIAAldQAAgyAyAAIFdAAQAyAAAAAyIAAFdQAAAygyAAg');

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-22.5, -22.5, 45, 45);

  (lib.roundBtnhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(255,255,255,0.498)')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape.setTransform(0, 0.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_1.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtnhover,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.Menuwatermark = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(255,204,0,0.098)')
      .s()
      .p(
        'AxFPVQl3h6jhi1Qoam+GYoRQCajIEdh8QEBhvFIgmQEvgjEpAjQEhAjDCBaQGAC0BoC4QBoC6iUDpQiEC0jwBTQjRBHj9gJQjjgKi5hDQi1hCgnhWQgdhDAehLQAmhcBwgfQBugfBLAkQA/AeAAArQAAAXgOAOQgLAMADANQDvBpCkhiQBDgmAhg/QAgg5gLg3QhQnYwIDCQkUAyikB9QiSBtgqCVQglCKA0CNQAxCHByBaQBiBQDEBaQECB1EiA/QM6C5MSkvQERhqCjh6QDLiYBwjkQDqngmUmyQh+iIiyh3IihhjQg/g+BTAdQKBFcCGHjQBGEBhKDIQhgEBjoDIQmKFSq/BqQlYAzk5AAQoPAAm+iQg',
      );
    this.shape.setTransform(-0.0116, 0.0317);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Menuwatermark,
    new cjs.Rectangle(-200, -112.5, 400, 225.1),
    null,
  );

  (lib.GameFrame_veil = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('Eg/RAvqMAAAhfTMB+jAAAMAAABfTg');
    this.shape.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameFrame_veil,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.EndScreenbuttonhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(255,255,255,0.498)')
      .ss(3, 1, 1)
      .p(
        'AqJjHIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAI0TAAQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonhover,
    new cjs.Rectangle(-86.5, -21.5, 173, 43),
    null,
  );

  (lib.EndScreenbuttonbg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.2)'],
        [0, 1],
        0,
        16,
        0.1,
        -16,
      )
      .s()
      .p(
        'AqJCWQg+AAgsgsQgsgsAAg+QAAg9AsgsQAsgsA+AAIUTAAQA+AAAsAsQAsAsAAA9QAAA+gsAsQgsAsg+AAg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#003399')
      .ss(3, 1, 1)
      .p(
        'AqJjHIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAI0TAAQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAg',
      );

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#3366CC')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonbg,
    new cjs.Rectangle(-86.5, -21.5, 173, 43),
    null,
  );

  (lib.divisionTile38 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('81÷9', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile37 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('72÷8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile36 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('64÷8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile35 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('63÷7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile34 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('56÷7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile33 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('49÷7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile32 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('54÷6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile31 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('48÷6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile30 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('42÷6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile29 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('36÷6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile28 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('45÷5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile27 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('40÷5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile26 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('35÷5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile25 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('30÷5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile24 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('25÷5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile23 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('36÷4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.divisionTile22 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('32÷4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile21 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('28÷4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile20 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('24÷4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile19 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('20÷4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile18 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('16÷4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile17 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('27÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile16 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('24÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('21÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('18÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('15÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('12÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('3', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('9÷3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile09 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('18÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile08 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('16÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile07 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('14÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile06 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('12÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile05 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('10÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('8÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('3', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('6÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.divisionTile02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('2', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.lineWidth = 11;
    this.text.parent = this;
    this.text.setTransform(-0.05, -5);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4÷2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCFF')
      .s()
      .p(
        'AjkE3QgiAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAiAAIHIAAQAiAAAZAZQAZAZgBAhIAAHJQABAigZAZQgZAXgiAAg',
      );
    this.shape_1.setTransform(0, 0.1);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 62.8);

  (lib.arrowShape02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#F3ADAB')
      .s()
      .p(
        'EgYBAofQnOnOj+pXQkGpuAAqnQAAqlEGpuQD+pYHOnNQHOnOJXj+QJtkHKnAAQG8AAGsB0IB9kTIK3POIynBzIB2kDQkvhHk8AAQolAAnzDPQn1DQmEGEQmEGEjPH0QjPH0AAIkQAAIlDPH0QDPH1GEGEQFUFTGrDKIjUIyQokj4mvmvg',
      );
    this.shape.setTransform(0.025, -15.475);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.arrowShape02,
    new cjs.Rectangle(-251.6, -342.5, 503.29999999999995, 654.1),
    null,
  );

  (lib.arrowShape01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#86C8D7')
      .s()
      .p(
        'APWfGICaDwQGOmBDWn7QDYn9AAosQABohjPnyQjOnymCmCQmDmDnxjOQnxjOojAAQmKAAl4BuQl4BvlKDVIlGn4QGUkEHLiHQHLiHHgAAQKlAAJqEFQJXD+HKHLQHNHND8JVQEGJqAAKkQAALFkfKFQkfKDoMHZICiD+IyrA5g',
      );
    this.shape.setTransform(256.45, 305.425);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.arrowShape01,
    new cjs.Rectangle(0, 0, 512.9, 610.9),
    null,
  );

  (lib.arr4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#86C8D7')
      .s()
      .p(
        'Ai7EdQiYgjibgSQgtgFgtgDQhagIhagBIgqAAIhOABIAApXIBOgBIAqAAQBaABBaAGQAtADAtAEQEcAbESBKIB9kTIK4PNIymB0g',
      );
    this.shape.setTransform(38.5, 11.475);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-50, -43, 177, 109);

  (lib.arr3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#F3ADAB')
      .s()
      .p('AiBEdQkvhGk9AAQhhAAhgAGIAApYQBggFBhAAQG9AAGqBzIB9kTIK4PNIymB0g');
    this.shape.setTransform(44.275, 11.475);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-50, -43, 188.6, 109);

  (lib.additionTile16 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('10', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('5+5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('10', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4+6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4+5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('4+4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('10', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3+7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3+6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile10 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3+5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile09 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3+4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile08 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('3+3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile07 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('10', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+8', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile06 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('9', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+7', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.lineWidth = 37;
    this.text_1.parent = this;
    this.text_1.setTransform(1.7, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile05 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('8', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+6', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('7', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+5', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('6', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+4', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('5', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+3', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.additionTile01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // answer
    this.text = new cjs.Text('4', "bold 24px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 38;
    this.text.parent = this;
    this.text.setTransform(0, -3.05);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(2));

    // problem
    this.text_1 = new cjs.Text('2+2', "bold 24px 'Open Sans Condensed'");
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 38;
    this.text_1.parent = this;
    this.text_1.setTransform(0, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.text_1).wait(2));

    // tile solved
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CEEAB9')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHHAAQAjAAAYAZQAZAZAAAhIAAHJQAAAigZAZQgYAXgjAAg',
      );
    this.shape.setTransform(-0.025, 0);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(1).to({ _off: false }, 0).wait(1),
    );

    // tile unsolved
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#86C8D7')
      .s()
      .p(
        'AjjE3QgjAAgYgXQgZgZAAgiIAAnJQAAghAZgZQAYgZAjAAIHIAAQAiAAAZAZQAXAZAAAhIAAHJQAAAigXAZQgZAXgiAAg',
      );

    this.timeline.addTween(
      cjs.Tween.get(this.shape_1).to({ _off: true }, 1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-31.2, -31.1, 62.4, 64.7);

  (lib.ValueTextBlack_fields = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // line
    this.line = new lib.ValueTextBlack_line();
    this.line.name = 'line';
    this.line.alpha = 0;

    this.timeline.addTween(cjs.Tween.get(this.line).wait(1));

    // denominator
    this.denominator = new cjs.Text(
      '1',
      "bold 16px 'Open Sans Condensed'",
      '#262626',
    );
    this.denominator.name = 'denominator';
    this.denominator.textAlign = 'center';
    this.denominator.lineHeight = 23;
    this.denominator.lineWidth = 24;
    this.denominator.alpha = 0.0;
    this.denominator.parent = this;
    this.denominator.setTransform(-0.3, -4.6);

    this.timeline.addTween(cjs.Tween.get(this.denominator).wait(1));

    // numerator
    this.numerator = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.numerator.name = 'numerator';
    this.numerator.textAlign = 'center';
    this.numerator.lineHeight = 23;
    this.numerator.lineWidth = 24;
    this.numerator.alpha = 0.00392157;
    this.numerator.parent = this;
    this.numerator.setTransform(-0.3, -23.35);

    this.timeline.addTween(cjs.Tween.get(this.numerator).wait(1));

    // extraTinyText
    this.extraTinyText = new cjs.Text('1', "bold 15px 'Open Sans Condensed'");
    this.extraTinyText.name = 'extraTinyText';
    this.extraTinyText.textAlign = 'center';
    this.extraTinyText.lineHeight = 22;
    this.extraTinyText.lineWidth = 62;
    this.extraTinyText.parent = this;
    this.extraTinyText.setTransform(1.5, -11.9);

    this.timeline.addTween(cjs.Tween.get(this.extraTinyText).wait(1));

    // tinyText
    this.tinyText = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.tinyText.name = 'tinyText';
    this.tinyText.textAlign = 'center';
    this.tinyText.lineHeight = 29;
    this.tinyText.lineWidth = 61;
    this.tinyText.parent = this;
    this.tinyText.setTransform(1.5, -15.2);

    this.timeline.addTween(cjs.Tween.get(this.tinyText).wait(1));

    // smallText
    this.smallText = new cjs.Text('1', "bold 24px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 35;
    this.smallText.lineWidth = 63;
    this.smallText.parent = this;
    this.smallText.setTransform(1.8, -18.7);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    // largeText
    this.largeText = new cjs.Text('1', "bold 30px 'Open Sans Condensed'");
    this.largeText.name = 'largeText';
    this.largeText.textAlign = 'center';
    this.largeText.lineHeight = 43;
    this.largeText.lineWidth = 62;
    this.largeText.parent = this;
    this.largeText.setTransform(1.4, -23.05);

    this.timeline.addTween(cjs.Tween.get(this.largeText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueTextBlack_fields,
    new cjs.Rectangle(-31.7, -25.3, 67, 50),
    null,
  );

  (lib.subtractionGrid = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // tiles
    this.s15 = new lib.subtractionTile16();
    this.s15.name = 's15';
    this.s15.setTransform(201.25, 201.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s14 = new lib.subtractionTile15();
    this.s14.name = 's14';
    this.s14.setTransform(134.1, 201.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s13 = new lib.subtractionTile14();
    this.s13.name = 's13';
    this.s13.setTransform(67.05, 201.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s12 = new lib.subtractionTile13();
    this.s12.name = 's12';
    this.s12.setTransform(0, 201.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s11 = new lib.subtractionTile12();
    this.s11.name = 's11';
    this.s11.setTransform(201.25, 134.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.s10 = new lib.subtractionTile11();
    this.s10.name = 's10';
    this.s10.setTransform(134.1, 134.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.s9 = new lib.subtractionTile10();
    this.s9.name = 's9';
    this.s9.setTransform(67.05, 134.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.s8 = new lib.subtractionTile09();
    this.s8.name = 's8';
    this.s8.setTransform(0, 134.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.s7 = new lib.subtractionTile08();
    this.s7.name = 's7';
    this.s7.setTransform(201.25, 67.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s6 = new lib.subtractionTile07();
    this.s6.name = 's6';
    this.s6.setTransform(134.1, 67.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s5 = new lib.subtractionTile06();
    this.s5.name = 's5';
    this.s5.setTransform(67.05, 67.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s4 = new lib.subtractionTile05();
    this.s4.name = 's4';
    this.s4.setTransform(0, 67.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.s3 = new lib.subtractionTile04();
    this.s3.name = 's3';
    this.s3.setTransform(201.25, -0.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.s2 = new lib.subtractionTile03();
    this.s2.name = 's2';
    this.s2.setTransform(134.1, -0.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.s1 = new lib.subtractionTile02();
    this.s1.name = 's1';
    this.s1.setTransform(67.05, -0.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.s0 = new lib.subtractionTile01();
    this.s0.name = 's0';
    this.s0.setTransform(0, -0.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.s0 },
            { t: this.s1 },
            { t: this.s2 },
            { t: this.s3 },
            { t: this.s4 },
            { t: this.s5 },
            { t: this.s6 },
            { t: this.s7 },
            { t: this.s8 },
            { t: this.s9 },
            { t: this.s10 },
            { t: this.s11 },
            { t: this.s12 },
            { t: this.s13 },
            { t: this.s14 },
            { t: this.s15 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.subtractionGrid,
    new cjs.Rectangle(-31.1, -31.3, 263.5, 265.9),
    null,
  );

  (lib.comsuntexsymbolsPositiveFeedback = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.text = new lib.PostitiveFeedback_text();
    this.text.name = 'text';
    this.text.setTransform(0.7, 0.45);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

    // bg
    this.bg = new lib.PostivieFeedback_bg();
    this.bg.name = 'bg';
    this.bg.setTransform(-4, 0.45);

    this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        ['#FFFFFF', 'rgba(255,255,255,0)'],
        [0.749, 1],
        -0.1,
        -0.1,
        0,
        -0.1,
        -0.1,
        47.4,
      )
      .s()
      .p(
        'AvCFUQmPiMAAjIQAAjGGPiOQGPiNIzAAQI0AAGOCNQGPCOABDGQgBDImPCMQmOCOo0AAQozAAmPiOg',
      );
    this.shape.setTransform(-0.2, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsPositiveFeedback,
    new cjs.Rectangle(-136.3, -48.2, 272.3, 96.4),
    null,
  );

  (lib.multiplicationGrid = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // tiles
    this.a35 = new lib.multiiplicatonTile37();
    this.a35.name = 'a35';
    this.a35.setTransform(239, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a34 = new lib.multiiplicatonTile36();
    this.a34.name = 'a34';
    this.a34.setTransform(192, 223.65, 0.7223, 0.719, 0, 0, 0, 0, 0.3);

    this.a33 = new lib.multiiplicatonTile35();
    this.a33.name = 'a33';
    this.a33.setTransform(145, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a32 = new lib.multiiplicatonTile34();
    this.a32.name = 'a32';
    this.a32.setTransform(98, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a31 = new lib.multiiplicatonTile33();
    this.a31.name = 'a31';
    this.a31.setTransform(51, 223.6, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a30 = new lib.multiiplicatonTile32();
    this.a30.name = 'a30';
    this.a30.setTransform(4, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a29 = new lib.multiiplicatonTile31();
    this.a29.name = 'a29';
    this.a29.setTransform(239, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a28 = new lib.multiiplicatonTile30();
    this.a28.name = 'a28';
    this.a28.setTransform(192, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a27 = new lib.multiiplicatonTile29();
    this.a27.name = 'a27';
    this.a27.setTransform(145, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a26 = new lib.multiiplicatonTile28();
    this.a26.name = 'a26';
    this.a26.setTransform(98, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a21 = new lib.multiiplicatonTile23();
    this.a21.name = 'a21';
    this.a21.setTransform(145, 130.9, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a20 = new lib.multiiplicatonTile22();
    this.a20.name = 'a20';
    this.a20.setTransform(98, 130.9, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a19 = new lib.multiiplicatonTile21();
    this.a19.name = 'a19';
    this.a19.setTransform(51, 130.9, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a18 = new lib.multiiplicatonTile20();
    this.a18.name = 'a18';
    this.a18.setTransform(4, 130.75, 0.7223, 0.7221);

    this.a25 = new lib.multiiplicatonTile27();
    this.a25.name = 'a25';
    this.a25.setTransform(51, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a24 = new lib.multiiplicatonTile26();
    this.a24.name = 'a24';
    this.a24.setTransform(4, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a23 = new lib.multiiplicatonTile25();
    this.a23.name = 'a23';
    this.a23.setTransform(239, 130.95, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a22 = new lib.multiiplicatonTile24();
    this.a22.name = 'a22';
    this.a22.setTransform(192, 130.95, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a17 = new lib.multiiplicatonTile19();
    this.a17.name = 'a17';
    this.a17.setTransform(239, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a16 = new lib.multiiplicatonTile18();
    this.a16.name = 'a16';
    this.a16.setTransform(192, 84.65, 0.7223, 0.719, 0, 0, 0, 0, 0.3);

    this.a15 = new lib.multiiplicatonTile17();
    this.a15.name = 'a15';
    this.a15.setTransform(145, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a14 = new lib.multiiplicatonTile15();
    this.a14.name = 'a14';
    this.a14.setTransform(98, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a13 = new lib.multiiplicatonTile14();
    this.a13.name = 'a13';
    this.a13.setTransform(51, 84.6, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a12 = new lib.multiiplicatonTile13();
    this.a12.name = 'a12';
    this.a12.setTransform(4, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a11 = new lib.multiiplicatonTile12();
    this.a11.name = 'a11';
    this.a11.setTransform(239, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a10 = new lib.multiiplicatonTile11();
    this.a10.name = 'a10';
    this.a10.setTransform(192, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a9 = new lib.multiiplicatonTile10();
    this.a9.name = 'a9';
    this.a9.setTransform(145, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a8 = new lib.multiiplicatonTile09();
    this.a8.name = 'a8';
    this.a8.setTransform(98, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a3 = new lib.multiiplicatonTile04();
    this.a3.name = 'a3';
    this.a3.setTransform(145, -8.1, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a2 = new lib.multiiplicatonTile03();
    this.a2.name = 'a2';
    this.a2.setTransform(98, -8.1, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a1 = new lib.multiiplicatonTile02();
    this.a1.name = 'a1';
    this.a1.setTransform(51, -8.1, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.a0 = new lib.multiiplicatonTile01();
    this.a0.name = 'a0';
    this.a0.setTransform(4, -8.25, 0.7223, 0.7221);

    this.a7 = new lib.multiiplicatonTile08();
    this.a7.name = 'a7';
    this.a7.setTransform(51, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a6 = new lib.multiiplicatonTile07();
    this.a6.name = 'a6';
    this.a6.setTransform(4, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a5 = new lib.multiiplicatonTile06();
    this.a5.name = 'a5';
    this.a5.setTransform(239, -8.05, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.a4 = new lib.multiiplicatonTile05();
    this.a4.name = 'a4';
    this.a4.setTransform(192, -8.05, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.a4 },
            { t: this.a5 },
            { t: this.a6 },
            { t: this.a7 },
            { t: this.a0 },
            { t: this.a1 },
            { t: this.a2 },
            { t: this.a3 },
            { t: this.a8 },
            { t: this.a9 },
            { t: this.a10 },
            { t: this.a11 },
            { t: this.a12 },
            { t: this.a13 },
            { t: this.a14 },
            { t: this.a15 },
            { t: this.a16 },
            { t: this.a17 },
            { t: this.a22 },
            { t: this.a23 },
            { t: this.a24 },
            { t: this.a25 },
            { t: this.a18 },
            { t: this.a19 },
            { t: this.a20 },
            { t: this.a21 },
            { t: this.a26 },
            { t: this.a27 },
            { t: this.a28 },
            { t: this.a29 },
            { t: this.a30 },
            { t: this.a31 },
            { t: this.a32 },
            { t: this.a33 },
            { t: this.a34 },
            { t: this.a35 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.multiplicationGrid,
    new cjs.Rectangle(-18.5, -30.7, 280, 306.09999999999997),
    null,
  );

  (lib.Congratulations = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#003399')
      .s()
      .p('AgPA6IAAgUIAfAAIAAAUgAgMAZIgDhSIAfAAIgDBSg');
    this.shape.setTransform(579.075, 426.375);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#003399')
      .s()
      .p(
        'AgfAjQgOgMAAgWQAAgVANgNQANgMAWAAQAWAAALALQAKAKAAAUIAAAJIg/AAQABAKAHAGQAHAFANABQAJAAAIgEQAJgDAFgDIADAAIAAAWQgKAEgIACQgJABgKAAQgZABgOgMgAgLgYQgFAEgBAKIAjAAQAAgJgEgFQgEgEgJAAQgHAAgFAEg',
      );
    this.shape_1.setTransform(570.525, 427.8);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#003399')
      .s()
      .p(
        'AAsAtIAAgsIgBgKQAAgEgBgDQgCgDgDgBQgCgBgGgBIgHACIgIAEIAAA9IgbAAIAAgsIAAgJIgCgIQgBgDgDgBQgDgBgFgBQgEAAgEACIgHAEIAAA9IgdAAIAAhXIAdAAIAAAKQAHgGAHgDQAGgDAIAAQAJAAAFAEQAHADAEAIQAIgHAIgEQAIgEAIAAQAOAAAHAJQAIAIAAAQIAAA4g',
      );
    this.shape_2.setTransform(556.725, 427.7);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#003399')
      .s()
      .p(
        'AgjAmQgIgHAAgMQAAgKAEgGQAFgFAHgEQAJgDALgCIAXgCIAAAAQAAgIgGgCQgGgDgKAAQgIAAgHACIgLAEIgDAAIAAgVIAPgDIATgBQAYAAAKAHQALAHAAAQIAAA7IgcAAIAAgKIgFAFIgHADIgHADIgKABQgNAAgJgIgAAEAEIgJACQgEABgDADQgCACAAAEIABAFIABADQACACADAAIAHABQAEAAAEgCQAEgBAEgDIAAgSIgMABg',
      );
    this.shape_3.setTransform(542.6, 427.825);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#003399')
      .s()
      .p(
        'AgUA9IgPgDIAAgWIADAAIANADIANACIAMgBQAEgCADgDIAEgGIABgJIAAgCQgFAEgHADQgGADgGgBQgTAAgKgLQgKgLAAgWQAAgKADgJQADgHAGgGQAFgFAIgDQAHgEAIAAQAGABAGABQAGACAEADIACgEIAbAAIAABMQAAANgEAIQgDAJgHAFQgGAEgJADQgJACgKAAIgSgBgAgKgiQgGAHAAALQAAANAFADQAFAFAIABIAIgBIAIgEIAAgnIgGgBIgHgBQgKAAgFAGg',
      );
    this.shape_4.setTransform(531.625, 429.35);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#003399')
      .s()
      .p(
        'AgfAjQgOgMAAgWQAAgVANgNQANgMAWAAQAWAAALALQAKAKAAAUIAAAJIg/AAQABAKAHAGQAHAFANABQAJAAAIgEQAJgDAFgDIADAAIAAAWQgKAEgIACQgJABgKAAQgZABgOgMgAgLgYQgFAEgBAKIAjAAQAAgJgEgFQgEgEgJAAQgHAAgFAEg',
      );
    this.shape_5.setTransform(515.575, 427.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#003399')
      .s()
      .p(
        'AAQA9IAAgsIgBgKIgBgHQgCgDgDgBQgEgCgFAAIgHACQgEABgEADIAAA9IgcAAIAAh5IAcAAIAAAsQAHgGAIgDQAFgDAJAAQAOAAAIAIQAIAIAAAQIAAA5g',
      );
    this.shape_6.setTransform(504.6, 426.125);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#003399')
      .s()
      .p(
        'AgNAzQgHgHgBgQIAAgoIgLAAIAAgTIALAAIAAgZIAbAAIAAAZIAbAAIAAATIgbAAIAAAeIAAAIIACAGQABADADACQADABAFAAIAGgBIAEgBIADAAIAAATIgKACIgMAAQgPAAgJgGg',
      );
    this.shape_7.setTransform(495.2, 426.625);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#003399')
      .s()
      .p(
        'AgjAxQgKgMAAgVQAAgLADgIQAEgIAFgGQAGgGAHgDQAIgEAHAAQAHABAFABIALAFIAAgmIAcAAIAAB4IgcAAIAAgJQgIAGgGADQgFADgJAAQgPAAgKgNgAgKgCQgGAFAAANQAAANAFAFQAEAHAJgBIAIgBIAIgDIAAgrIgHgBIgGgBQgKAAgFAHg',
      );
    this.shape_8.setTransform(480.175, 426.25);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#003399')
      .s()
      .p(
        'AgfAjQgOgMAAgWQAAgVANgNQANgMAWAAQAWAAALALQAKAKAAAUIAAAJIg/AAQABAKAHAGQAHAFANABQAJAAAIgEQAJgDAFgDIADAAIAAAWQgKAEgIACQgJABgKAAQgZABgOgMgAgLgYQgFAEgBAKIAjAAQAAgJgEgFQgEgEgJAAQgHAAgFAEg',
      );
    this.shape_9.setTransform(469.575, 427.8);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#003399')
      .s()
      .p(
        'AAQA9IAAgsIgBgKIgBgHQgDgDgCgBQgEgCgFAAIgHACQgEABgEADIAAA9IgcAAIAAh5IAcAAIAAAsQAHgGAIgDQAFgDAJAAQAOAAAIAIQAIAIAAAQIAAA5g',
      );
    this.shape_10.setTransform(458.6, 426.125);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#003399')
      .s()
      .p(
        'AgZAsQgKgCgFgDIAAgXIACAAIAGADIAHAEIAKADIAMABQAHAAAEgBQAFgCAAgEQgBgDgCgBIgJgDIgHgCIgKgCQgMgDgGgGQgFgGgBgKQAAgNAMgIQANgIATAAQAKAAAJACIAOAEIAAAWIgDAAQgGgEgHgDQgJgDgIAAQgFAAgFACQgFACAAAEQAAAAAAABQAAABABAAQAAABAAAAQABABAAAAIAJAEIAKABIAKACQAKADAFAFQAGAHAAAJQAAAOgMAIQgMAIgVAAQgLAAgKgCg',
      );
    this.shape_11.setTransform(448.2, 427.825);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#003399')
      .s()
      .p('AgNA9IAAhXIAbAAIAABXgAgOgmIAAgWIAdAAIAAAWg');
    this.shape_12.setTransform(440.65, 426.125);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#003399')
      .s()
      .p(
        'AAPAtIAAgrIAAgKIgBgIQgCgDgDgBQgEgBgFgBIgHACQgEABgEADIAAA9IgcAAIAAhXIAcAAIAAAKQAIgGAGgDQAHgDAIAAQAOAAAIAIQAIAJAAAQIAAA4g',
      );
    this.shape_13.setTransform(432.25, 427.7);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#003399')
      .s()
      .p('AgNA9IAAhXIAbAAIAABXgAgOgmIAAgWIAdAAIAAAWg');
    this.shape_14.setTransform(423.8, 426.125);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#003399')
      .s()
      .p(
        'AgUA9IAAhDIgMAAIAAgTIAMAAIAAgDQAAgQAIgIQAJgIAQAAIALAAIAJABIAAAUIgCAAIgFgBIgGgBQgIAAgDADQgDADAAAJIAAABIAWAAIAAATIgVAAIAABDg',
      );
    this.shape_15.setTransform(417.975, 426.075);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#003399')
      .s()
      .p(
        'AgjAlQgIgJAAgQIAAg4IAdAAIAAArIAAALQAAAEACACQABAEADABIAIABIAHgBIAJgEIAAg9IAcAAIAABWIgcAAIAAgJQgIAGgGADQgGADgIAAQgPAAgIgIg',
      );
    this.shape_16.setTransform(403.1, 427.95);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#003399')
      .s()
      .p(
        'AgiAjQgNgNAAgWQAAgVANgMQANgMAVAAQAXAAAMAMQANAMAAAVQAAAWgNANQgNAMgWgBQgWABgMgMgAgGgZIgGAEQgDADgBAGQgCAFAAAIQAAAGACAGQABAFADADQACADAEACQADABADAAIAHgBQAEgCACgDIAEgIQACgFAAgHQAAgIgCgFQgBgFgDgDQgCgDgEgBQgDgCgEAAIgGABg',
      );
    this.shape_17.setTransform(391.95, 427.8);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#003399')
      .s()
      .p('AgNA6IAAgrIgshIIAiAAIAYAtIAYgtIAhAAIgqBGIAAAtg');
    this.shape_18.setTransform(380.525, 426.375);

    this.btn = new lib.congratulations_button();
    this.btn.name = 'btn';
    this.btn.setTransform(478, 486.2);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#003399')
      .s()
      .p('AgXBXIAAgfIAuAAIAAAfgAgTAlIgEh7IAvAAIgFB7g');
    this.shape_19.setTransform(586, 398.325);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#003399')
      .s()
      .p(
        'AgmBCQgOgDgJgEIAAgjIAEAAIAIAFIALAGIAPAEQAJACAJAAQALAAAGgCQAGgDAAgGQAAgEgDgDQgEgCgJgCIgMgCIgPgDQgSgFgIgJQgJgKAAgOQAAgTASgNQASgMAeAAQAPAAANADQAOACAIAEIAAAhIgEAAQgJgGgMgEQgMgEgNAAQgJAAgHACQgHADAAAFQAAAFADADQADACALACIAOADIAPADQARAEAIAJQAIAJAAAOQAAAUgTANQgSAMgfAAQgRAAgPgDg',
      );
    this.shape_20.setTransform(574.175, 400.475);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#003399')
      .s()
      .p(
        'AAYBEIAAhCIgBgOQgBgIgCgFQgCgEgFgBQgEgCgIAAIgLABIgNAGIAABdIgqAAIAAiDIAqAAIAAAPQALgKALgEQAJgFANABQAVgBAMAMQAMANAAAZIAABVg',
      );
    this.shape_21.setTransform(558.4, 400.3);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#003399')
      .s()
      .p(
        'Ag0AzQgTgTAAggQAAggATgSQATgTAhAAQAjAAASATQATATAAAfQAAAggTATQgTATgiAAQghAAgTgTgAgKgmQgFACgEAFQgEAEgCAIQgCAIAAALQAAALACAIQABAIAEAFQAEAEAFACQAGACAFAAQAGAAAGgBQAEgCAEgFQAEgFADgHQABgHAAgNQAAgKgCgIQgCgIgEgFQgEgFgEgCQgGgCgGAAQgFAAgFACg',
      );
    this.shape_22.setTransform(541.55, 400.475);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#003399')
      .s()
      .p('AgUBbIAAiCIApAAIAACCgAgVg6IAAggIArAAIAAAgg');
    this.shape_23.setTransform(529.225, 397.925);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#003399')
      .s()
      .p(
        'AgTBMQgMgKAAgYIAAg9IgSAAIAAgcIASAAIAAgmIApAAIAAAmIAnAAIAAAcIgnAAIAAAuIAAAMQABAFABAEQACAEAEADQAEACAIAAIAIgBIAIgDIADAAIAAAdIgOADIgSABQgYAAgMgKg',
      );
    this.shape_24.setTransform(519.6, 398.725);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#003399')
      .s()
      .p(
        'Ag0A6QgNgMAAgSQAAgOAHgKQAGgHAMgFQAMgGARgCQAQgDATAAIAAgBQAAgLgJgEQgJgFgQAAQgKABgMAEIgRAFIgEAAIAAggIAWgEQAPgCAPgBQAjAAAQAMQAQALAAAXIAABZIgqAAIAAgOIgJAGIgJAGQgGADgGABQgHACgIAAQgSAAgNgMgAAFAGIgOADQgGACgDAEQgEADAAAHIABAGIADAGIAHADIALABQAGAAAGgDQAHgCAFgFIAAgbIgTACg',
      );
    this.shape_25.setTransform(505.675, 400.45);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics.f('#003399').s().p('AgUBbIAAi1IApAAIAAC1g');
    this.shape_26.setTransform(494, 397.925);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#003399')
      .s()
      .p(
        'Ag2A3QgLgNAAgYIAAhUIAqAAIAABBIABAQQAAAGADAEQACAEAFADQAEACAIAAQAFAAAGgCQAGgDAHgEIAAhbIAqAAIAACCIgqAAIAAgOQgMAIgJAFQgKAFgNAAQgVAAgNgNg',
      );
    this.shape_27.setTransform(481.3, 400.65);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#003399')
      .s()
      .p(
        'AgTBMQgMgKAAgYIAAg9IgSAAIAAgcIASAAIAAgmIApAAIAAAmIAnAAIAAAcIgnAAIAAAuIABAMQgBAFACAEQACAEAEADQAEACAIAAIAIgBIAIgDIADAAIAAAdIgOADIgSABQgYAAgMgKg',
      );
    this.shape_28.setTransform(467.3, 398.725);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#003399')
      .s()
      .p(
        'Ag0A6QgNgMAAgSQAAgOAHgKQAGgHAMgFQAMgGARgCQAQgDATAAIAAgBQAAgLgJgEQgJgFgQAAQgKABgMAEIgRAFIgEAAIAAggIAWgEQAPgCAPgBQAjAAAQAMQAQALAAAXIAABZIgqAAIAAgOIgJAGIgJAGQgGADgGABQgHACgIAAQgSAAgNgMgAAFAGIgOADQgGACgDAEQgEADAAAHIABAGIADAGIAHADIALABQAGAAAGgDQAHgCAFgFIAAgbIgTACg',
      );
    this.shape_29.setTransform(453.375, 400.45);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#003399')
      .s()
      .p(
        'AgvBCIAAiCIAqAAIAAATQANgMALgEQAKgEAJAAIAFAAIAFABIAAAnIgEAAIgJgBIgKAAQgJgBgHACQgHABgHADIAABXg',
      );
    this.shape_30.setTransform(440.625, 400.45);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#003399')
      .s()
      .p(
        'AgfBbIgXgEIAAghIAGAAIASAFQAMADAIAAQALAAAHgCQAIgCADgEQAEgEACgGQABgGAAgIIAAgDQgHAHgKADQgJAEgKAAQgcAAgPgRQgPgQAAghQAAgRAFgMQAEgLAJgJQAHgIAMgFQALgEAMAAQAJAAAJACQAJADAHAEIACgGIApAAIAAB0QAAASgGANQgFAMgJAIQgKAHgNADQgOADgQAAQgNAAgOgBgAgQgzQgIAJAAASQAAATAHAGQAHAIANAAQAGAAAGgCQAGgCAFgEIAAg6IgJgDIgJgBQgQAAgIAKg',
      );
    this.shape_31.setTransform(424.975, 402.775);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#003399')
      .s()
      .p(
        'AAYBEIAAhCIgBgOQgBgIgCgFQgCgEgFgBQgEgCgIAAIgLABIgNAGIAABdIgqAAIAAiDIAqAAIAAAPQALgKALgEQAJgFANABQAVgBAMAMQAMANAAAZIAABVg',
      );
    this.shape_32.setTransform(408.55, 400.3);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#003399')
      .s()
      .p(
        'Ag0AzQgTgTAAggQAAggATgSQATgTAhAAQAjAAASATQATATAAAfQAAAggTATQgTATgiAAQghAAgTgTgAgKgmQgFACgEAFQgEAEgCAIQgCAIAAALQAAALACAIQABAIAEAFQAEAEAFACQAGACAFAAQAGAAAGgBQAEgCAEgFQAEgFADgHQABgHAAgNQAAgKgCgIQgCgIgDgFQgFgFgEgCQgGgCgGAAQgFAAgFACg',
      );
    this.shape_33.setTransform(391.7, 400.475);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#003399')
      .s()
      .p(
        'AgVBVQgRgGgLgLQgMgMgHgRQgGgRgBgWQABgUAGgQQAGgRAMgMQALgMARgGQARgHATAAQALAAAIACIARADIAPAFIALAFIAAAqIgGAAIgIgGIgMgIQgGgEgHgCQgIgDgIAAQgKAAgIADQgIADgHAHQgHAHgEALQgFALAAAOQAAARAFALQAFALAGAGQAIAGAIADQAJADAIAAQAIAAAIgDQAIgCAHgEIAKgHIAIgHIAGAAIAAAqIgNAFIgNAFIgQADQgHACgOAAQgSAAgQgGg',
      );
    this.shape_34.setTransform(374.85, 398.325);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.btn },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f()
      .s('#003399')
      .ss(3, 1, 1)
      .p(
        'A1KvOMAqVAAAQB8AABYBYQBYBYAAB8IAAVFQAAB8hYBYQhYBYh8AAMgqVAAAQh8AAhYhYQhYhYAAh8IAA1FQAAh8BYhYQBYhYB8AAg',
      );
    this.shape_35.setTransform(480.475, 447.475);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'A1KPPQh8AAhYhYQhYhYAAh8IAA1FQAAh8BYhYQBYhYB8AAMAqVAAAQB8AABYBYQBYBYAAB8IAAVFQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_36.setTransform(480.475, 447.475);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_36 }, { t: this.shape_35 }] })
        .wait(1),
    );

    // Layer 1
    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('rgba(255,255,255,0.698)')
      .s()
      .p('EhK/BLAMAAAiV/MCV/AAAMAAACV/g');
    this.shape_37.setTransform(480, 480);

    this.timeline.addTween(cjs.Tween.get(this.shape_37).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Congratulations,
    new cjs.Rectangle(0, 0, 960, 960),
    null,
  );

  (lib.gfxgear03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gear
    this.instance = new lib.gear03();
    this.instance.setTransform(0, 0.05, 1, 1, 0, 0, 0, 104.7, 104.7);
    new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.gear03(), 3);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-104.7, -104.6, 209.4, 209.3);

  (lib.gfxgear02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gear
    this.instance = new lib.gear02();
    this.instance.setTransform(0, 0, 1, 1, 0, 0, 0, 110.2, 110.2);
    new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.gear02(), 3);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-110.2, -110.2, 220.4, 220.4);

  (lib.gfxgear01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gear
    this.instance = new lib.gear01();
    this.instance.setTransform(0, -0.05, 1, 1, 0, 0, 0, 110.3, 110.2);
    new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.gear01(), 3);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-110.3, -110.2, 220.6, 220.5);

  (lib.Scoreboard_progressMeter = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // outline
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#003366').ss(2, 1, 1).p('AvniVIfPAAIAAErI/PAAg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // fill
    this.progressMeterFill = new lib.Scoreboard_progressMeter_fill();
    this.progressMeterFill.name = 'progressMeterFill';
    this.progressMeterFill.setTransform(100, 0, 1, 1, 0, 0, 0, 100, 0);

    this.timeline.addTween(cjs.Tween.get(this.progressMeterFill).wait(1));

    // Layer 2
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#003366')
      .ss(2, 1, 1)
      .p('AvniVIfPAAIAAErI/PAAg');
    this.shape_1.setTransform(100, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(0,51,102,0.047)')
      .s()
      .p('AvnCWIAAkrIfPAAIAAErg');
    this.shape_2.setTransform(100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter,
    new cjs.Rectangle(-1, -16, 202, 32),
    null,
  );

  (lib.Scoreboard_muteBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape.setTransform(11.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape_1.setTransform(11.05, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [] }, 2)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // Layer_1
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#333333')
      .s()
      .p('AgNAzIAAhlIBehOIAAEBgAhQAuIAAhbIAyAAIAABbg');
    this.shape_2.setTransform(-8.225, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#CCCCCC')
      .s()
      .p('AgNAzIAAhlIBehOIAAEBgAhQAuIAAhbIAyAAIAABbg');
    this.shape_3.setTransform(-8.225, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }] }, 2)
        .wait(2),
    );

    // Layer_4
    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_4.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.Scoreboard_musicBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_7
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AieAZQAAgbAfgWIAMAFIgEADQgWARAAAYQAAAbAaATIgMAEQgfgWAAgcgAB0AUQAagSAAgaQAAgYgWgSIgEgEIAMgEQAfAWAAAcQAAAbgfAWg',
      );
    this.shape.setTransform(-0.475, 7.5);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(3).to({ _off: false }, 0).wait(1),
    );

    // Layer_5
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#333333')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_1.setTransform(-1.05, -1.45);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_2.setTransform(-1.05, -1.45);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }] })
        .to({ state: [{ t: this.shape_2 }] }, 2)
        .wait(2),
    );

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.ProgressPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.correctTxt = new cjs.Text('', "20px 'Tahoma'", '#003366');
    this.correctTxt.name = 'correctTxt';
    this.correctTxt.lineHeight = 26;
    this.correctTxt.lineWidth = 28;
    this.correctTxt.parent = this;
    this.correctTxt.setTransform(270.15, -11.4, 1, 1.0024);

    this.correctLbl = new cjs.Text('Correct:', "bold 15px 'Tahoma'", '#003366');
    this.correctLbl.name = 'correctLbl';
    this.correctLbl.lineHeight = 20;
    this.correctLbl.lineWidth = 64;
    this.correctLbl.parent = this;
    this.correctLbl.setTransform(204.9, -8.55, 1.0021, 0.9976);

    this.bonusTxt = new cjs.Text('', "bold 20px 'Tahoma'", '#003366');
    this.bonusTxt.name = 'bonusTxt';
    this.bonusTxt.lineHeight = 26;
    this.bonusTxt.lineWidth = 69;
    this.bonusTxt.parent = this;
    this.bonusTxt.setTransform(477.6, -12.3, 1, 1.0024);

    this.roundTxt = new cjs.Text('', "bold 20px 'Tahoma'", '#003366');
    this.roundTxt.name = 'roundTxt';
    this.roundTxt.lineHeight = 26;
    this.roundTxt.lineWidth = 29;
    this.roundTxt.parent = this;
    this.roundTxt.setTransform(62.55, -12.3, 1, 1.0024);

    this.gameTxt = new cjs.Text('', "20px 'Tahoma'", '#003366');
    this.gameTxt.name = 'gameTxt';
    this.gameTxt.lineHeight = 26;
    this.gameTxt.lineWidth = 28;
    this.gameTxt.parent = this;
    this.gameTxt.setTransform(148.25, -12.3, 1, 1.0024);

    this.progressMeterMc = new lib.Scoreboard_progressMeter();
    this.progressMeterMc.name = 'progressMeterMc';
    this.progressMeterMc.setTransform(290.15, -0.7, 1, 1, 0, 0, 0, 100, -0.5);

    this.bonusLbl = new cjs.Text(
      'Bonus \nStickers:  ',
      "bold 12px 'Tahoma'",
      '#003366',
    );
    this.bonusLbl.name = 'bonusLbl';
    this.bonusLbl.textAlign = 'center';
    this.bonusLbl.lineHeight = 13;
    this.bonusLbl.lineWidth = 96;
    this.bonusLbl.parent = this;
    this.bonusLbl.setTransform(443.95, -13.45, 1.0014, 0.9976);

    this.gameLbl = new cjs.Text('Game:  ', "bold 15px 'Tahoma'", '#003366');
    this.gameLbl.name = 'gameLbl';
    this.gameLbl.lineHeight = 20;
    this.gameLbl.lineWidth = 75;
    this.gameLbl.parent = this;
    this.gameLbl.setTransform(92, -7.45, 1.0021, 0.9976);

    this.roundLbl = new cjs.Text('Round:  ', "bold 15px 'Tahoma'", '#003366');
    this.roundLbl.name = 'roundLbl';
    this.roundLbl.lineHeight = 20;
    this.roundLbl.lineWidth = 79;
    this.roundLbl.parent = this;
    this.roundLbl.setTransform(2, -7.45, 1.0021, 0.9976);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.roundLbl },
            { t: this.gameLbl },
            { t: this.bonusLbl },
            { t: this.progressMeterMc },
            { t: this.gameTxt },
            { t: this.roundTxt },
            { t: this.bonusTxt },
            { t: this.correctLbl },
            { t: this.correctTxt },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ProgressPanel,
    new cjs.Rectangle(0, -16.2, 548.1, 32),
    null,
  );

  (lib.roundBtn4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAjCSIgVAAIAAgwIAAgUIh3AAIgUAAIAAg3ICHioIBMAAIAAAUIAACWIAVAAIATAAIAAAUIAAAhIgoAAIAABEgAhFAZIAkAAIAvAAIAAg8IAAgtg',
      );
    this.shape.setTransform(-0.15, -0.5);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AAPCSIAAgUIAzAAIAAhEIAoAAIAAghIAUAAIAAA1IgnAAIAABEgAh9BOIAAgUIB4AAIAAAUgABCAFIAAiWIAVAAIAACWgAhZAFIBUhpIAAAtIgwA8g',
      );
    this.shape_1.setTransform(1.85, 1.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#FF0000', '#990000'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn4,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhICQQgagGgQgHIAMADQAaAFAkAAQAgAAAVgGQAWgHARgMQAQgNAJgSQAIgRAAgVQAAgSgGgLQgGgLgJgHIgKgHQAJABAKAEQAMAEAJAHQAJAIAGALQAGALAAASQAAAVgIARQgJASgQANQgRAMgWAHQgWAGgfAAQgkAAgagFgAArgOQgLgEgKgBIAAgDQAZgFAPgTQAPgUAAgYQAAgSgIgOQgIgNgQgKIgFgDIABAAQAVAFANAIQAQAKAIANQAIAOAAASQAAAYgPAUQgPATgZAFIAAACIgJgEgAhqhHIAAgWIATgGQAWgHASAAIASABQAKACAIADIAHAFIgNgBQgSAAgWAHQgVAGgUAMg',
      );
    this.shape.setTransform(2.825, 0.6875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AgnAgIgRgHIAAgBIAHAAQAKAGANAFIgNgDgAA0gYIgZAAIgQAAIAAgKIALAAQANAAAKADQAHACAFAFIgFAAg',
      );
    this.shape_1.setTransform(-2.9375, 4.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhICSIgMgDQgSgFgMgFIAAhAIAIAAQAKAGAMAFIASAHIAMADQAQAFAPAAQALAAAMgCQANgCAKgGQAHgGAEgHQAEgGAAgOQAAgMgFgHIgEgDQgFgFgHgCQgJgDgNAAIgLAAIgOAAIgQAAIAAgzIARAAIAbgBQAKgBAJgEQAIgEAEgGQAFgGAAgMQAAgJgFgFIgEgEIgHgEQgIgEgKgCIgRAAQgSAAgWAGIgTAGQgLAFgLAHIgIAAIAAg/QARgGAbgHQAcgFAcAAQAaAAAVAEQARAEAMAGIAFADQAQAKAIANQAIAOAAATQAAAXgPAUQgPATgZAFIAAADQAKABALAEIAJADIACABIAKAHQAJAJAGALQAGAKAAATQAAAUgIASQgJARgQANQgRANgWAGQgWAGgfAAQgkABgagGg',
      );
    this.shape_2.setTransform(-0.175, -0.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // Layer 4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_4.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn3,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhxCLIAAgUIDPAAIAAgkIAUAAIAAA4gAgjA/IAZgUQARgNASgQQAcgaAOgZQAOgZAAgbQAAgdgNgUIAEAEQAdAXAAAqQAAAcgOAYQgOAYgcAaQgRARgSANgAhphKIAAgcQALgGAMgFQATgHASAAQAYgBANALQAHAGACAIQgKgFgQAAQgSABgTAHQgUAIgRALg',
      );
    this.shape.setTransform(2.625, 2.15);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhdCUIgUAAIAAgwQAagTAagVQAbgVAPgQQAXgXAKgQQAKgRAAgQQAAgKgDgHQgDgIgHgGQgMgLgYAAQgSAAgTAIQgMAEgLAGIgOAJIgGAAIAAhBQANgGAcgGQAagGAcAAQA1AAAdAXQAJAHAHAJQANAUAAAdQAAAbgOAZQgOAYgcAaQgSARgSANIgYAUIAtAAIBUAAIAAAUIAAAjg',
      );
    this.shape_1.setTransform(0.625, -0.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#1BB448', '#265945'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn2,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhgCSIAAgUICtAAIAAgfIAUAAIAAAzgAARBLIAAjcIAUAAIAADcgAhgg6IAAgUIApAAIAAAUg',
      );
    this.shape.setTransform(1.5, 1.425);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhMCSIgUAAIAAgzIA9AAIAAiFIAAgUIgpAAIgUAAIAAgvQAOAAANgCQANgCAJgEQAJgFAFgHQAGgIABgMIA/AAIAAAUIAADcIAUAAIAoAAIAAAUIAAAfg',
      );
    this.shape_1.setTransform(-0.5, -0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn1,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.nextBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgbBTIgSgDIAAgfIAEAAIAGADIAIACIAJACIAJABQAJAAAGgCQAHgCADgEQADgEABgFQABgFAAgIIAAgCQgGAGgIADQgHAEgJAAQgYAAgMgQQgNgPAAgeQAAgOAEgMQAEgLAGgIQAIgHAJgFQAJgEAKAAQAJAAAHADIANAGIACgFIAkAAIAABpQAAARgFAMQgFAMgIAGQgJAHgLADQgMADgNAAQgMAAgLgCgAgNgvQgGAJAAAQIABANQABAFACAEQADAEAEACQAEACAGAAQAGAAAEgCIAJgFIAAg1IgGgDIgIAAQgNAAgHAIg',
      );
    this.shape.setTransform(63.95, 3.475);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AASA+IAAg8IAAgOQgBgGgBgEQgCgEgEgCQgEgCgGAAIgIACQgFABgFAEIAABVIglAAIAAh4IAlAAIAAAOQAJgIAJgFQAHgEALAAQATAAAJALQAKAMAAAWIAABOg',
      );
    this.shape_1.setTransform(50.45, 1.2);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AgSBTIAAh3IAlAAIAAB3gAgTg1IAAgdIAnAAIAAAdg');
    this.shape_2.setTransform(40.025, -0.95);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AglBTIATgwIgth1IAoAAIAYBMIAYhMIAnAAIg9Clg');
    this.shape_3.setTransform(30.375, 3.6);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtA1QgLgLAAgQQAAgNAGgJQAFgHAKgFQALgFANgCIAegDIAAgBQAAgJgHgEQgIgEgOAAQgGAAgJADIgRAFIgEAAIAAgdIASgDQANgCAMgBQAfAAAOALQAPAKAAAVIAABRIgmAAIAAgMIgHAFIgIAFIgJAEIgOACQgPAAgLgLgAAEAFIgLADQgFACgDAEQgDADAAAGQAAAIAFADQAFAEAIAAQAEAAAGgDQAFgCAEgEIAAgZIgPABg',
      );
    this.shape_4.setTransform(17.1, 1.35);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#FFFFFF').s().p('AgSBTIAAilIAlAAIAAClg');
    this.shape_5.setTransform(7.575, -0.95);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag6BUIAAikIAlAAIAAANQAJgHAIgFQAIgEALAAQAVAAAMAQQALARAAAdQAAAcgPARQgOASgWAAQgIAAgGgCQgHgCgIgEIAAAygAgLg0IgKAEIAAA8IAHACIAJABQAMAAAHgJQAGgIABgSQAAgSgGgIQgFgIgLAAIgKACg',
      );
    this.shape_6.setTransform(-2.25, 3.425);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag6BUIAAikIAmAAIAAANQAIgHAIgFQAIgEALAAQAVAAALAQQAMARAAAdQAAAcgOARQgPASgVAAQgJAAgHgCQgGgCgHgEIAAAygAgKg0IgKAEIAAA8IAGACIAIABQAOAAAGgJQAGgIAAgSQAAgSgEgIQgGgIgKAAIgKACg',
      );
    this.shape_7.setTransform(-22.55, 3.425);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgpAwQgSgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQABAIACAGQAEAFAFAEQAEADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgTgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgKAAgGAGg',
      );
    this.shape_8.setTransform(-36.4, 1.325);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgpAwQgSgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQABAIACAGQAEAFAFAEQAEADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgTgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgKAAgGAGg',
      );
    this.shape_9.setTransform(-49.45, 1.325);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p('AAWBQIgrhBIgIALIAAA2IgoAAIAAifIAoAAIAABHIAzhHIAuAAIg5BKIA7BVg');
    this.shape_10.setTransform(-62.65, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.nextBtn,
    new cjs.Rectangle(-86.5, -21.5, 173, 43),
    null,
  );

  (lib.moreBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgpAwQgSgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQABAIADAGQADAFAFAEQAEADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgMACIgRABQggAAgTgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgJAAgHAGg',
      );
    this.shape.setTransform(25.7, 1.325);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AA1A+IAAg8IgBgPQAAgFgBgFQgCgDgDgCQgDgCgHAAQgEAAgEACIgKAFIAABVIgkAAIAAg8IgBgOIgBgLQgCgDgEgCQgDgCgGAAQgFABgEACIgJAEIAABVIglAAIAAh4IAlAAIAAAOQAKgIAIgFQAIgEAKAAQAMAAAGAGQAJAEAFALQALgKAJgFQAJgGAKAAQAJAAAHACQAGADAFAGQAFAFACAJQADAHAAANIAABOg',
      );
    this.shape_1.setTransform(8.7, 1.2);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtAvQgQgRAAgeQAAgdAQgRQARgRAcAAQAeAAAQARQAQARAAAdQAAAegQARQgQARgeAAQgcAAgRgRgAgIgjQgEACgEAEQgDAFgCAHQgCAHAAAKQAAALACAHIAFALQADAEAEACQAFACAEAAQAFAAAFgCQAEgCADgEQADgEACgHQACgGAAgMQAAgKgCgHQgCgHgDgEQgDgFgEgBQgEgCgGAAQgEAAgEABg',
      );
    this.shape_2.setTransform(-8.675, 1.375);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AAcBQIAAhHIg3AAIAABHIgoAAIAAifIAoAAIAAA6IA3AAIAAg6IAnAAIAACfg');
    this.shape_3.setTransform(-23.85, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.moreBtn,
    new cjs.Rectangle(-86.5, -21.5, 173, 43),
    null,
  );

  (lib.continueBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('Ag1BQIAAifIBqAAIAAAeIhBAAIAAAfIA9AAIAAAdIg9AAIAABFg');
    this.shape.setTransform(66.3, -0.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p('AgqBQIAAgcIAXAAIAAhnIgXAAIAAgcIBVAAIAAAcIgXAAIAABnIAXAAIAAAcg');
    this.shape_1.setTransform(53.975, -0.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AgUBQIg3ifIAqAAIAiBrIAihrIApAAIg3Cfg');
    this.shape_2.setTransform(41.225, -0.6);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgoAwQgTgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQAAAIADAGQAEAFAEAEQAFADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgSgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgJAAgHAGg',
      );
    this.shape_3.setTransform(20.85, 1.325);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AguAyQgJgLgBgWIAAhOIAmAAIAAA7IABAPQAAAGACAEQACAEADACQAEABAGAAQAEAAAFgBIAKgGIAAhUIAmAAIAAB3IgmAAIAAgNQgKAJgIADQgIAFgLAAQgRAAgLgMg',
      );
    this.shape_4.setTransform(7.2, 1.55);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AASA+IAAg8IAAgOQgBgGgBgEQgCgEgEgCQgEgCgGAAIgIACQgEABgGAEIAABVIglAAIAAh4IAlAAIAAAOQAJgIAJgFQAHgEALAAQATAAAJALQALAMgBAWIAABOg',
      );
    this.shape_5.setTransform(-6.8, 1.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p('AgSBTIAAh3IAlAAIAAB3gAgTg1IAAgdIAnAAIAAAdg');
    this.shape_6.setTransform(-17.225, -0.95);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgTBFQgKgJAAgWIAAg3IgOAAIAAgaIAOAAIAAgjIAkAAIAAAjIAlAAIAAAaIglAAIAAAqIABALQAAAEABAEQACAEAEACQAEACAHAAIAIgBIAHgCIADAAIAAAaIgNADIgRABQgWAAgLgKg',
      );
    this.shape_7.setTransform(-25.05, -0.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AATA+IAAg8IgBgOQgBgGgBgEQgCgEgEgCQgEgCgFAAIgJACQgEABgGAEIAABVIgmAAIAAh4IAmAAIAAAOQAJgIAJgFQAIgEALAAQASAAAKALQAKAMgBAWIAABOg',
      );
    this.shape_8.setTransform(-36.7, 1.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtAvQgQgRAAgeQAAgdAQgRQARgRAcAAQAeAAAQARQAQARAAAdQAAAegQARQgQARgeAAQgcAAgRgRgAgIgjQgEACgEAEQgDAFgCAHQgCAHAAAKQAAALACAHIAFALQADAEAEACQAFACAEAAQAFAAAFgCQAEgCADgEQADgEACgHQACgGAAgMQAAgKgCgHQgCgHgDgEQgDgFgEgBQgEgCgGAAQgEAAgEABg',
      );
    this.shape_9.setTransform(-50.625, 1.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgsA+QgVgXAAgnQAAglAVgXQAVgWAjAAIARABIAPADIAMAFIAKAEIAAAmIgEAAIgHgFIgKgIQgGgEgGgCQgHgCgIAAQgIAAgIACQgFADgHAHQgGAGgEAKQgEALAAAOQAAAOAEALQAEAJAHAHQAGAGAGACQAIADAIAAQAHAAAIgDQAHgCAFgDIAJgHIAHgGIAEAAIAAAmIgKAEIgMAFIgOADIgSABQgjAAgVgVg',
      );
    this.shape_10.setTransform(-64.75, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.continueBtn,
    new cjs.Rectangle(-86.5, -21.5, 173, 43),
    null,
  );

  (lib.EndScreen = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.stickersText = new cjs.Text(
      'Congratulations!',
      "bold 32px 'Tahoma'",
      '#003399',
    );
    this.stickersText.name = 'stickersText';
    this.stickersText.textAlign = 'center';
    this.stickersText.lineHeight = 45;
    this.stickersText.lineWidth = 498;
    this.stickersText.parent = this;
    this.stickersText.setTransform(396.95, 319.5);

    this.beforeScoreText = new cjs.Text(
      'You scored',
      "bold 30px 'Tahoma'",
      '#003399',
    );
    this.beforeScoreText.name = 'beforeScoreText';
    this.beforeScoreText.textAlign = 'center';
    this.beforeScoreText.lineHeight = 42;
    this.beforeScoreText.lineWidth = 451;
    this.beforeScoreText.parent = this;
    this.beforeScoreText.setTransform(401.5, 121.35);

    this.pointsText = new cjs.Text('0', "bold 60px 'Tahoma'", '#003399');
    this.pointsText.name = 'pointsText';
    this.pointsText.textAlign = 'center';
    this.pointsText.lineHeight = 78;
    this.pointsText.lineWidth = 196;
    this.pointsText.parent = this;
    this.pointsText.setTransform(400.95, 144.8);

    this.afterScoreText = new cjs.Text(
      'points',
      "bold 30px 'Tahoma'",
      '#003399',
    );
    this.afterScoreText.name = 'afterScoreText';
    this.afterScoreText.textAlign = 'center';
    this.afterScoreText.lineHeight = 42;
    this.afterScoreText.lineWidth = 488;
    this.afterScoreText.parent = this;
    this.afterScoreText.setTransform(401.95, 203.7);

    this.messageText = new cjs.Text(
      'Congratulations!',
      "bold 40px 'Tahoma'",
      '#003399',
    );
    this.messageText.name = 'messageText';
    this.messageText.textAlign = 'center';
    this.messageText.lineHeight = 54;
    this.messageText.lineWidth = 498;
    this.messageText.parent = this;
    this.messageText.setTransform(396.95, 243.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.messageText },
            { t: this.afterScoreText },
            { t: this.pointsText },
            { t: this.beforeScoreText },
            { t: this.stickersText },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.continueBtn = new lib.continueBtn();
    this.continueBtn.name = 'continueBtn';
    this.continueBtn.setTransform(424.95, 401);

    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(586.1, 401, 0.7647, 1);

    this.nextBtn = new lib.nextBtn();
    this.nextBtn.name = 'nextBtn';
    this.nextBtn.setTransform(242.05, 401);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.nextBtn },
            { t: this.moreBtn },
            { t: this.continueBtn },
          ],
        })
        .wait(1),
    );

    // swirl
    this.watermark = new lib.Menuwatermark();
    this.watermark.name = 'watermark';
    this.watermark.setTransform(399.95, 259.95);

    this.timeline.addTween(cjs.Tween.get(this.watermark).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 275);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreen,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.DivisionGrid = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // tiles
    this.s35 = new lib.divisionTile38();
    this.s35.name = 's35';
    this.s35.setTransform(239, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s34 = new lib.divisionTile37();
    this.s34.name = 's34';
    this.s34.setTransform(192, 223.65, 0.7223, 0.719, 0, 0, 0, 0, 0.3);

    this.s33 = new lib.divisionTile36();
    this.s33.name = 's33';
    this.s33.setTransform(145, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s32 = new lib.divisionTile35();
    this.s32.name = 's32';
    this.s32.setTransform(98, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s31 = new lib.divisionTile34();
    this.s31.name = 's31';
    this.s31.setTransform(51, 223.6, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s30 = new lib.divisionTile33();
    this.s30.name = 's30';
    this.s30.setTransform(4, 223.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s29 = new lib.divisionTile32();
    this.s29.name = 's29';
    this.s29.setTransform(239, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s28 = new lib.divisionTile31();
    this.s28.name = 's28';
    this.s28.setTransform(192, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s27 = new lib.divisionTile30();
    this.s27.name = 's27';
    this.s27.setTransform(145, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s26 = new lib.divisionTile29();
    this.s26.name = 's26';
    this.s26.setTransform(98, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s21 = new lib.divisionTile24();
    this.s21.name = 's21';
    this.s21.setTransform(145, 130.9, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s20 = new lib.divisionTile23();
    this.s20.name = 's20';
    this.s20.setTransform(98, 130.9, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s19 = new lib.divisionTile22();
    this.s19.name = 's19';
    this.s19.setTransform(51, 130.9, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s18 = new lib.divisionTile21();
    this.s18.name = 's18';
    this.s18.setTransform(4, 130.75, 0.7223, 0.7221);

    this.s25 = new lib.divisionTile28();
    this.s25.name = 's25';
    this.s25.setTransform(51, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s24 = new lib.divisionTile27();
    this.s24.name = 's24';
    this.s24.setTransform(4, 177.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s23 = new lib.divisionTile26();
    this.s23.name = 's23';
    this.s23.setTransform(239, 130.95, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s22 = new lib.divisionTile25();
    this.s22.name = 's22';
    this.s22.setTransform(192, 130.95, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s17 = new lib.divisionTile20();
    this.s17.name = 's17';
    this.s17.setTransform(239, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s16 = new lib.divisionTile19();
    this.s16.name = 's16';
    this.s16.setTransform(192, 84.65, 0.7223, 0.719, 0, 0, 0, 0, 0.3);

    this.s15 = new lib.divisionTile18();
    this.s15.name = 's15';
    this.s15.setTransform(145, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s14 = new lib.divisionTile17();
    this.s14.name = 's14';
    this.s14.setTransform(98, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s13 = new lib.divisionTile16();
    this.s13.name = 's13';
    this.s13.setTransform(51, 84.6, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s12 = new lib.divisionTile15();
    this.s12.name = 's12';
    this.s12.setTransform(4, 84.65, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s11 = new lib.divisionTile14();
    this.s11.name = 's11';
    this.s11.setTransform(239, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s10 = new lib.divisionTile13();
    this.s10.name = 's10';
    this.s10.setTransform(192, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s9 = new lib.divisionTile12();
    this.s9.name = 's9';
    this.s9.setTransform(145, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s8 = new lib.divisionTile11();
    this.s8.name = 's8';
    this.s8.setTransform(98, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s3 = new lib.divisionTile05();
    this.s3.name = 's3';
    this.s3.setTransform(145, -8.1, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s2 = new lib.divisionTile04();
    this.s2.name = 's2';
    this.s2.setTransform(98, -8.1, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s1 = new lib.divisionTile03();
    this.s1.name = 's1';
    this.s1.setTransform(51, -8.1, 0.7223, 0.7221, 0, 0, 0, 0, 0.2);

    this.s0 = new lib.divisionTile02();
    this.s0.name = 's0';
    this.s0.setTransform(4, -8.25, 0.7223, 0.7221);

    this.s7 = new lib.divisionTile09();
    this.s7.name = 's7';
    this.s7.setTransform(51, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s6 = new lib.divisionTile08();
    this.s6.name = 's6';
    this.s6.setTransform(4, 38.3, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s5 = new lib.divisionTile07();
    this.s5.name = 's5';
    this.s5.setTransform(239, -8.05, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.s4 = new lib.divisionTile06();
    this.s4.name = 's4';
    this.s4.setTransform(192, -8.05, 0.7223, 0.7221, 0, 0, 0, 0, 0.3);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.s4 },
            { t: this.s5 },
            { t: this.s6 },
            { t: this.s7 },
            { t: this.s0 },
            { t: this.s1 },
            { t: this.s2 },
            { t: this.s3 },
            { t: this.s8 },
            { t: this.s9 },
            { t: this.s10 },
            { t: this.s11 },
            { t: this.s12 },
            { t: this.s13 },
            { t: this.s14 },
            { t: this.s15 },
            { t: this.s16 },
            { t: this.s17 },
            { t: this.s22 },
            { t: this.s23 },
            { t: this.s24 },
            { t: this.s25 },
            { t: this.s18 },
            { t: this.s19 },
            { t: this.s20 },
            { t: this.s21 },
            { t: this.s26 },
            { t: this.s27 },
            { t: this.s28 },
            { t: this.s29 },
            { t: this.s30 },
            { t: this.s31 },
            { t: this.s32 },
            { t: this.s33 },
            { t: this.s34 },
            { t: this.s35 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.DivisionGrid,
    new cjs.Rectangle(-18.5, -30.6, 280, 276.90000000000003),
    null,
  );

  (lib.ra = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.instance = new lib.arr3('synched', 0);
    this.instance.setTransform(
      95.05,
      127,
      1,
      1,
      0,
      153.7606,
      -26.2394,
      0.5,
      0.5,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ra,
    new cjs.Rectangle(35.1, 17.6, 159.9, 155.9),
    null,
  );

  (lib.arrow04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_25 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(25)
        .call(this.frame_25)
        .wait(1),
    );

    // mask (mask)
    var mask = new cjs.Shape();
    mask._off = true;
    var mask_graphics_1 = new cjs.Graphics().p(
      'EhLJBLFMAAAiWJMCWTAAAMAAACWJgEgWFAgPQnPNMADABQEFCAGcB4QM4DxL8gdQQvgoMio9QPqrMIL3nQHS06kWxQQhtmzk9ocQk4oTlZleQlBF4k8FuQp1LagcALQGmG+CkIsQDHKhj8KRQj2KBoaFJQmuEIpUA0QmpAmnThIQjpgjiUgsQADACnPNLg',
    );

    this.timeline.addTween(
      cjs.Tween.get(mask)
        .to({ graphics: null, x: 0, y: 0 })
        .wait(1)
        .to({ graphics: mask_graphics_1, x: 74.425, y: 92.175 })
        .wait(25),
    );

    // arrow
    this.instance = new lib.arrowShape02();
    this.instance.setTransform(145, 54, 1, 1, -157.5596);
    this.instance._off = true;

    var maskedShapeInstanceList = [this.instance];

    for (
      var shapedInstanceItr = 0;
      shapedInstanceItr < maskedShapeInstanceList.length;
      shapedInstanceItr++
    ) {
      maskedShapeInstanceList[shapedInstanceItr].mask = mask;
    }

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9986,
            scaleY: 0.9986,
            rotation: -150.9549,
            x: 141.7,
            y: 61.95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -144.4192,
            x: 135.3,
            y: 69.95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9983,
            scaleY: 0.9983,
            rotation: -137.8818,
            x: 128.65,
            y: 77,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -131.3441, x: 120.2, y: 83 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -124.6193,
            x: 111.85,
            y: 88.05,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9986,
            scaleY: 0.9986,
            rotation: -118.0828,
            x: 103.25,
            y: 92,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -111.5514,
            x: 94.95,
            y: 95.05,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: -105.0221,
            x: 84.3,
            y: 97,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -98.3098,
            x: 74.9,
            y: 98,
          },
          0,
        )
        .wait(1)
        .to({ scaleX: 0.9999, scaleY: 0.9999, rotation: -91.7893, x: 66.45 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -85.46,
            x: 58.05,
            y: 97.05,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -78.9373,
            x: 48.5,
            y: 95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.999,
            scaleY: 0.999,
            rotation: -72.2243,
            x: 39.05,
            y: 91.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9987,
            scaleY: 0.9987,
            rotation: -65.6932,
            x: 31.6,
            y: 87.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9985,
            scaleY: 0.9985,
            rotation: -59.1591,
            x: 23.1,
            y: 81,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -52.6236,
            x: 15.7,
            y: 75.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9983,
            scaleY: 0.9983,
            rotation: -45.8992,
            x: 9.15,
            y: 67.95,
          },
          0,
        )
        .wait(1)
        .to(
          { scaleX: 0.9984, scaleY: 0.9984, rotation: -39.3598, x: 3.7, y: 61 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9985,
            scaleY: 0.9985,
            rotation: -32.824,
            x: -0.75,
            y: 54,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9987,
            scaleY: 0.9987,
            rotation: -26.2894,
            x: -5.25,
            y: 45.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -19.5698,
            x: -7.65,
            y: 36,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -13.0401,
            x: -9.15,
            y: 26,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -6.5177,
            x: -10.55,
            y: 16.95,
          },
          0,
        )
        .wait(1)
        .to({ scaleX: 1, scaleY: 1, rotation: 0, x: -10, y: 7 }, 0)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-406.5, -372.9, 930.1, 872);

  (lib.arrow03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_25 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(25)
        .call(this.frame_25)
        .wait(1),
    );

    // mask (mask)
    var mask = new cjs.Shape();
    mask._off = true;
    var mask_graphics_1 = new cjs.Graphics().p(
      'EhLJBLFMAAAiWJMCWTAAAMAAACWJgEgWFAgPQnPNMADABQEFCAGcB4QM4DxL8gdQQvgoMio9QPqrMIL3nQHS06kWxQQhtmzk9ocQk4oTlZleQlBF4k8FuQp1LagcALQGmG+CkIsQDHKhj8KRQj2KBoaFJQmuEIpUA0QmpAmnThIQjpgjiUgsQADACnPNLg',
    );

    this.timeline.addTween(
      cjs.Tween.get(mask)
        .to({ graphics: null, x: 0, y: 0 })
        .wait(1)
        .to({ graphics: mask_graphics_1, x: 74.425, y: 92.175 })
        .wait(25),
    );

    // arrow
    this.instance = new lib.arrowShape02();
    this.instance.setTransform(145, 54, 1, 1, -157.5596);
    this.instance._off = true;

    var maskedShapeInstanceList = [this.instance];

    for (
      var shapedInstanceItr = 0;
      shapedInstanceItr < maskedShapeInstanceList.length;
      shapedInstanceItr++
    ) {
      maskedShapeInstanceList[shapedInstanceItr].mask = mask;
    }

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9986,
            scaleY: 0.9986,
            rotation: -150.9549,
            x: 141.7,
            y: 61.95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -144.4192,
            x: 135.3,
            y: 69.95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9983,
            scaleY: 0.9983,
            rotation: -137.8818,
            x: 128.65,
            y: 77,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -131.3441, x: 120.2, y: 83 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -124.6193,
            x: 111.85,
            y: 88.05,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9986,
            scaleY: 0.9986,
            rotation: -118.0828,
            x: 103.25,
            y: 92,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -111.5514,
            x: 94.95,
            y: 95.05,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: -105.0221,
            x: 84.3,
            y: 97,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -98.3098,
            x: 74.9,
            y: 98,
          },
          0,
        )
        .wait(1)
        .to({ scaleX: 0.9999, scaleY: 0.9999, rotation: -91.7893, x: 66.45 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -85.46,
            x: 58.05,
            y: 97.05,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -78.9373,
            x: 48.5,
            y: 95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.999,
            scaleY: 0.999,
            rotation: -72.2243,
            x: 39.05,
            y: 91.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9987,
            scaleY: 0.9987,
            rotation: -65.6932,
            x: 31.6,
            y: 87.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9985,
            scaleY: 0.9985,
            rotation: -59.1591,
            x: 23.1,
            y: 81,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -52.6236,
            x: 15.7,
            y: 75.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9983,
            scaleY: 0.9983,
            rotation: -45.8992,
            x: 9.15,
            y: 67.95,
          },
          0,
        )
        .wait(1)
        .to(
          { scaleX: 0.9984, scaleY: 0.9984, rotation: -39.3598, x: 3.7, y: 61 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9985,
            scaleY: 0.9985,
            rotation: -32.824,
            x: -0.75,
            y: 54,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: 0.1,
            scaleX: 0.9987,
            scaleY: 0.9987,
            rotation: -26.2894,
            x: -5.25,
            y: 45.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -19.5698,
            x: -7.65,
            y: 36,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -13.0401,
            x: -9.15,
            y: 26,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -6.5177,
            x: -10.55,
            y: 16.95,
          },
          0,
        )
        .wait(1)
        .to({ scaleX: 1, scaleY: 1, rotation: 0, x: -10, y: 7 }, 0)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-406.5, -372.9, 930.1, 872);

  (lib.arrow02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_24 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(24)
        .call(this.frame_24)
        .wait(1),
    );

    // arrowMask (mask)
    var mask = new cjs.Shape();
    mask._off = true;
    var mask_graphics_1 = new cjs.Graphics().p(
      'EhLEBLFMAAAiWJMCWJAAAMAAACWJgEgnsg+OQl2DMk4FJQm0HMj6KDQk4MlAAQXQAAVmMdO1QJ+L3RbHBQMdFAO6CFQHdBCE9ABQgGgEAF+hQi/gCkggjQo9hGnfimQqfjol/mHQnfnoAArEQAAyAG/qEQCLjICoh/QBTg/A1gYQgCgBnMrIQnLrHgDgCQh9Aki7Bmg',
    );

    this.timeline.addTween(
      cjs.Tween.get(mask)
        .to({ graphics: null, x: 0, y: 0 })
        .wait(1)
        .to({ graphics: mask_graphics_1, x: -80.025, y: 93.175 })
        .wait(24),
    );

    // arrowAnimation
    this.instance = new lib.arrowShape01();
    this.instance.setTransform(
      -160.05,
      14,
      0.9988,
      0.9988,
      -156.7157,
      0,
      0,
      256.1,
      305.1,
    );
    this.instance._off = true;

    var maskedShapeInstanceList = [this.instance];

    for (
      var shapedInstanceItr = 0;
      shapedInstanceItr < maskedShapeInstanceList.length;
      shapedInstanceItr++
    ) {
      maskedShapeInstanceList[shapedInstanceItr].mask = mask;
    }

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9974,
            scaleY: 0.9974,
            rotation: -149.9294,
            x: -156.95,
            y: 3.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9973,
            scaleY: 0.9973,
            rotation: -143.1422,
            x: -156,
            y: -5.6,
          },
          0,
        )
        .wait(1)
        .to({ regY: 305, rotation: -136.354, x: -151.9, y: -14.3 }, 0)
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9974,
            scaleY: 0.9974,
            rotation: -129.3777,
            x: -148.85,
            y: -23.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9975,
            scaleY: 0.9975,
            rotation: -122.5903,
            x: -142.85,
            y: -29.9,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9978,
            scaleY: 0.9978,
            rotation: -115.8064,
            x: -135.9,
            y: -38.7,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9981,
            scaleY: 0.9981,
            rotation: -109.0247,
            x: -131.75,
            y: -45.45,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9985,
            scaleY: 0.9985,
            rotation: -102.0592,
            x: -124.8,
            y: -50.25,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -95.2867,
            x: -112.7,
            y: -54.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: -88.7076,
            x: -107.75,
            y: -57.85,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -81.9387,
            x: -96.6,
            y: -60.65,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9986,
            scaleY: 0.9986,
            rotation: -74.9733,
            x: -89.55,
            y: -63.4,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9983,
            scaleY: 0.9983,
            rotation: -68.195,
            x: -80.55,
            y: -63.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9981,
            scaleY: 0.9981,
            rotation: -61.4124,
            x: -71.45,
            y: -62,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.998,
            scaleY: 0.998,
            rotation: -54.6272,
            x: -61.4,
            y: -59.8,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9979,
            scaleY: 0.9979,
            rotation: -47.6523,
            x: -53.4,
            y: -57.6,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.998,
            scaleY: 0.998,
            rotation: -40.8624,
            x: -44.3,
            y: -53.25,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9982,
            scaleY: 0.9982,
            rotation: -34.0758,
            x: -37.25,
            y: -48.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -27.2903,
            x: -29.25,
            y: -41.9,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9987,
            scaleY: 0.9987,
            rotation: -20.3188,
            x: -23.15,
            y: -34.7,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9991,
            scaleY: 0.9991,
            rotation: -13.5417,
            x: -19.15,
            y: -27.5,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -6.7674,
            x: -15.05,
            y: -19.3,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 256.2,
            regY: 305.2,
            scaleX: 1,
            scaleY: 1,
            rotation: 0,
            x: -11.05,
            y: -11.05,
          },
          0,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-547.2, -387.3, 896.4000000000001, 782.3);

  (lib.arrow01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_24 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(24)
        .call(this.frame_24)
        .wait(1),
    );

    // arrowMask (mask)
    var mask = new cjs.Shape();
    mask._off = true;
    var mask_graphics_1 = new cjs.Graphics().p(
      'EhLEBLFMAAAiWJMCWJAAAMAAACWJgEgnsg+OQl2DMk4FJQm0HMj6KDQk4MlAAQXQAAVmMdO1QJ+L3RbHBQMdFAO6CFQHdBCE9ABQgGgEAF+hQi/gCkggjQo9hGnfimQqfjol/mHQnfnoAArEQAAyAG/qEQCLjICoh/QBTg/A1gYQgCgBnMrIQnLrHgDgCQh9Aki7Bmg',
    );

    this.timeline.addTween(
      cjs.Tween.get(mask)
        .to({ graphics: null, x: 0, y: 0 })
        .wait(1)
        .to({ graphics: mask_graphics_1, x: -80.025, y: 93.175 })
        .wait(24),
    );

    // arrowAnimation
    this.instance = new lib.arrowShape01();
    this.instance.setTransform(
      -160.05,
      14,
      0.9988,
      0.9988,
      -156.7157,
      0,
      0,
      256.1,
      305.1,
    );
    this.instance._off = true;

    var maskedShapeInstanceList = [this.instance];

    for (
      var shapedInstanceItr = 0;
      shapedInstanceItr < maskedShapeInstanceList.length;
      shapedInstanceItr++
    ) {
      maskedShapeInstanceList[shapedInstanceItr].mask = mask;
    }

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9974,
            scaleY: 0.9974,
            rotation: -149.9294,
            x: -156.95,
            y: 3.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9973,
            scaleY: 0.9973,
            rotation: -143.1422,
            x: -156,
            y: -5.6,
          },
          0,
        )
        .wait(1)
        .to({ regY: 305, rotation: -136.354, x: -151.9, y: -14.3 }, 0)
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9974,
            scaleY: 0.9974,
            rotation: -129.3777,
            x: -148.85,
            y: -23.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9975,
            scaleY: 0.9975,
            rotation: -122.5903,
            x: -142.85,
            y: -29.9,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9978,
            scaleY: 0.9978,
            rotation: -115.8064,
            x: -135.9,
            y: -38.7,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9981,
            scaleY: 0.9981,
            rotation: -109.0247,
            x: -131.75,
            y: -45.45,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9985,
            scaleY: 0.9985,
            rotation: -102.0592,
            x: -124.8,
            y: -50.25,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -95.2867,
            x: -112.7,
            y: -54.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: -88.7076,
            x: -107.75,
            y: -57.85,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.9989,
            scaleY: 0.9989,
            rotation: -81.9387,
            x: -96.6,
            y: -60.65,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9986,
            scaleY: 0.9986,
            rotation: -74.9733,
            x: -89.55,
            y: -63.4,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9983,
            scaleY: 0.9983,
            rotation: -68.195,
            x: -80.55,
            y: -63.15,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9981,
            scaleY: 0.9981,
            rotation: -61.4124,
            x: -71.45,
            y: -62,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.998,
            scaleY: 0.998,
            rotation: -54.6272,
            x: -61.4,
            y: -59.8,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305,
            scaleX: 0.9979,
            scaleY: 0.9979,
            rotation: -47.6523,
            x: -53.4,
            y: -57.6,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 305.1,
            scaleX: 0.998,
            scaleY: 0.998,
            rotation: -40.8624,
            x: -44.3,
            y: -53.25,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9982,
            scaleY: 0.9982,
            rotation: -34.0758,
            x: -37.25,
            y: -48.1,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9984,
            scaleY: 0.9984,
            rotation: -27.2903,
            x: -29.25,
            y: -41.9,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9987,
            scaleY: 0.9987,
            rotation: -20.3188,
            x: -23.15,
            y: -34.7,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9991,
            scaleY: 0.9991,
            rotation: -13.5417,
            x: -19.15,
            y: -27.5,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -6.7674,
            x: -15.05,
            y: -19.3,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 256.2,
            regY: 305.2,
            scaleX: 1,
            scaleY: 1,
            rotation: 0,
            x: -11.05,
            y: -11.05,
          },
          0,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-547.2, -387.3, 896.4000000000001, 782.3);

  (lib.additionGrid = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // tiles
    this.a15 = new lib.additionTile16();
    this.a15.name = 'a15';
    this.a15.setTransform(214.25, 193.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a14 = new lib.additionTile15();
    this.a14.name = 'a14';
    this.a14.setTransform(147.1, 193.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a13 = new lib.additionTile14();
    this.a13.name = 'a13';
    this.a13.setTransform(80.05, 193.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a12 = new lib.additionTile13();
    this.a12.name = 'a12';
    this.a12.setTransform(13, 193.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a11 = new lib.additionTile12();
    this.a11.name = 'a11';
    this.a11.setTransform(214.25, 126.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.a10 = new lib.additionTile11();
    this.a10.name = 'a10';
    this.a10.setTransform(147.1, 126.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.a9 = new lib.additionTile10();
    this.a9.name = 'a9';
    this.a9.setTransform(80.05, 126.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.a8 = new lib.additionTile09();
    this.a8.name = 'a8';
    this.a8.setTransform(13, 126.45, 1, 1, 0, 0, 0, 0, 0.2);

    this.a3 = new lib.additionTile04();
    this.a3.name = 'a3';
    this.a3.setTransform(214.25, -8.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.a2 = new lib.additionTile03();
    this.a2.name = 'a2';
    this.a2.setTransform(147.1, -8.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.a1 = new lib.additionTile02();
    this.a1.name = 'a1';
    this.a1.setTransform(80.05, -8.05, 1, 1, 0, 0, 0, 0, 0.2);

    this.a0 = new lib.additionTile01();
    this.a0.name = 'a0';
    this.a0.setTransform(13, -8.25);

    this.a7 = new lib.additionTile08();
    this.a7.name = 'a7';
    this.a7.setTransform(214.25, 59.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a6 = new lib.additionTile07();
    this.a6.name = 'a6';
    this.a6.setTransform(147.1, 59.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a5 = new lib.additionTile06();
    this.a5.name = 'a5';
    this.a5.setTransform(80.05, 59.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.a4 = new lib.additionTile05();
    this.a4.name = 'a4';
    this.a4.setTransform(13, 59.2, 1, 1, 0, 0, 0, 0, 0.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.a4 },
            { t: this.a5 },
            { t: this.a6 },
            { t: this.a7 },
            { t: this.a0 },
            { t: this.a1 },
            { t: this.a2 },
            { t: this.a3 },
            { t: this.a8 },
            { t: this.a9 },
            { t: this.a10 },
            { t: this.a11 },
            { t: this.a12 },
            { t: this.a13 },
            { t: this.a14 },
            { t: this.a15 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.additionGrid,
    new cjs.Rectangle(-18.1, -39.4, 263.5, 266),
    null,
  );

  (lib.comsuntexsymbolsValueTextBlack = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // fields
    this.fields = new lib.ValueTextBlack_fields();
    this.fields.name = 'fields';
    this.fields.setTransform(-2.75, -1.2);

    this.timeline.addTween(cjs.Tween.get(this.fields).wait(1));

    // glow
    this.textGlow = new lib.ValueText_glow();
    this.textGlow.name = 'textGlow';
    this.textGlow.setTransform(-3, -1, 0.6667, 0.6667);

    this.timeline.addTween(cjs.Tween.get(this.textGlow).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueTextBlack,
    new cjs.Rectangle(-34.4, -26.5, 67, 50),
    null,
  );

  (lib.textMovieClip = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1),
    );

    // Layer 1
    this.textb = new lib.comsuntexsymbolsValueTextBlack();
    this.textb.name = 'textb';
    this.textb.setTransform(-1.4, -1.3, 1.2185, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.textb).wait(5));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(-0.2, 1.95);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape_1.setTransform(-0.2, 1.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_2.setTransform(-1.8, 1.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_3.setTransform(-1.8, 1.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#DCF3A8')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_4.setTransform(-1.8, 1.4);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_5.setTransform(-1.8, 1.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-44.6, -27.8, 85.6, 51.8);

  (lib.start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { button: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape.setTransform(132.825, -102.975);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKA1IgZgpIAAApIgdAAIAAhpIAsAAQAIAAAGACQAGACAFAFQAJAKAAAOQAAAHgCAGQgDAGgFADQgEAFgJACIAhArgAgPgFIAEAAQAJAAACgCIAEgFIABgGIgBgGIgEgEQgCgDgJAAIgEAAg',
      );
    this.shape_1.setTransform(124.55, -102.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AAaA1IgHgSIglAAIgHASIgeAAIAphpIAeAAIAoBpgAgKAOIAWAAIgMghg');
    this.shape_2.setTransform(113.325, -102.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape_3.setTransform(104.525, -102.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgmArIAMgWQAMALAMAAQAGAAAEgDQACgDAAgEQAAgFgDgCQgEgCgIgDQgQgFgFgEQgIgGAAgPQAAgQALgKQAKgJAOAAQASAAAQAIIgLAWQgJgHgJAAQgGAAgCADQgDADAAADQAAAFAGADIAMAEQAOAEAGAHQAGAGAAAMQAAAVgNAJQgMAIgPAAQgUAAgRgNg',
      );
    this.shape_4.setTransform(96.175, -102.95);

    this.clockDisplay = new lib.comsuntexsymbolsValueTextBlack();
    this.clockDisplay.name = 'clockDisplay';
    this.clockDisplay.setTransform(
      115.65,
      -102.5,
      1.2185,
      1.25,
      0,
      0,
      0,
      -0.4,
      0,
    );
    this.clockDisplay.alpha = 0.3984;

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to({ state: [{ t: this.clockDisplay }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.startblock = new lib.sb();
    this.startblock.name = 'startblock';
    this.startblock.setTransform(115.8, -103.2, 1, 1, 0, 0, 0, 36.8, 15.8);

    this.timeline.addTween(cjs.Tween.get(this.startblock).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(
    74.1,
    -135.7,
    81.70000000000002,
    62.499999999999986,
  );

  (lib.gfxgearCenter = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // equation
    this.ta = new lib.textMovieClip();
    this.ta.name = 'ta';
    this.ta.setTransform(10.95, 13.65, 4.0001, 3.6833, 0, 0, 0, 0, 1);

    this.timeline.addTween(cjs.Tween.get(this.ta).wait(1));

    // gear
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#414042')
      .s()
      .p(
        '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',
      );
    this.shape.setTransform(0.025, 0.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .rf(
        [
          'rgba(0,0,0,0)',
          'rgba(147,152,157,0)',
          '#93989D',
          '#8C9297',
          '#BCBEC0',
          '#58595B',
        ],
        [0, 0.733, 0.733, 0.741, 0.749, 0.89],
        0,
        0,
        0,
        0,
        0,
        221.8,
      )
      .s()
      .p(
        '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',
      );
    this.shape_1.setTransform(0.025, 0.025);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .rf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CFCCC9',
          '#A8A8A8',
          '#6B7072',
          '#485053',
          '#888D8E',
          '#B8BABB',
          '#D5D6D6',
          '#E0E0E0',
          '#D6D7D8',
          '#BDBFC1',
          '#93989D',
          'rgba(147,152,157,0)',
          'rgba(0,0,0,0)',
        ],
        [
          0, 0, 0.059, 0.169, 0.322, 0.4, 0.475, 0.533, 0.58, 0.608, 0.631,
          0.678, 0.733, 0.733, 1,
        ],
        0,
        0,
        0,
        0,
        0,
        221.8,
      )
      .s()
      .p(
        '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',
      );
    this.shape_2.setTransform(0.025, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // Layer 2
    this.cSlide = new lib.curtain();
    this.cSlide.name = 'cSlide';
    this.cSlide.setTransform(-3.5, -8.95, 1, 1, 0, 0, 0, 0.5, 0.5);

    this.timeline.addTween(cjs.Tween.get(this.cSlide).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(
    -220.4,
    -223.1,
    440.9,
    446.29999999999995,
  );

  (lib.gear03RightStart = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_40 = function () {
      this.stop();
    };
    this.frame_80 = function () {
      this.stop();
    };
    this.frame_120 = function () {
      this.stop();
    };
    this.frame_160 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(39)
        .call(this.frame_40)
        .wait(40)
        .call(this.frame_80)
        .wait(40)
        .call(this.frame_120)
        .wait(40)
        .call(this.frame_160)
        .wait(1),
    );

    // value
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(6, 7.75, 2.9244, 2.4007);

    this.timeline.addTween(
      cjs.Tween.get(this.t)
        .wait(1)
        .to({ regX: 0.1, regY: 1.2, x: 6.35, y: 10.55 }, 0)
        .wait(1)
        .to({ regX: -1.8, regY: -1, scaleX: 2.9245, x: 9.4, y: 5 }, 0)
        .wait(1)
        .to({ x: 18, y: 4.7 }, 0)
        .wait(1)
        .to({ x: 26.6, y: 4.3 }, 0)
        .wait(1)
        .to({ x: 35.1, y: 3.85 }, 0)
        .wait(1)
        .to({ x: 43.6, y: 3.25 }, 0)
        .wait(1)
        .to({ x: 52, y: 2.5 }, 0)
        .wait(1)
        .to({ x: 60.3, y: 1.65 }, 0)
        .wait(1)
        .to({ x: 68.6, y: 0.65 }, 0)
        .wait(1)
        .to({ x: 76.75, y: -0.5 }, 0)
        .wait(1)
        .to({ x: 84.8, y: -1.85 }, 0)
        .wait(1)
        .to({ x: 92.8, y: -3.3 }, 0)
        .wait(1)
        .to({ x: 100.65, y: -5 }, 0)
        .wait(1)
        .to({ x: 108.4, y: -6.9 }, 0)
        .wait(1)
        .to({ x: 116, y: -9 }, 0)
        .wait(1)
        .to({ x: 123.5, y: -11.3 }, 0)
        .wait(1)
        .to({ x: 130.8, y: -13.9 }, 0)
        .wait(1)
        .to({ x: 138, y: -16.7 }, 0)
        .wait(1)
        .to({ x: 145.05, y: -19.75 }, 0)
        .wait(1)
        .to({ x: 151.9, y: -23.1 }, 0)
        .wait(1)
        .to({ x: 158.6, y: -26.75 }, 0)
        .wait(1)
        .to({ x: 165.1, y: -30.65 }, 0)
        .wait(1)
        .to({ x: 171.4, y: -34.9 }, 0)
        .wait(1)
        .to({ x: 177.55, y: -39.45 }, 0)
        .wait(1)
        .to({ x: 183.45, y: -44.35 }, 0)
        .wait(1)
        .to({ x: 189.25, y: -49.5 }, 0)
        .wait(1)
        .to({ x: 194.85, y: -54.95 }, 0)
        .wait(1)
        .to({ x: 200.3, y: -60.6 }, 0)
        .wait(1)
        .to({ x: 205.6, y: -66.5 }, 0)
        .wait(1)
        .to({ x: 210.8, y: -72.6 }, 0)
        .wait(1)
        .to({ x: 215.9, y: -78.95 }, 0)
        .wait(1)
        .to({ x: 220.85, y: -85.4 }, 0)
        .wait(1)
        .to({ x: 225.75, y: -92 }, 0)
        .wait(1)
        .to({ x: 230.55, y: -98.75 }, 0)
        .wait(1)
        .to({ x: 235.3, y: -105.65 }, 0)
        .wait(1)
        .to({ x: 240, y: -112.6 }, 0)
        .wait(1)
        .to({ x: 244.6, y: -119.6 }, 0)
        .wait(1)
        .to({ x: 249.25, y: -126.65 }, 0)
        .wait(1)
        .to({ x: 253.85, y: -133.75 }, 0)
        .wait(1)
        .to({ x: 258.45, y: -140.85 }, 0)
        .wait(1)
        .to({ x: 257.95, y: -140.05 }, 0)
        .wait(1)
        .to({ regX: 1.4, regY: -0.6, scaleX: 2.9244, x: 258.9, y: -130 }, 0)
        .wait(1)
        .to({ regX: -1.8, regY: -1, scaleX: 2.9245, x: 244.85, y: -123.9 }, 0)
        .wait(1)
        .to({ x: 240.1, y: -117.05 }, 0)
        .wait(1)
        .to({ x: 235.25, y: -110.4 }, 0)
        .wait(1)
        .to({ x: 230.35, y: -103.95 }, 0)
        .wait(1)
        .to({ x: 225.3, y: -97.65 }, 0)
        .wait(1)
        .to({ x: 220.15, y: -91.55 }, 0)
        .wait(1)
        .to({ x: 214.95, y: -85.6 }, 0)
        .wait(1)
        .to({ x: 209.6, y: -79.9 }, 0)
        .wait(1)
        .to({ x: 204.15, y: -74.3 }, 0)
        .wait(1)
        .to({ x: 198.65, y: -68.95 }, 0)
        .wait(1)
        .to({ x: 193, y: -63.75 }, 0)
        .wait(1)
        .to({ x: 187.3, y: -58.75 }, 0)
        .wait(1)
        .to({ x: 181.45, y: -53.9 }, 0)
        .wait(1)
        .to({ x: 175.55, y: -49.25 }, 0)
        .wait(1)
        .to({ x: 169.5, y: -44.8 }, 0)
        .wait(1)
        .to({ x: 163.35, y: -40.5 }, 0)
        .wait(1)
        .to({ x: 157.1, y: -36.4 }, 0)
        .wait(1)
        .to({ x: 150.8, y: -32.5 }, 0)
        .wait(1)
        .to({ x: 144.35, y: -28.75 }, 0)
        .wait(1)
        .to({ x: 137.75, y: -25.2 }, 0)
        .wait(1)
        .to({ x: 131.1, y: -21.85 }, 0)
        .wait(1)
        .to({ x: 124.35, y: -18.65 }, 0)
        .wait(1)
        .to({ x: 117.45, y: -15.65 }, 0)
        .wait(1)
        .to({ x: 110.45, y: -12.8 }, 0)
        .wait(1)
        .to({ x: 103.35, y: -10.15 }, 0)
        .wait(1)
        .to({ x: 96.15, y: -7.7 }, 0)
        .wait(1)
        .to({ x: 88.85, y: -5.4 }, 0)
        .wait(1)
        .to({ x: 81.4, y: -3.3 }, 0)
        .wait(1)
        .to({ x: 73.85, y: -1.45 }, 0)
        .wait(1)
        .to({ x: 66.2, y: 0.3 }, 0)
        .wait(1)
        .to({ x: 58.45, y: 1.85 }, 0)
        .wait(1)
        .to({ x: 50.55, y: 3.2 }, 0)
        .wait(1)
        .to({ x: 42.55, y: 4.4 }, 0)
        .wait(1)
        .to({ x: 34.45, y: 5.4 }, 0)
        .wait(1)
        .to({ x: 26.2, y: 6.25 }, 0)
        .wait(1)
        .to({ x: 17.85, y: 6.9 }, 0)
        .wait(1)
        .to({ x: 9.35, y: 7.35 }, 0)
        .wait(1)
        .to({ x: 0.8, y: 7.6 }, 0)
        .wait(1)
        .to({ regX: 2.4, regY: 0.3, scaleX: 2.9244, x: 7.45, y: 10.95 }, 0)
        .wait(1)
        .to({ regX: -1.8, regY: -1, scaleX: 2.9245, x: -12.6, y: 7.2 }, 0)
        .wait(1)
        .to({ x: -20.5, y: 5.95 }, 0)
        .wait(1)
        .to({ x: -28.3, y: 4.45 }, 0)
        .wait(1)
        .to({ x: -36.05, y: 2.7 }, 0)
        .wait(1)
        .to({ x: -43.75, y: 0.8 }, 0)
        .wait(1)
        .to({ x: -51.4, y: -1.25 }, 0)
        .wait(1)
        .to({ x: -59, y: -3.35 }, 0)
        .wait(1)
        .to({ x: -66.65, y: -5.6 }, 0)
        .wait(1)
        .to({ x: -74.2, y: -7.95 }, 0)
        .wait(1)
        .to({ x: -81.75, y: -10.4 }, 0)
        .wait(1)
        .to({ x: -89.3, y: -12.9 }, 0)
        .wait(1)
        .to({ x: -96.8, y: -15.45 }, 0)
        .wait(1)
        .to({ x: -104.25, y: -18.1 }, 0)
        .wait(1)
        .to({ x: -111.7, y: -20.85 }, 0)
        .wait(1)
        .to({ x: -119.1, y: -23.7 }, 0)
        .wait(1)
        .to({ x: -126.5, y: -26.6 }, 0)
        .wait(1)
        .to({ x: -133.85, y: -29.6 }, 0)
        .wait(1)
        .to({ x: -141.15, y: -32.7 }, 0)
        .wait(1)
        .to({ x: -148.4, y: -35.95 }, 0)
        .wait(1)
        .to({ x: -155.55, y: -39.35 }, 0)
        .wait(1)
        .to({ x: -162.65, y: -42.9 }, 0)
        .wait(1)
        .to({ x: -169.6, y: -46.7 }, 0)
        .wait(1)
        .to({ x: -176.45, y: -50.7 }, 0)
        .wait(1)
        .to({ x: -183.15, y: -54.9 }, 0)
        .wait(1)
        .to({ x: -189.7, y: -59.4 }, 0)
        .wait(1)
        .to({ x: -196, y: -64.2 }, 0)
        .wait(1)
        .to({ x: -202.05, y: -69.35 }, 0)
        .wait(1)
        .to({ x: -207.9, y: -74.7 }, 0)
        .wait(1)
        .to({ x: -213.5, y: -80.3 }, 0)
        .wait(1)
        .to({ x: -219, y: -86 }, 0)
        .wait(1)
        .to({ x: -223.8, y: -91.45 }, 0)
        .wait(1)
        .to({ x: -228.25, y: -97.2 }, 0)
        .wait(1)
        .to({ x: -232.4, y: -103.1 }, 0)
        .wait(1)
        .to({ x: -236.35, y: -109.2 }, 0)
        .wait(1)
        .to({ x: -240.05, y: -115.45 }, 0)
        .wait(1)
        .to({ x: -243.55, y: -121.75 }, 0)
        .wait(1)
        .to({ x: -247, y: -128.15 }, 0)
        .wait(1)
        .to({ x: -250.4, y: -134.7 }, 0)
        .wait(1)
        .to({ x: -253.9, y: -140.95 }, 0)
        .wait(1)
        .to(
          { regX: -0.8, regY: -0.3, scaleX: 2.9244, x: -250.2, y: -140.05 },
          0,
        )
        .wait(1)
        .to({ regX: -1.8, regY: -1, scaleX: 2.9245, x: -249.45, y: -136.05 }, 0)
        .wait(1)
        .to({ x: -245.6, y: -130.5 }, 0)
        .wait(1)
        .to({ x: -241.5, y: -124.95 }, 0)
        .wait(1)
        .to({ x: -237.35, y: -119.55 }, 0)
        .wait(1)
        .to({ x: -233.1, y: -114.25 }, 0)
        .wait(1)
        .to({ x: -228.75, y: -109.05 }, 0)
        .wait(1)
        .to({ x: -224.35, y: -103.9 }, 0)
        .wait(1)
        .to({ x: -219.8, y: -98.8 }, 0)
        .wait(1)
        .to({ x: -215.2, y: -93.8 }, 0)
        .wait(1)
        .to({ x: -209.65, y: -87.9 }, 0)
        .wait(1)
        .to({ x: -204, y: -82 }, 0)
        .wait(1)
        .to({ x: -198.3, y: -76.2 }, 0)
        .wait(1)
        .to({ x: -192.5, y: -70.5 }, 0)
        .wait(1)
        .to({ x: -186.55, y: -65 }, 0)
        .wait(1)
        .to({ x: -180.4, y: -59.65 }, 0)
        .wait(1)
        .to({ x: -174.05, y: -54.55 }, 0)
        .wait(1)
        .to({ x: -167.45, y: -49.8 }, 0)
        .wait(1)
        .to({ x: -160.55, y: -45.45 }, 0)
        .wait(1)
        .to({ x: -153.45, y: -41.5 }, 0)
        .wait(1)
        .to({ x: -146.2, y: -37.85 }, 0)
        .wait(1)
        .to({ x: -138.8, y: -34.4 }, 0)
        .wait(1)
        .to({ x: -131.35, y: -31.15 }, 0)
        .wait(1)
        .to({ x: -123.85, y: -28 }, 0)
        .wait(1)
        .to({ x: -116.3, y: -24.95 }, 0)
        .wait(1)
        .to({ x: -108.7, y: -22.05 }, 0)
        .wait(1)
        .to({ x: -101.05, y: -19.2 }, 0)
        .wait(1)
        .to({ x: -93.4, y: -16.5 }, 0)
        .wait(1)
        .to({ x: -85.7, y: -13.85 }, 0)
        .wait(1)
        .to({ x: -78, y: -11.3 }, 0)
        .wait(1)
        .to({ x: -70.25, y: -8.8 }, 0)
        .wait(1)
        .to({ x: -62.45, y: -6.45 }, 0)
        .wait(1)
        .to({ x: -54.65, y: -4.15 }, 0)
        .wait(1)
        .to({ x: -46.8, y: -2.05 }, 0)
        .wait(1)
        .to({ x: -38.9, y: 0 }, 0)
        .wait(1)
        .to({ x: -31, y: 1.95 }, 0)
        .wait(1)
        .to({ x: -23.05, y: 3.7 }, 0)
        .wait(1)
        .to({ x: -15.1, y: 5.2 }, 0)
        .wait(1)
        .to({ x: -6.95, y: 6.45 }, 0)
        .wait(1)
        .to({ x: 1.05, y: 7.1 }, 0)
        .wait(1),
    );

    // gear03RightStart
    this.instance = new lib.gear03();
    this.instance.setTransform(-104.7, -102.5);
    new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.gear03(), 3);

    this.instance_1 = new lib.gfxgear03('synched', 0);
    this.instance_1.setTransform(0, 2.5);
    this.instance_1._off = true;

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.instance }] })
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .wait(1),
    );
    this.timeline.addTween(
      cjs.Tween.get(this.instance_1)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to({ rotation: -5.0001, x: 7.7, y: 3 }, 0)
        .wait(1)
        .to({ rotation: -9.9999, x: 15.5, y: 2.95 }, 0)
        .wait(1)
        .to({ rotation: -15, x: 23.6, y: 2.45 }, 0)
        .wait(1)
        .to({ rotation: -20, x: 31.6, y: 2.65 }, 0)
        .wait(1)
        .to({ rotation: -25.0001, x: 39.55, y: 0.9 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: -30.0002,
            x: 47.5,
            y: -0.1,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -34.9997, x: 55.25, y: -1.55 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: -40.0004,
            x: 63,
            y: -3.05,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -45, x: 70.7, y: -4.5 }, 0)
        .wait(1)
        .to({ regX: 0.1, rotation: -49.998, x: 78.45, y: -6.55 }, 0)
        .wait(1)
        .to({ regX: 0.2, regY: 0.1, rotation: -54.9985, x: 86.3, y: -8.5 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -59.9991,
            x: 94.05,
            y: -11,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -64.9996, x: 101.25, y: -14.25 }, 0)
        .wait(1)
        .to({ rotation: -69.9993, x: 108.7, y: -17 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.4,
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -74.9999,
            x: 116.25,
            y: -19.85,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -79.9996, x: 123.25, y: -23.35 }, 0)
        .wait(1)
        .to({ rotation: -84.9996, x: 130.5, y: -26.3 }, 0)
        .wait(1)
        .to({ regX: 0.5, rotation: -89.9939, x: 137.5, y: -30.1 }, 0)
        .wait(1)
        .to({ regY: 0.2, rotation: -94.9996, x: 144.75, y: -33.55 }, 0)
        .wait(1)
        .to({ rotation: -100.0004, x: 151.7, y: -37.35 }, 0)
        .wait(1)
        .to({ rotation: -104.9994, x: 158.45, y: -41.35 }, 0)
        .wait(1)
        .to({ rotation: -109.9995, x: 164.95, y: -45.8 }, 0)
        .wait(1)
        .to({ regY: 0.3, rotation: -114.9995, x: 171.7, y: -50.35 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -119.9987,
            x: 177.95,
            y: -55.1,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -125.0002, x: 184.2, y: -60.05 }, 0)
        .wait(1)
        .to(
          {
            regY: 0.4,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -130.0014,
            x: 190.55,
            y: -64.85,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -134.9988, x: 196.55, y: -69.85 }, 0)
        .wait(1)
        .to({ regX: 0.6, rotation: -139.9991, x: 202.2, y: -75.35 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.5,
            regY: 0.5,
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -145.0005,
            x: 208.05,
            y: -80.85,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -149.9992, x: 214.5, y: -86.05 }, 0)
        .wait(1)
        .to({ regY: 0.6, rotation: -154.9986, x: 219, y: -92.35 }, 0)
        .wait(1)
        .to({ rotation: -160.0003, x: 224, y: -98.3 }, 0)
        .wait(1)
        .to({ regX: 0.4, rotation: -164.9995, x: 229.25, y: -104.3 }, 0)
        .wait(1)
        .to({ rotation: -169.9997, x: 234.2, y: -110.25 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: -174.9995,
            x: 239.2,
            y: -116.5,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: 0.3, regY: 0.7, rotation: -179.9991, x: 244, y: -123.05 },
          0,
        )
        .wait(1)
        .to({ rotation: -184.9996, x: 248.5, y: -129.5 }, 0)
        .wait(1)
        .to({ rotation: -189.9997, x: 252.5, y: -136.25 }, 0)
        .wait(1)
        .to(
          { regX: 0.2, regY: 0.8, rotation: -194.9997, x: 256.3, y: -143.3 },
          0,
        )
        .wait(1)
        .to({ startPosition: 0 }, 0)
        .wait(1)
        .to(
          { regX: 0.3, regY: 0.7, rotation: -189.9997, x: 252.5, y: -136.25 },
          0,
        )
        .wait(1)
        .to({ rotation: -184.9996, x: 248.5, y: -129.5 }, 0)
        .wait(1)
        .to({ rotation: -179.9991, x: 244, y: -123.05 }, 0)
        .wait(1)
        .to(
          { regX: 0.4, regY: 0.6, rotation: -174.9995, x: 239.2, y: -116.5 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -169.9997,
            x: 234.2,
            y: -110.25,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -164.9995, x: 229.25, y: -104.3 }, 0)
        .wait(1)
        .to({ regX: 0.5, rotation: -160.0003, x: 224, y: -98.3 }, 0)
        .wait(1)
        .to({ rotation: -154.9986, x: 219, y: -92.35 }, 0)
        .wait(1)
        .to({ regY: 0.5, rotation: -149.9992, x: 214.5, y: -86.05 }, 0)
        .wait(1)
        .to({ rotation: -145.0005, x: 208.05, y: -80.85 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.6,
            regY: 0.4,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -139.9991,
            x: 202.2,
            y: -75.35,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0.5, rotation: -134.9988, x: 196.55, y: -69.85 }, 0)
        .wait(1)
        .to({ rotation: -130.0014, x: 190.55, y: -64.85 }, 0)
        .wait(1)
        .to(
          {
            regY: 0.3,
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -125.0002,
            x: 184.2,
            y: -60.05,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -119.9987, x: 177.95, y: -55.1 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -114.9995,
            x: 171.7,
            y: -50.35,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0.2, rotation: -109.9995, x: 164.95, y: -45.8 }, 0)
        .wait(1)
        .to({ rotation: -104.9994, x: 158.45, y: -41.35 }, 0)
        .wait(1)
        .to({ rotation: -100.0004, x: 151.7, y: -37.35 }, 0)
        .wait(1)
        .to({ rotation: -94.9996, x: 144.75, y: -33.55 }, 0)
        .wait(1)
        .to({ regY: 0.1, rotation: -89.9939, x: 137.5, y: -30.1 }, 0)
        .wait(1)
        .to({ regX: 0.4, rotation: -84.9996, x: 130.5, y: -26.3 }, 0)
        .wait(1)
        .to({ rotation: -79.9996, x: 123.25, y: -23.35 }, 0)
        .wait(1)
        .to({ rotation: -74.9999, x: 116.25, y: -19.85 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.2,
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -69.9993,
            x: 108.7,
            y: -17,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -64.9996, x: 101.25, y: -14.25 }, 0)
        .wait(1)
        .to({ rotation: -59.9991, x: 94.05, y: -11 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: -54.9985,
            x: 86.3,
            y: -8.5,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0.1, regY: 0, rotation: -49.998, x: 78.45, y: -6.55 }, 0)
        .wait(1)
        .to({ regX: 0, rotation: -45, x: 70.7, y: -4.5 }, 0)
        .wait(1)
        .to({ rotation: -40.0004, x: 63, y: -3.05 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: -34.9997,
            x: 55.25,
            y: -1.55,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -30.0002, x: 47.5, y: -0.1 }, 0)
        .wait(1)
        .to({ scaleX: 1, scaleY: 1, rotation: -25.0001, x: 39.55, y: 0.9 }, 0)
        .wait(1)
        .to({ rotation: -20, x: 31.6, y: 2.65 }, 0)
        .wait(1)
        .to({ rotation: -15, x: 23.6, y: 2.45 }, 0)
        .wait(1)
        .to({ rotation: -9.9999, x: 15.5, y: 2.95 }, 0)
        .wait(1)
        .to({ rotation: -5.0001, x: 7.7, y: 3 }, 0)
        .wait(1)
        .to({ rotation: 0, x: 0, y: 2.5 }, 0)
        .wait(1)
        .to({ startPosition: 0 }, 0)
        .wait(1)
        .to({ regY: 0.1, rotation: 5.0001, x: -8, y: 2.55 }, 0)
        .wait(1)
        .to({ regX: 0.1, rotation: 9.9999, x: -15.9, y: 2.5 }, 0)
        .wait(1)
        .to({ regX: 0, regY: 0.2, rotation: 14.9983, x: -24, y: 2.55 }, 0)
        .wait(1)
        .to({ rotation: 19.998, x: -32, y: 2.05 }, 0)
        .wait(1)
        .to({ regX: -0.1, rotation: 24.9993, x: -40.05, y: 1.05 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: 30.0002,
            x: -48,
            y: -0.45,
          },
          0,
        )
        .wait(1)
        .to({ regX: -0.2, rotation: 35.0002, x: -55.45, y: -1 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: 40.0004,
            x: -63.45,
            y: -3.5,
          },
          0,
        )
        .wait(1)
        .to({ regX: -0.3, rotation: 45, x: -71.5, y: -4.45 }, 0)
        .wait(1)
        .to({ regX: -0.4, rotation: 49.998, x: -79, y: -6.95 }, 0)
        .wait(1)
        .to({ rotation: 54.9985, x: -87, y: -9.5 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: 59.9991,
            x: -93.95,
            y: -12.45,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 64.9996, x: -101.45, y: -14.9 }, 0)
        .wait(1)
        .to({ regX: -0.5, rotation: 69.9993, x: -108.95, y: -18 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: 74.9999,
            x: -116.45,
            y: -21,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 79.9996, x: -123.95, y: -24.45 }, 0)
        .wait(1)
        .to({ rotation: 84.9996, x: -130.9, y: -27.95 }, 0)
        .wait(1)
        .to({ regX: -0.6, rotation: 89.9939, x: -137.9, y: -32 }, 0)
        .wait(1)
        .to({ regX: -0.7, rotation: 94.9996, x: -144.4, y: -36 }, 0)
        .wait(1)
        .to({ rotation: 100.0004, x: -151.4, y: -40 }, 0)
        .wait(1)
        .to({ rotation: 104.9994, x: -157.9, y: -44.45 }, 0)
        .wait(1)
        .to({ regX: -0.8, rotation: 109.9995, x: -164.9, y: -48.95 }, 0)
        .wait(1)
        .to({ regY: 0.4, rotation: 114.9995, x: -171.45, y: -52.95 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: 119.9987,
            x: -177.45,
            y: -58,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 125.0002, x: -183.45, y: -63 }, 0)
        .wait(1)
        .to({ regY: 0.5, rotation: 129.9992, x: -189.5, y: -68.5 }, 0)
        .wait(1)
        .to({ regX: -0.7, rotation: 135, x: -195.45, y: -73.45 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: 139.9982,
            x: -200.9,
            y: -78.95,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0.6, rotation: 144.9994, x: -207, y: -84.5 }, 0)
        .wait(1)
        .to({ regY: 0.7, rotation: 149.999, x: -213, y: -90 }, 0)
        .wait(1)
        .to(
          {
            regY: 0.6,
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: 154.9993,
            x: -217.9,
            y: -95.95,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0.7, rotation: 159.9996, x: -222.95, y: -102 }, 0)
        .wait(1)
        .to({ rotation: 164.9995, x: -227.9, y: -108.55 }, 0)
        .wait(1)
        .to({ rotation: 170.0002, x: -232.8, y: -114.45 }, 0)
        .wait(1)
        .to({ regX: -0.6, rotation: 174.9998, x: -238.4, y: -119.95 }, 0)
        .wait(1)
        .to({ regY: 0.8, rotation: 180, x: -242.4, y: -127 }, 0)
        .wait(1)
        .to({ rotation: 184.9993, x: -246.85, y: -133.45 }, 0)
        .wait(1)
        .to({ regX: -0.5, rotation: 189.9991, x: -250.4, y: -140.45 }, 0)
        .wait(1)
        .to({ rotation: 195.0001, x: -254.4, y: -147.4 }, 0)
        .wait(1)
        .to({ startPosition: 0 }, 0)
        .wait(1)
        .to({ rotation: 189.9991, x: -250.4, y: -140.45 }, 0)
        .wait(1)
        .to({ regX: -0.6, rotation: 184.9993, x: -246.85, y: -133.45 }, 0)
        .wait(1)
        .to({ rotation: 180, x: -242.4, y: -127 }, 0)
        .wait(1)
        .to({ regY: 0.7, rotation: 174.9998, x: -238.4, y: -119.95 }, 0)
        .wait(1)
        .to({ regX: -0.7, rotation: 170.0002, x: -232.8, y: -114.45 }, 0)
        .wait(1)
        .to({ rotation: 164.9995, x: -227.9, y: -108.55 }, 0)
        .wait(1)
        .to({ rotation: 159.9996, x: -222.95, y: -102 }, 0)
        .wait(1)
        .to({ regY: 0.6, rotation: 154.9993, x: -217.9, y: -95.95 }, 0)
        .wait(1)
        .to(
          {
            regY: 0.7,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: 149.999,
            x: -213,
            y: -90,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0.6, rotation: 144.9994, x: -207, y: -84.5 }, 0)
        .wait(1)
        .to({ regY: 0.5, rotation: 139.9982, x: -200.9, y: -78.95 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: 135,
            x: -195.45,
            y: -73.45,
          },
          0,
        )
        .wait(1)
        .to({ regX: -0.8, rotation: 129.9992, x: -189.5, y: -68.5 }, 0)
        .wait(1)
        .to({ regY: 0.4, rotation: 125.0002, x: -183.45, y: -63 }, 0)
        .wait(1)
        .to({ rotation: 119.9987, x: -177.45, y: -58 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: 114.9995,
            x: -171.45,
            y: -52.95,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0.2, rotation: 109.9995, x: -164.9, y: -48.95 }, 0)
        .wait(1)
        .to({ regX: -0.7, rotation: 104.9994, x: -157.9, y: -44.45 }, 0)
        .wait(1)
        .to({ rotation: 100.0004, x: -151.4, y: -40 }, 0)
        .wait(1)
        .to({ rotation: 94.9996, x: -144.4, y: -36 }, 0)
        .wait(1)
        .to({ regX: -0.6, rotation: 89.9939, x: -137.9, y: -32 }, 0)
        .wait(1)
        .to({ regX: -0.5, rotation: 84.9996, x: -130.9, y: -27.95 }, 0)
        .wait(1)
        .to({ rotation: 79.9996, x: -123.95, y: -24.45 }, 0)
        .wait(1)
        .to({ rotation: 74.9999, x: -116.45, y: -21 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: 69.9993,
            x: -108.95,
            y: -18,
          },
          0,
        )
        .wait(1)
        .to({ regX: -0.4, rotation: 64.9996, x: -101.45, y: -14.9 }, 0)
        .wait(1)
        .to({ rotation: 59.9991, x: -93.95, y: -12.45 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: 54.9985,
            x: -87,
            y: -9.5,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 49.998, x: -79, y: -6.95 }, 0)
        .wait(1)
        .to({ regX: -0.3, rotation: 45, x: -71.5, y: -4.45 }, 0)
        .wait(1)
        .to({ regX: -0.2, rotation: 40.0004, x: -63.45, y: -3.5 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: 35.0002,
            x: -55.45,
            y: -1,
          },
          0,
        )
        .wait(1)
        .to({ regX: -0.1, rotation: 30.0002, x: -48, y: -0.45 }, 0)
        .wait(1)
        .to({ scaleX: 1, scaleY: 1, rotation: 24.9993, x: -40.05, y: 1.05 }, 0)
        .wait(1)
        .to({ regX: 0, rotation: 19.998, x: -32, y: 2.05 }, 0)
        .wait(1)
        .to({ rotation: 14.9983, x: -24, y: 2.55 }, 0)
        .wait(1)
        .to({ regX: 0.1, regY: 0.1, rotation: 9.9999, x: -15.9, y: 2.5 }, 0)
        .wait(1)
        .to({ regX: 0, rotation: 5.0001, x: -8, y: 2.55 }, 0)
        .wait(1)
        .to({ regY: 0, rotation: 0, x: 0, y: 2.5 }, 0)
        .wait(1),
    );

    // Layer 2
    this.lefta = new lib.ra();
    this.lefta.name = 'lefta';
    this.lefta.setTransform(-180.25, -96, 1, 1, 0, 4.7194, -175.2806, 84, 83.5);

    this.righta = new lib.ra();
    this.righta.name = 'righta';
    this.righta.setTransform(186.35, -94, 1, 1, 0, 0, 0, 84.1, 83.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.righta }, { t: this.lefta }] }, 1)
        .to({ state: [] }, 1)
        .wait(159),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(
    -375.1,
    -257.7,
    750.9000000000001,
    371.79999999999995,
  );

  (lib.gear02Start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_40 = function () {
      this.stop();
    };
    this.frame_78 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(39)
        .call(this.frame_40)
        .wait(38)
        .call(this.frame_78)
        .wait(1),
    );

    // value
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(5, 10.85, 2.4, 2.4, 0, 0, 0, 0, 1);

    this.timeline.addTween(
      cjs.Tween.get(this.t)
        .wait(1)
        .to({ regX: 0.2, regY: 0.6, x: 5.4, y: 9.9 }, 0)
        .wait(1)
        .to({ regX: -1.8, regY: -1, x: -4.65, y: -1.7 }, 0)
        .wait(1)
        .to({ x: -10, y: -9.15 }, 0)
        .wait(1)
        .to({ x: -15.4, y: -16.45 }, 0)
        .wait(1)
        .to({ x: -20.9, y: -23.5 }, 0)
        .wait(1)
        .to({ x: -26.5, y: -30.35 }, 0)
        .wait(1)
        .to({ x: -32.15, y: -37 }, 0)
        .wait(1)
        .to({ x: -37.85, y: -43.4 }, 0)
        .wait(1)
        .to({ x: -43.65, y: -49.65 }, 0)
        .wait(1)
        .to({ x: -49.55, y: -55.65 }, 0)
        .wait(1)
        .to({ x: -55.5, y: -61.45 }, 0)
        .wait(1)
        .to({ x: -61.5, y: -67 }, 0)
        .wait(1)
        .to({ x: -67.6, y: -72.4 }, 0)
        .wait(1)
        .to({ x: -73.8, y: -77.6 }, 0)
        .wait(1)
        .to({ x: -80.05, y: -82.6 }, 0)
        .wait(1)
        .to({ x: -86.35, y: -87.4 }, 0)
        .wait(1)
        .to({ x: -92.75, y: -92 }, 0)
        .wait(1)
        .to({ x: -99.25, y: -96.4 }, 0)
        .wait(1)
        .to({ x: -105.8, y: -100.65 }, 0)
        .wait(1)
        .to({ x: -112.4, y: -104.65 }, 0)
        .wait(1)
        .to({ x: -119.1, y: -108.5 }, 0)
        .wait(1)
        .to({ x: -125.85, y: -112.1 }, 0)
        .wait(1)
        .to({ x: -132.7, y: -115.55 }, 0)
        .wait(1)
        .to({ x: -139.65, y: -118.8 }, 0)
        .wait(1)
        .to({ x: -146.65, y: -121.85 }, 0)
        .wait(1)
        .to({ x: -153.75, y: -124.7 }, 0)
        .wait(1)
        .to({ x: -160.9, y: -127.35 }, 0)
        .wait(1)
        .to({ x: -168.15, y: -129.8 }, 0)
        .wait(1)
        .to({ x: -175.5, y: -132.1 }, 0)
        .wait(1)
        .to({ x: -182.9, y: -134.15 }, 0)
        .wait(1)
        .to({ x: -190.4, y: -136.05 }, 0)
        .wait(1)
        .to({ x: -197.95, y: -137.7 }, 0)
        .wait(1)
        .to({ x: -205.6, y: -139.15 }, 0)
        .wait(1)
        .to({ x: -213.35, y: -140.45 }, 0)
        .wait(1)
        .to({ x: -221.2, y: -141.5 }, 0)
        .wait(1)
        .to({ x: -229.15, y: -142.35 }, 0)
        .wait(1)
        .to({ x: -237.15, y: -143 }, 0)
        .wait(1)
        .to({ x: -245.25, y: -143.4 }, 0)
        .wait(1)
        .to({ x: -256.45, y: -144.6 }, 0)
        .wait(1)
        .to({ x: -256.8, y: -143.65 }, 0)
        .wait(1)
        .to({ regX: -0.5, regY: 0.1, x: -240.1, y: -140.95 }, 0)
        .wait(1)
        .to({ regX: -1.8, regY: -1, x: -234.95, y: -143.35 }, 0)
        .wait(1)
        .to({ x: -226.75, y: -142.95 }, 0)
        .wait(1)
        .to({ x: -218.7, y: -142.3 }, 0)
        .wait(1)
        .to({ x: -210.7, y: -141.5 }, 0)
        .wait(1)
        .to({ x: -202.8, y: -140.45 }, 0)
        .wait(1)
        .to({ x: -195, y: -139.2 }, 0)
        .wait(1)
        .to({ x: -187.3, y: -137.75 }, 0)
        .wait(1)
        .to({ x: -179.65, y: -136.1 }, 0)
        .wait(1)
        .to({ x: -172.1, y: -134.2 }, 0)
        .wait(1)
        .to({ x: -164.65, y: -132.15 }, 0)
        .wait(1)
        .to({ x: -157.25, y: -129.85 }, 0)
        .wait(1)
        .to({ x: -150, y: -127.4 }, 0)
        .wait(1)
        .to({ x: -142.75, y: -124.7 }, 0)
        .wait(1)
        .to({ x: -135.65, y: -121.75 }, 0)
        .wait(1)
        .to({ x: -128.6, y: -118.65 }, 0)
        .wait(1)
        .to({ x: -121.65, y: -115.35 }, 0)
        .wait(1)
        .to({ x: -114.8, y: -111.8 }, 0)
        .wait(1)
        .to({ x: -108, y: -108.05 }, 0)
        .wait(1)
        .to({ x: -101.3, y: -104.1 }, 0)
        .wait(1)
        .to({ x: -94.7, y: -99.95 }, 0)
        .wait(1)
        .to({ x: -88.15, y: -95.6 }, 0)
        .wait(1)
        .to({ x: -81.7, y: -91.05 }, 0)
        .wait(1)
        .to({ x: -75.3, y: -86.25 }, 0)
        .wait(1)
        .to({ x: -69, y: -81.25 }, 0)
        .wait(1)
        .to({ x: -62.8, y: -76.05 }, 0)
        .wait(1)
        .to({ x: -56.7, y: -70.65 }, 0)
        .wait(1)
        .to({ x: -50.65, y: -65 }, 0)
        .wait(1)
        .to({ x: -44.65, y: -59.15 }, 0)
        .wait(1)
        .to({ x: -38.75, y: -53.15 }, 0)
        .wait(1)
        .to({ x: -32.95, y: -46.85 }, 0)
        .wait(1)
        .to({ x: -27.2, y: -40.4 }, 0)
        .wait(1)
        .to({ x: -21.55, y: -33.7 }, 0)
        .wait(1)
        .to({ x: -16, y: -26.85 }, 0)
        .wait(1)
        .to({ x: -10.5, y: -19.7 }, 0)
        .wait(1)
        .to({ x: -5.05, y: -12.4 }, 0)
        .wait(1)
        .to({ x: 0.25, y: -4.85 }, 0)
        .wait(1)
        .to({ x: 5.5, y: 2.8 }, 0)
        .wait(1),
    );

    // gear02Start
    this.instance = new lib.gear02();
    this.instance.setTransform(-112.2, -111.5);
    new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.gear02(), 3);

    this.instance_1 = new lib.gfxgear02('synched', 0);
    this.instance_1.setTransform(-2, -1.5);
    this.instance_1._off = true;

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.instance }] })
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .wait(1),
    );
    this.timeline.addTween(
      cjs.Tween.get(this.instance_1)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to({ rotation: -9.9993, x: -6.25, y: -15 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: -14.9999,
            x: -10.4,
            y: -21.6,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: -19.9995, x: -15.6, y: -28.05 },
          0,
        )
        .wait(1)
        .to({ rotation: -24.9995, x: -20.6, y: -34.4 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: -29.9998,
            x: -25.4,
            y: -40.75,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -35.001, x: -30.5, y: -46.6 }, 0)
        .wait(1)
        .to({ rotation: -40.0011, x: -35.85, y: -52.65 }, 0)
        .wait(1)
        .to(
          { scaleX: 0.9997, scaleY: 0.9997, rotation: -45, x: -40.8, y: -58.8 },
          0,
        )
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: -50.0005, x: -46.7, y: -64.35 },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -55,
            x: -52.35,
            y: -69.75,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -60.0012, x: -58.6, y: -74.85 }, 0)
        .wait(1)
        .to({ rotation: -64.9997, x: -64.45, y: -80.4 }, 0)
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: -70.0019, x: -71.05, y: -85.05 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -75.0002,
            x: -77.35,
            y: -89.65,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, rotation: -80.0003, x: -83.25, y: -94.75 }, 0)
        .wait(1)
        .to({ regX: -0.1, rotation: -85.0007, x: -90.25, y: -99.05 }, 0)
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -89.9956, x: -96.8, y: -103.15 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -95.0005,
            x: -103.55,
            y: -107.3,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: -99.9991, x: -110.6, y: -111.1 },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -104.9975,
            x: -117.6,
            y: -115,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: 0,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -110.0001,
            x: -124.85,
            y: -118.65,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -114.999,
            x: -132.1,
            y: -121.95,
          },
          0,
        )
        .wait(1)
        .to(
          { scaleX: 1, scaleY: 1, rotation: -119.9984, x: -139.4, y: -124.8 },
          0,
        )
        .wait(1)
        .to(
          { regX: 0.1, regY: -0.1, rotation: -124.9996, x: -147, y: -127.6 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: -129.9995,
            x: -154.5,
            y: -130.35,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -135, x: -161.6, y: -133.25 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.1,
            regY: -0.1,
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: -139.9997,
            x: -169.45,
            y: -135.7,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0.2, regY: 0, rotation: -145, x: -176.9, y: -138.3 }, 0)
        .wait(1)
        .to({ rotation: -149.9994, x: -184.6, y: -139.8 }, 0)
        .wait(1)
        .to({ rotation: -154.9998, x: -192.6, y: -141.3 }, 0)
        .wait(1)
        .to({ regY: 0.1, rotation: -159.9991, x: -200.3, y: -143.35 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -164.9995,
            x: -208.25,
            y: -144.35,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: 0.4, regY: 0.7, rotation: -170.0005, x: -216.35, y: -145.85 },
          0,
        )
        .wait(1)
        .to({ rotation: -174.9999, x: -224.1, y: -147.35 }, 0)
        .wait(1)
        .to({ regY: 0.8, rotation: -179.9991, x: -232.05, y: -148.1 }, 0)
        .wait(1)
        .to({ rotation: -184.9993, x: -240.05, y: -148.3 }, 0)
        .wait(1)
        .to({ rotation: -189.9998, x: -248.05, y: -148.6 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.5,
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -194.9993,
            x: -256.1,
            y: -148.45,
          },
          0,
        )
        .wait(1)
        .to({ startPosition: 0 }, 0)
        .wait(1)
        .to(
          {
            regX: 0.4,
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -189.9998,
            x: -248.05,
            y: -148.6,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -184.9993, x: -240.05, y: -148.3 }, 0)
        .wait(1)
        .to({ rotation: -179.9991, x: -232.05, y: -148.1 }, 0)
        .wait(1)
        .to({ regY: 0.7, rotation: -174.9999, x: -224.1, y: -147.35 }, 0)
        .wait(1)
        .to({ rotation: -170.0005, x: -216.35, y: -145.85 }, 0)
        .wait(1)
        .to(
          { regX: 0.2, regY: 0.1, rotation: -164.9995, x: -208.25, y: -144.35 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: -159.9991,
            x: -200.3,
            y: -143.35,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0, rotation: -154.9998, x: -192.6, y: -141.3 }, 0)
        .wait(1)
        .to({ rotation: -149.9994, x: -184.6, y: -139.8 }, 0)
        .wait(1)
        .to({ rotation: -145, x: -176.9, y: -138.3 }, 0)
        .wait(1)
        .to(
          { regX: 0.1, regY: -0.1, rotation: -139.9997, x: -169.45, y: -135.7 },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: -135,
            x: -161.6,
            y: -133.25,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: 0.1, regY: -0.1, rotation: -129.9995, x: -154.5, y: -130.35 },
          0,
        )
        .wait(1)
        .to(
          { scaleX: 1, scaleY: 1, rotation: -124.9996, x: -147, y: -127.6 },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -119.9984, x: -139.4, y: -124.8 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -114.999,
            x: -132.1,
            y: -121.95,
          },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -110.0001,
            x: -124.85,
            y: -118.65,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regY: -0.1,
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: -104.9975,
            x: -117.6,
            y: -115,
          },
          0,
        )
        .wait(1)
        .to(
          {
            regX: -0.1,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: -99.9991,
            x: -110.6,
            y: -111.1,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -95.0005, x: -103.55, y: -107.3 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: -89.9956,
            x: -96.8,
            y: -103.15,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: -85.0007, x: -90.25, y: -99.05 },
          0,
        )
        .wait(1)
        .to({ regX: 0, rotation: -80.0003, x: -83.25, y: -94.75 }, 0)
        .wait(1)
        .to({ regX: -0.1, rotation: -75.0002, x: -77.35, y: -89.65 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: -70.0019,
            x: -71.05,
            y: -85.05,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -64.9997, x: -64.45, y: -80.4 }, 0)
        .wait(1)
        .to({ rotation: -60.0012, x: -58.6, y: -74.85 }, 0)
        .wait(1)
        .to({ rotation: -55, x: -52.35, y: -69.75 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: -0.1,
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: -50.0005,
            x: -46.7,
            y: -64.35,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -45, x: -40.8, y: -58.8 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: -40.0011,
            x: -35.85,
            y: -52.65,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -35.001, x: -30.5, y: -46.6 }, 0)
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: -29.9998, x: -25.4, y: -40.75 },
          0,
        )
        .wait(1)
        .to(
          {
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: -24.9995,
            x: -20.6,
            y: -34.4,
          },
          0,
        )
        .wait(1)
        .to({ rotation: -19.9995, x: -15.6, y: -28.05 }, 0)
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: -14.9999, x: -10.4, y: -21.6 }, 0)
        .wait(1)
        .to({ scaleX: 1, scaleY: 1, rotation: -9.9993, x: -6.25, y: -15 }, 0)
        .wait(1)
        .to({ rotation: 0, x: 2, y: -4.5 }, 0)
        .wait(1),
    );

    // Layer 3
    this.instance_2 = new lib.arr4('synched', 0);
    this.instance_2.setTransform(
      -182.05,
      -134.95,
      1,
      1,
      0,
      29.9992,
      -150.0008,
      38.5,
      11.5,
    );
    this.instance_2._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_2)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(77),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(
    -360.5,
    -257.8,
    472.7,
    366.70000000000005,
  );

  (lib.gear01Start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_40 = function () {
      this.stop();
    };
    this.frame_78 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(39)
        .call(this.frame_40)
        .wait(38)
        .call(this.frame_78)
        .wait(1),
    );

    // value
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(4.3, 6.1, 2.4, 2.4, 0, 0, 0, 0.3, 0.3);

    this.timeline.addTween(
      cjs.Tween.get(this.t)
        .wait(1)
        .to({ regX: -1.8, regY: -1, x: -0.85, y: 3.15 }, 0)
        .wait(1)
        .to({ x: 4.3, y: -4.2 }, 0)
        .wait(1)
        .to({ x: 9.55, y: -11.5 }, 0)
        .wait(1)
        .to({ x: 14.85, y: -18.55 }, 0)
        .wait(1)
        .to({ x: 20.25, y: -25.4 }, 0)
        .wait(1)
        .to({ x: 25.75, y: -32.05 }, 0)
        .wait(1)
        .to({ x: 31.3, y: -38.55 }, 0)
        .wait(1)
        .to({ x: 36.95, y: -44.8 }, 0)
        .wait(1)
        .to({ x: 42.65, y: -50.9 }, 0)
        .wait(1)
        .to({ x: 48.45, y: -56.8 }, 0)
        .wait(1)
        .to({ x: 54.35, y: -62.45 }, 0)
        .wait(1)
        .to({ x: 60.35, y: -67.95 }, 0)
        .wait(1)
        .to({ x: 66.4, y: -73.25 }, 0)
        .wait(1)
        .to({ x: 72.55, y: -78.35 }, 0)
        .wait(1)
        .to({ x: 78.8, y: -83.25 }, 0)
        .wait(1)
        .to({ x: 85.15, y: -87.95 }, 0)
        .wait(1)
        .to({ x: 91.55, y: -92.5 }, 0)
        .wait(1)
        .to({ x: 98.05, y: -96.8 }, 0)
        .wait(1)
        .to({ x: 104.6, y: -100.9 }, 0)
        .wait(1)
        .to({ x: 111.3, y: -104.85 }, 0)
        .wait(1)
        .to({ x: 118.05, y: -108.55 }, 0)
        .wait(1)
        .to({ x: 124.9, y: -112.1 }, 0)
        .wait(1)
        .to({ x: 131.85, y: -115.45 }, 0)
        .wait(1)
        .to({ x: 138.85, y: -118.55 }, 0)
        .wait(1)
        .to({ x: 145.95, y: -121.5 }, 0)
        .wait(1)
        .to({ x: 153.15, y: -124.25 }, 0)
        .wait(1)
        .to({ x: 160.45, y: -126.8 }, 0)
        .wait(1)
        .to({ x: 167.85, y: -129.1 }, 0)
        .wait(1)
        .to({ x: 175.3, y: -131.25 }, 0)
        .wait(1)
        .to({ x: 182.85, y: -133.2 }, 0)
        .wait(1)
        .to({ x: 190.5, y: -134.95 }, 0)
        .wait(1)
        .to({ x: 198.25, y: -136.5 }, 0)
        .wait(1)
        .to({ x: 206.1, y: -137.85 }, 0)
        .wait(1)
        .to({ x: 214, y: -139 }, 0)
        .wait(1)
        .to({ x: 222.05, y: -139.95 }, 0)
        .wait(1)
        .to({ x: 230.15, y: -140.7 }, 0)
        .wait(1)
        .to({ x: 238.35, y: -141.25 }, 0)
        .wait(1)
        .to({ x: 246.65, y: -141.6 }, 0)
        .wait(1)
        .to({ x: 255, y: -141.8 }, 0)
        .wait(1)
        .to({ regX: 0.2, regY: -0.1, x: 259.15, y: -138.5 }, 0)
        .wait(1)
        .to({ regX: -1.8, regY: -1, x: 246.2, y: -140.25 }, 0)
        .wait(1)
        .to({ x: 238.1, y: -139.75 }, 0)
        .wait(1)
        .to({ x: 230.1, y: -139.05 }, 0)
        .wait(1)
        .to({ x: 222.2, y: -138.25 }, 0)
        .wait(1)
        .to({ x: 214.35, y: -137.2 }, 0)
        .wait(1)
        .to({ x: 206.6, y: -136.05 }, 0)
        .wait(1)
        .to({ x: 198.95, y: -134.7 }, 0)
        .wait(1)
        .to({ x: 191.35, y: -133.15 }, 0)
        .wait(1)
        .to({ x: 183.8, y: -131.45 }, 0)
        .wait(1)
        .to({ x: 176.35, y: -129.6 }, 0)
        .wait(1)
        .to({ x: 169, y: -127.55 }, 0)
        .wait(1)
        .to({ x: 161.7, y: -125.35 }, 0)
        .wait(1)
        .to({ x: 154.5, y: -122.95 }, 0)
        .wait(1)
        .to({ x: 147.4, y: -120.35 }, 0)
        .wait(1)
        .to({ x: 140.3, y: -117.6 }, 0)
        .wait(1)
        .to({ x: 133.35, y: -114.65 }, 0)
        .wait(1)
        .to({ x: 126.45, y: -111.55 }, 0)
        .wait(1)
        .to({ x: 119.6, y: -108.25 }, 0)
        .wait(1)
        .to({ x: 112.85, y: -104.75 }, 0)
        .wait(1)
        .to({ x: 106.2, y: -101.05 }, 0)
        .wait(1)
        .to({ x: 99.6, y: -97.2 }, 0)
        .wait(1)
        .to({ x: 93.1, y: -93.15 }, 0)
        .wait(1)
        .to({ x: 86.65, y: -88.9 }, 0)
        .wait(1)
        .to({ x: 80.3, y: -84.45 }, 0)
        .wait(1)
        .to({ x: 74, y: -79.8 }, 0)
        .wait(1)
        .to({ x: 67.8, y: -74.95 }, 0)
        .wait(1)
        .to({ x: 61.65, y: -69.95 }, 0)
        .wait(1)
        .to({ x: 55.6, y: -64.7 }, 0)
        .wait(1)
        .to({ x: 49.65, y: -59.25 }, 0)
        .wait(1)
        .to({ x: 43.75, y: -53.65 }, 0)
        .wait(1)
        .to({ x: 37.9, y: -47.8 }, 0)
        .wait(1)
        .to({ x: 32.15, y: -41.75 }, 0)
        .wait(1)
        .to({ x: 26.5, y: -35.5 }, 0)
        .wait(1)
        .to({ x: 20.9, y: -29.05 }, 0)
        .wait(1)
        .to({ x: 15.35, y: -22.35 }, 0)
        .wait(1)
        .to({ x: 9.95, y: -15.5 }, 0)
        .wait(1)
        .to({ x: 4.55, y: -8.4 }, 0)
        .wait(1)
        .to({ x: -0.75, y: -1.1 }, 0)
        .wait(1),
    );

    // gear01Start
    this.instance = new lib.gear01();
    this.instance.setTransform(-113.3, -112.25);
    new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.gear01(), 3);

    this.instance_1 = new lib.gfxgear01('synched', 0);
    this.instance_1.setTransform(-3, -2.25);
    this.instance_1._off = true;

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.instance }] })
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .wait(1),
    );
    this.timeline.addTween(
      cjs.Tween.get(this.instance_1)
        .wait(1)
        .to({ _off: false }, 0)
        .wait(1)
        .to({ regY: -0.1, rotation: 4.9995, x: 1.65, y: -8.9 }, 0)
        .wait(1)
        .to(
          {
            regY: 0,
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: 9.9988,
            x: 5.55,
            y: -15.65,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0.1, regY: -0.2, rotation: 14.9999, x: 10.55, y: -22.2 }, 0)
        .wait(1)
        .to(
          { regX: -0.1, regY: -0.1, rotation: 20.0004, x: 14.85, y: -28.6 },
          0,
        )
        .wait(1)
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: 25.0006,
            x: 19.75,
            y: -34.8,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: 0.1, regY: -0.1, rotation: 30.0006, x: 24.75, y: -41.15 },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: 34.9994, x: 29.35, y: -47.25 }, 0)
        .wait(1)
        .to(
          { scaleX: 0.9997, scaleY: 0.9997, rotation: 0, x: 40.4, y: -59.2 },
          0,
        )
        .wait(1)
        .to({ rotation: 4.9989, x: 45.4, y: -65.2 }, 0)
        .wait(1)
        .to({ regY: -0.1, rotation: 9.9992, x: 51.9, y: -70.25 }, 0)
        .wait(1)
        .to({ regX: -0.1, rotation: 14.9992, x: 58.1, y: -74.75 }, 0)
        .wait(1)
        .to({ rotation: 20.0004, x: 63.85, y: -80.5 }, 0)
        .wait(1)
        .to({ regY: -0.2, rotation: 25.0004, x: 70.1, y: -85.3 }, 0)
        .wait(1)
        .to(
          {
            regX: 0,
            regY: -0.3,
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: 29.9996,
            x: 76.65,
            y: -90.25,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 35, x: 82.85, y: -95 }, 0)
        .wait(1)
        .to({ rotation: 39.9991, x: 89.85, y: -99 }, 0)
        .wait(1)
        .to({ regX: 0.1, rotation: 45.0012, x: 96.6, y: -103.2 }, 0)
        .wait(1)
        .to(
          {
            regY: -0.4,
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: 50.0008,
            x: 103.4,
            y: -107.7,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 54.9988, x: 110.4, y: -111.45 }, 0)
        .wait(1)
        .to(
          {
            regY: -0.8,
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: 59.9982,
            x: 117.85,
            y: -115.45,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 64.9992, x: 124.8, y: -119.2 }, 0)
        .wait(1)
        .to({ regX: 0, rotation: 69.9997, x: 132.25, y: -122.2 }, 0)
        .wait(1)
        .to({ regY: -0.9, rotation: 74.9994, x: 139.55, y: -125.25 }, 0)
        .wait(1)
        .to({ regY: -0.8, rotation: 79.9989, x: 147.25, y: -126.75 }, 0)
        .wait(1)
        .to(
          { regX: 0.1, regY: -0.9, rotation: 84.9992, x: 155.05, y: -129.2 },
          0,
        )
        .wait(1)
        .to({ regX: 0, rotation: 89.9948, x: 162.3, y: -131.25 }, 0)
        .wait(1)
        .to({ regX: -0.1, regY: -1, rotation: 94.999, x: 169.85, y: -134.3 }, 0)
        .wait(1)
        .to({ rotation: 99.9994, x: 177.35, y: -137.3 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: 105.0005,
            x: 185.1,
            y: -140.25,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 110.0002, x: 192.35, y: -142.25 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: 115.0005,
            x: 200.3,
            y: -143.25,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 120.0002, x: 208.05, y: -144.25 }, 0)
        .wait(1)
        .to({ rotation: 124.9996, x: 216.3, y: -146.25 }, 0)
        .wait(1)
        .to({ rotation: 130.0001, x: 224.3, y: -147.2 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.2,
            scaleX: 0.9991,
            scaleY: 0.9991,
            rotation: 135,
            x: 232.1,
            y: -147.25,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 139.9992, x: 239.8, y: -147.3 }, 0)
        .wait(1)
        .to(
          {
            regY: -1.1,
            scaleX: 0.999,
            scaleY: 0.999,
            rotation: 144.9997,
            x: 248.05,
            y: -146.15,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: -0.4, regY: -1, rotation: 148.9993, x: 254.1, y: -146.3 },
          0,
        )
        .wait(1)
        .to({ startPosition: 0 }, 0)
        .wait(1)
        .to(
          { regX: -0.2, regY: -1.1, rotation: 144.9997, x: 248.05, y: -146.15 },
          0,
        )
        .wait(1)
        .to(
          {
            regY: -1,
            scaleX: 0.9991,
            scaleY: 0.9991,
            rotation: 139.9992,
            x: 239.8,
            y: -147.3,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 135, x: 232.1, y: -147.25 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            scaleX: 0.9992,
            scaleY: 0.9992,
            rotation: 130.0001,
            x: 224.3,
            y: -147.2,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 124.9996, x: 216.3, y: -146.25 }, 0)
        .wait(1)
        .to({ rotation: 120.0002, x: 208.05, y: -144.25 }, 0)
        .wait(1)
        .to({ rotation: 115.0005, x: 200.3, y: -143.25 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9993,
            scaleY: 0.9993,
            rotation: 110.0002,
            x: 192.35,
            y: -142.25,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 105.0005, x: 185.1, y: -140.25 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9994,
            scaleY: 0.9994,
            rotation: 99.9994,
            x: 177.35,
            y: -137.3,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 94.999, x: 169.85, y: -134.3 }, 0)
        .wait(1)
        .to({ regX: 0, regY: -0.9, rotation: 89.9948, x: 162.3, y: -131.25 }, 0)
        .wait(1)
        .to({ regX: 0.1, rotation: 84.9992, x: 155.05, y: -129.2 }, 0)
        .wait(1)
        .to(
          { regX: 0, regY: -0.8, rotation: 79.9989, x: 147.25, y: -126.75 },
          0,
        )
        .wait(1)
        .to({ regY: -0.9, rotation: 74.9994, x: 139.55, y: -125.25 }, 0)
        .wait(1)
        .to({ regY: -0.8, rotation: 69.9997, x: 132.25, y: -122.2 }, 0)
        .wait(1)
        .to({ regX: 0.1, rotation: 64.9992, x: 124.8, y: -119.2 }, 0)
        .wait(1)
        .to({ rotation: 59.9982, x: 117.85, y: -115.45 }, 0)
        .wait(1)
        .to(
          {
            regY: -0.4,
            scaleX: 0.9995,
            scaleY: 0.9995,
            rotation: 54.9988,
            x: 110.4,
            y: -111.45,
          },
          0,
        )
        .wait(1)
        .to({ rotation: 50.0008, x: 103.4, y: -107.7 }, 0)
        .wait(1)
        .to(
          {
            regY: -0.3,
            scaleX: 0.9996,
            scaleY: 0.9996,
            rotation: 45.0012,
            x: 96.6,
            y: -103.2,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0, rotation: 39.9991, x: 89.85, y: -99 }, 0)
        .wait(1)
        .to({ rotation: 35, x: 82.85, y: -95 }, 0)
        .wait(1)
        .to({ rotation: 29.9996, x: 76.65, y: -90.25 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: -0.2,
            scaleX: 0.9997,
            scaleY: 0.9997,
            rotation: 25.0004,
            x: 70.1,
            y: -85.3,
          },
          0,
        )
        .wait(1)
        .to({ regY: -0.1, rotation: 20.0004, x: 63.85, y: -80.5 }, 0)
        .wait(1)
        .to({ rotation: 14.9992, x: 58.1, y: -74.75 }, 0)
        .wait(1)
        .to({ regX: 0, rotation: 9.9992, x: 51.9, y: -70.25 }, 0)
        .wait(1)
        .to({ regY: 0, rotation: 4.9989, x: 45.4, y: -65.2 }, 0)
        .wait(1)
        .to({ rotation: 0, x: 40.4, y: -59.2 }, 0)
        .wait(1)
        .to(
          {
            scaleX: 0.9998,
            scaleY: 0.9998,
            rotation: 34.9994,
            x: 29.35,
            y: -47.25,
          },
          0,
        )
        .wait(1)
        .to(
          { regX: 0.1, regY: -0.1, rotation: 30.0006, x: 24.75, y: -41.15 },
          0,
        )
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: 25.0006, x: 19.75, y: -34.8 }, 0)
        .wait(1)
        .to(
          {
            regX: -0.1,
            regY: -0.1,
            scaleX: 0.9999,
            scaleY: 0.9999,
            rotation: 20.0004,
            x: 14.85,
            y: -28.6,
          },
          0,
        )
        .wait(1)
        .to({ regX: 0.1, regY: -0.2, rotation: 14.9999, x: 10.55, y: -22.2 }, 0)
        .wait(1)
        .to({ regX: 0, regY: 0, rotation: 9.9988, x: 5.55, y: -15.65 }, 0)
        .wait(1)
        .to(
          {
            regY: -0.1,
            scaleX: 1,
            scaleY: 1,
            rotation: 4.9995,
            x: 1.65,
            y: -8.9,
          },
          0,
        )
        .wait(1)
        .to({ regY: 0, rotation: 0, x: -3, y: -7.25 }, 0)
        .wait(1),
    );

    // arrow
    this.instance_2 = new lib.arr4('synched', 0);
    this.instance_2.setTransform(
      192,
      -134.95,
      1,
      1,
      -29.9992,
      0,
      0,
      38.5,
      11.5,
    );
    this.instance_2._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_2)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(77),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-113.3, -259, 470.7, 367.3);

  (lib.GameStage = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // Layer 2
    this.arrowD = new lib.arrow03();
    this.arrowD.name = 'arrowD';
    this.arrowD.setTransform(-75.95, -121);

    this.arrowC1 = new lib.arrow04();
    this.arrowC1.name = 'arrowC1';
    this.arrowC1.setTransform(-3.65, -39.05, 1, 1, 0, 0, 180, 74.4, 92.2);

    this.arrowB = new lib.arrow02();
    this.arrowB.name = 'arrowB';
    this.arrowB.setTransform(-10.8, -2.35, 1, 1, 0, 0, 180, -80, 93.2);

    this.arrowA = new lib.arrow01();
    this.arrowA.name = 'arrowA';
    this.arrowA.setTransform(9, -15.8, 1, 1, 0, 0, 0, -80, 93.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.arrowA },
            { t: this.arrowB },
            { t: this.arrowC1 },
            { t: this.arrowD },
          ],
        })
        .wait(1),
    );

    // gear03RightStart
    this.gearC = new lib.gear03RightStart();
    this.gearC.name = 'gearC';
    this.gearC.setTransform(-4.5, 192.5);

    this.timeline.addTween(cjs.Tween.get(this.gearC).wait(1));

    // gear02Start
    this.gearB = new lib.gear02Start();
    this.gearB.name = 'gearB';
    this.gearB.setTransform(251.45, -248.35);

    this.timeline.addTween(cjs.Tween.get(this.gearB).wait(1));

    // gear01Start
    this.gearA = new lib.gear01Start();
    this.gearA.name = 'gearA';
    this.gearA.setTransform(-253.5, -248.4);

    this.timeline.addTween(cjs.Tween.get(this.gearA).wait(1));

    // gearCenter
    this.gearMID = new lib.gfxgearCenter();
    this.gearMID.name = 'gearMID';
    this.gearMID.setTransform(-2, -100);

    this.timeline.addTween(cjs.Tween.get(this.gearMID).wait(1));

    // additionGrid
    this.muteBtn = new lib.Scoreboard_muteBtn();
    this.muteBtn.name = 'muteBtn';
    this.muteBtn.setTransform(22.5, 410.95);

    this.musicBtn = new lib.Scoreboard_musicBtn();
    this.musicBtn.name = 'musicBtn';
    this.musicBtn.setTransform(-17.5, 410.95);

    this.addChart = new lib.additionGrid();
    this.addChart.name = 'addChart';
    this.addChart.setTransform(-451.75, 174, 1.1573, 1.1551);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.addChart },
            { t: this.musicBtn },
            { t: this.muteBtn },
          ],
        })
        .wait(1),
    );

    // subtractionGrid
    this.subtractChart = new lib.subtractionGrid();
    this.subtractChart.name = 'subtractChart';
    this.subtractChart.setTransform(
      322.4,
      280.8,
      1.1573,
      1.1555,
      0,
      0,
      0,
      100.6,
      100.6,
    );

    this.timeline.addTween(cjs.Tween.get(this.subtractChart).wait(1));

    // multiplicationGrid
    this.multiplyChart = new lib.multiplicationGrid();
    this.multiplyChart.name = 'multiplyChart';
    this.multiplyChart.setTransform(
      -320.25,
      272.85,
      1.0893,
      1.1009,
      0,
      0,
      0,
      120.7,
      98.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.multiplyChart).wait(1));

    // divisionGrid
    this.divideChart = new lib.DivisionGrid();
    this.divideChart.name = 'divideChart';
    this.divideChart.setTransform(
      330.55,
      291.4,
      1.0893,
      1.1013,
      0,
      0,
      0,
      129.1,
      115.2,
    );

    this.timeline.addTween(cjs.Tween.get(this.divideChart).wait(1));

    // left bottom
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#414042')
      .ss(2)
      .p(
        'AXr40I0QAAIhQAAI33AAQgwAAgiAiQgiAhAAAvMAAAAuEQAAAvAiAhQAiAiAwAAIZHAAIUQAB',
      );
    this.shape.setTransform(-325.3996, 282.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .lf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CECAC9',
          '#A8A4A7',
          '#8A878D',
          '#F3F4F4',
          '#E5E5E6',
          '#C0BEC0',
          '#848084',
          '#7F7B80',
          '#D1D3D4',
          '#A7A9AC',
        ],
        [0, 0, 0.063, 0.184, 0.263, 0.522, 0.584, 0.702, 0.863, 0.875, 1, 1],
        -247.5,
        0.1,
        869.7,
        0.1,
      )
      .s()
      .p('AqHY0MAAAgxoIUPAAMAAAAxpg');
    this.shape_1.setTransform(-238.7, 282.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .lf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CECAC9',
          '#A8A4A7',
          '#8A878D',
          '#F3F4F4',
          '#E5E5E6',
          '#C0BEC0',
          '#848084',
          '#7F7B80',
          '#D1D3D4',
          '#A7A9AC',
        ],
        [0, 0, 0.063, 0.184, 0.263, 0.522, 0.584, 0.702, 0.863, 0.875, 1, 1],
        -88.5,
        0.2,
        1028.7,
        0.2,
      )
      .s()
      .p('ArpY0QgvAAgjghQgigiAAguMAAAguFQAAgvAighQAjgiAvAAIX3AAIBQAAMAAAAxog');
    this.shape_2.setTransform(-389.7, 282.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // center bottom
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#414042')
      .ss(2)
      .p(
        'AbW4xIgDAAQgZAAgUASQgUARgKAdIAAAAQj+NHm1HsQnCH6oNAAQiWAAiRgqQlnholClqQm2nuj+tJQgKgcgUgRQgUgRgXAAIgOAAA7VY0MA2rAAC',
      );
    this.shape_3.setTransform(0.45, 282.675);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .lf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CECAC9',
          '#A8A4A7',
          '#8A878D',
          '#F3F4F4',
          '#E5E5E6',
          '#C0BEC0',
          '#848084',
          '#7F7B80',
          '#D1D3D4',
          '#A7A9AC',
        ],
        [0, 0, 0.063, 0.184, 0.263, 0.522, 0.584, 0.702, 0.863, 0.875, 1, 1],
        -397.5,
        0,
        398.6,
        0,
      )
      .s()
      .p(
        'A7VY0MAAAgxpIAOAAQAXAAAUARQAUARALAcQD+NJG1HuQFBFqFoBoQCQAqCWAAQIOAAHBn6QG1nsD+tHIABAAQAKgdAUgRQAUgSAZAAIADAAMAAAAxng',
      );
    this.shape_4.setTransform(0.45, 282.675);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .wait(1),
    );

    // right bottom
    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#414042')
      .ss(2)
      .p('A1DV3MAoZAABQAqAAAdgdQAdgeAAgpMAAAgonQAAgpgdgeQgdgdgqAAMgoZAAA');
    this.shape_5.setTransform(326.016, 282.8931, 1.1392, 1.1345);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .lf(
        [
          '#E4E2DF',
          '#DDD9D6',
          '#CECAC9',
          '#A8A4A7',
          '#8A878D',
          '#F3F4F4',
          '#E5E5E6',
          '#C0BEC0',
          '#848084',
          '#7F7B80',
          '#D1D3D4',
          '#A7A9AC',
        ],
        [0, 0, 0.063, 0.184, 0.263, 0.522, 0.584, 0.702, 0.863, 0.875, 1, 1],
        -824.6,
        -0.1,
        135.3,
        -0.1,
      )
      .s()
      .p('A0+V3MAAAgruMAoZAAAQAqAAAdAeQAdAdAAApMAAAAonQAAAqgdAcQgdAegqAAg');
    this.shape_6.setTransform(325.4465, 282.8931, 1.1392, 1.1345);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameStage,
    new cjs.Rectangle(-480.3, -360.6, 959.8, 828.2),
    null,
  );

  (lib.comsuntexsymbolsScoreboard = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.progressPanel = new lib.ProgressPanel();
    this.progressPanel.name = 'progressPanel';
    this.progressPanel.setTransform(283.95, 20.7, 1, 1, 0, 0, 0, 274.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.progressPanel).wait(1));

    // buttons
    this.muteBtn = new lib.Scoreboard_muteBtn();
    this.muteBtn.name = 'muteBtn';
    this.muteBtn.setTransform(778.45, 20);

    this.musicBtn = new lib.Scoreboard_musicBtn();
    this.musicBtn.name = 'musicBtn';
    this.musicBtn.setTransform(738.45, 20);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.musicBtn }, { t: this.muteBtn }] })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('Eg+zADSIAAmjMB9nAAAIAAGjg');
    this.shape.setTransform(400, 21);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsScoreboard,
    new cjs.Rectangle(-2, 0, 804, 42),
    null,
  );

  (lib.PracticeMenu = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#003399')
      .s()
      .p('AgUBCIAAguIApAAIAAAugAgUgTIAAguIApAAIAAAug');
    this.shape.setTransform(536.375, 262.175);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#003399')
      .s()
      .p(
        'AgzBKQgMgSAAgfQgBgRAFgMQAEgNAIgJQAHgJAKgEQAKgGAMAAQAKAAAGACIAPAHIAAg4IAqAAIAAC1IgqAAIAAgNIgJAHIgJAFIgJAEIgLABQgWAAgOgTgAgOgDQgIAIAAATQAAATAHAJQAFAJANAAQAFAAAFgCQAGgCAEgEIAAg/IgIgDIgIgBQgOAAgHALg',
      );
    this.shape_1.setTransform(524, 259.8);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#003399')
      .s()
      .p(
        'AAUBDIAAhBIAAgPQgBgHgCgEQgCgFgEgCQgEgBgGAAIgKABIgLAGIAABcIgpAAIAAiCIApAAIAAAOQALgIAJgFQAJgEALgBQAUAAALANQALAMAAAZIAABUg',
      );
    this.shape_2.setTransform(509.275, 262);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#003399')
      .s()
      .p(
        'AgyA4QgLgNAAgZIAAhUIAqAAIAABAIAAAQQABAHACAEQACAEAEACQADACAHAAQAEAAAGgCQAGgBAFgFIAAhbIApAAIAACCIgpAAIAAgPQgLAKgJAEQgIAEgMABQgUAAgLgMg',
      );
    this.shape_3.setTransform(493.825, 262.35);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#003399')
      .s()
      .p(
        'AgxAzQgSgTAAggQAAggASgSQASgTAfAAQAgAAASATQASASAAAgQAAAggSATQgSATggAAQgfAAgSgTgAgJgmQgEACgEAFQgDAEgCAIQgDAIAAALQAAAMACAIQACAHADAFQAEAEAEACQAGACAFAAQAEAAAGgCQAEgCAEgEQADgFACgHQACgHAAgNQAAgKgCgIQgCgIgDgFQgEgFgEgCQgFgCgGAAQgEAAgFACg',
      );
    this.shape_4.setTransform(478.8, 262.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#003399')
      .s()
      .p(
        'AgrBCIAAiCIApAAIAAASIAHgGIAJgGIAKgFQAGgCAFAAIAFAAIAEABIAAAmIgDAAIgHgBIgKgBQgGAAgHACIgNAFIAABXg',
      );
    this.shape_5.setTransform(466.975, 262.15);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#003399')
      .s()
      .p(
        'AgtAzQgTgRgBghQAAggATgSQASgUAhABQAeAAAPAPQAPARABAeIAAAOIhZAAQABAJACAHQAEAFAFAEQAGADAGADQAGABAJAAIAOgBIAMgFIAKgEIAHgFIAFAAIAAAiIgKADIgMAEIgNADIgRABQgkgBgVgSgAgQgjQgGAHgBAMIAwAAQAAgNgGgHQgFgGgMgBQgLAAgHAIg',
      );
    this.shape_6.setTransform(446.85, 262.15);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#003399')
      .s()
      .p(
        'AgNBBQgNgEgLgIQgKgJgFgNQgGgNABgSQAAgRAFgOQAGgNAKgIQALgJANgDQAMgEAPAAQAKAAALACQAMADALAFIAAAjIgGAAIgGgFIgIgFQgEgDgGgBQgGgCgHAAQgPAAgIALQgIALgBARQAAAUAKAKQAIAKAPAAQAIAAAGgCQAGgCAEgCIAHgFIAFgFIAGAAIAAAjIgJAEIgJADIgMACIgNABQgQAAgNgEg',
      );
    this.shape_7.setTransform(433.5, 262.175);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#003399')
      .s()
      .p('AgUBbIAAiCIAoAAIAACCgAgVg6IAAggIArAAIAAAgg');
    this.shape_8.setTransform(423.425, 259.625);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#003399')
      .s()
      .p(
        'AgUBMQgLgLAAgXIAAg9IgQAAIAAgcIAQAAIAAgmIAnAAIAAAmIAoAAIAAAcIgoAAIAAAuIABAMQAAAFACAEQACAEADADQAFACAIAAIAJgBIAGgDIAEAAIAAAdIgOADIgTABQgXAAgMgKg',
      );
    this.shape_9.setTransform(414.9, 260.425);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#003399')
      .s()
      .p(
        'AgNBBQgOgEgKgIQgJgJgGgNQgFgNgBgSQAAgRAHgOQAGgNAJgIQALgJANgDQAMgEAOAAQAMAAALACQAKADAMAFIAAAjIgGAAIgGgFIgIgFQgEgDgGgBQgFgCgIAAQgPAAgHALQgJALAAARQAAAUAJAKQAIAKAPAAQAIAAAGgCQAGgCAEgCIAHgFIAFgFIAGAAIAAAjIgJAEIgKADIgKACIgOABQgQAAgNgEg',
      );
    this.shape_10.setTransform(403.65, 262.175);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#003399')
      .s()
      .p(
        'AgxA6QgMgMABgSQgBgPAGgIQAGgIALgGQALgFAQgCQAOgCASgBIAAgBQAAgLgIgEQgIgFgPABQgIAAgJACQgKADgJAEIgDAAIAAggIATgEQANgCAOAAQAigBAPAMQAPALAAAYIAABYIgoAAIAAgOIgIAHIgJAFIgJAEQgGABgJABQgSgBgLgLgAAEAGIgMADQgFACgDAEQgDAEAAAGQAAAJAFADQAFAEAJAAQAFAAAGgCQAFgDAFgEIAAgcIgRACg',
      );
    this.shape_11.setTransform(389.6, 262.15);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#003399')
      .s()
      .p(
        'AgrBCIAAiCIApAAIAAASIAHgGIAJgGIAKgFQAGgCAFAAIAFAAIAEABIAAAmIgDAAIgHgBIgKgBQgGAAgHACIgNAFIAABXg',
      );
    this.shape_12.setTransform(378.425, 262.15);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#003399')
      .s()
      .p(
        'Ag/BcIAAizIAoAAIAAANQAJgHAKgFQAJgFAMAAQAWAAANASQAMASAAAgQAAAegPATQgQAUgYAAQgJAAgHgCIgQgHIAAA3gAgLg5QgGABgGAEIAABBIAIACIAJABQAOAAAIgKQAHgJAAgUQAAgTgGgIQgGgJgLAAQgGAAgFACg',
      );
    this.shape_13.setTransform(365.35, 264.425);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#003399')
      .s()
      .p(
        'AgxA6QgMgMAAgSQAAgPAGgIQAGgIALgGQALgFAQgCQAOgCASgBIAAgBQAAgLgIgEQgIgFgPABQgIAAgJACQgKADgJAEIgDAAIAAggIATgEQANgCAPAAQAggBAQAMQAPALAAAYIAABYIgoAAIAAgOIgIAHIgJAFIgJAEQgGABgJABQgSgBgLgLgAAEAGIgMADQgFACgDAEQgDAEAAAGQAAAJAFADQAFAEAJAAQAFAAAFgCQAGgDAFgEIAAgcIgRACg',
      );
    this.shape_14.setTransform(342.7, 262.15);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#003399')
      .s()
      .p(
        'AgUBMQgLgLAAgXIAAg9IgQAAIAAgcIAQAAIAAgmIAnAAIAAAmIAoAAIAAAcIgoAAIAAAuIABAMQAAAFACAEQACAEADADQAFACAIAAIAJgBIAGgDIAEAAIAAAdIgOADIgTABQgYAAgLgKg',
      );
    this.shape_15.setTransform(324, 260.425);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#003399')
      .s()
      .p(
        'AgNBBQgOgEgKgIQgJgJgGgNQgFgNgBgSQAAgRAHgOQAGgNAJgIQALgJANgDQAMgEAOAAQAMAAALACQAKADAMAFIAAAjIgGAAIgGgFIgIgFQgEgDgGgBQgFgCgIAAQgPAAgHALQgJALAAARQgBAUAKAKQAIAKAPAAQAIAAAGgCQAGgCAEgCIAHgFIAFgFIAGAAIAAAjIgJAEIgKADIgKACIgOABQgQAAgNgEg',
      );
    this.shape_16.setTransform(312.75, 262.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#003399')
      .s()
      .p(
        'AgsAzQgVgRABghQAAggASgSQATgUAgABQAeAAAQAPQAPARgBAeIAAAOIhZAAQABAJAEAHQADAFAGAEQAEADAHADQAHABAIAAIAOgBIANgFIAJgEIAHgFIAEAAIAAAiIgJADIgLAEIgOADIgSABQgkgBgTgSgAgQgjQgHAHgBAMIAxAAQAAgNgGgHQgGgGgMgBQgKAAgHAIg',
      );
    this.shape_17.setTransform(299.2, 262.15);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics.f('#003399').s().p('AgTBbIAAi1IAnAAIAAC1g');
    this.shape_18.setTransform(288.4, 259.625);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#003399')
      .s()
      .p(
        'AgtAzQgUgRABghQAAggASgSQATgUAgABQAeAAAQAPQAOARAAAeIAAAOIhZAAQACAJADAHQADAFAGAEQAFADAFADQAIABAIAAIAOgBIANgFIAJgEIAHgFIAEAAIAAAiIgJADIgLAEIgOADIgSABQgjgBgVgSgAgQgjQgHAHgBAMIAxAAQAAgNgGgHQgGgGgMgBQgKAAgHAIg',
      );
    this.shape_19.setTransform(277.7, 262.15);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#003399')
      .s()
      .p(
        'AgoBXQgPgEgNgGIAAgqIADAAQANAMAQAGQARAGAOAAIAJgBIAKgDQAFgCADgDQADgEAAgGQAAgGgFgFQgGgEgHgBIgSgFIgSgFQgVgHgIgLQgKgMABgTQAAgYAUgPQAVgPAeAAQAPAAAQADQAPADAMAFIAAAoIgDAAQgKgIgOgGQgOgGgPAAIgJABQgFABgEACQgEACgEAEQgCAEAAAEQgBAHAFAEQAFAEANADIAQAEIASAFQASAGAJALQAIALAAASQAAAagTAQQgVAPgiAAQgUAAgPgDg',
      );
    this.shape_20.setTransform(263.15, 260.025);

    this.round4Btn = new lib.roundBtn4();
    this.round4Btn.name = 'round4Btn';
    this.round4Btn.setTransform(550, 330.6, 1.1111, 1.1106);

    this.round3Btn = new lib.roundBtn3();
    this.round3Btn.name = 'round3Btn';
    this.round3Btn.setTransform(450, 330.6, 1.1111, 1.1106);

    this.round2Btn = new lib.roundBtn2();
    this.round2Btn.name = 'round2Btn';
    this.round2Btn.setTransform(350, 330.6, 1.1111, 1.1106);

    this.round1Btn = new lib.roundBtn1();
    this.round1Btn.name = 'round1Btn';
    this.round1Btn.setTransform(250, 330.6, 1.1111, 1.1106);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#003399')
      .s()
      .p('AgYBfIAAgiIAxAAIAAAigAgTAoIgFiFIAxAAIgFCFg');
    this.shape_21.setTransform(559.175, 189.8);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#003399')
      .s()
      .p(
        'AgwA4QgWgUAAgjQAAgiAUgUQAUgWAkABQAgAAAQARQARASAAAgIAAAQIhhAAQABAJAEAIQAEAGAFAEQAGAEAGACQAIABAJAAQAIAAAIgBQAHgCAGgDIALgFIAHgFIAFAAIAAAkIgKAEIgNAEIgOADIgTABQgoAAgVgTgAgSgmQgGAIgCANIA1AAQAAgOgGgHQgGgIgNAAQgMAAgIAIg',
      );
    this.shape_22.setTransform(547, 192.1);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#003399')
      .s()
      .p(
        'AgOBHQgPgFgLgJQgKgJgGgOQgGgOAAgTQAAgUAGgOQAHgPALgJQALgJAOgEQANgEAQAAQAMAAAMADQALACAMAGIAAAmIgFAAIgHgFIgIgGQgFgDgGgBQgGgCgIAAQgRAAgIAMQgKALAAAUQAAAVAKALQAJAKARAAQAIAAAHgCIALgEIAHgGIAGgFIAFAAIAAAmIgIAEIgLADIgMADIgPABQgRAAgOgEg',
      );
    this.shape_23.setTransform(532.525, 192.125);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#003399')
      .s()
      .p('AgVBjIAAiOIAsAAIAACOgAgXg/IAAgjIAvAAIAAAjg');
    this.shape_24.setTransform(521.6, 189.375);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#003399')
      .s()
      .p(
        'AgWBSQgMgLAAgaIAAhBIgRAAIAAgfIARAAIAAgpIArAAIAAApIArAAIAAAfIgrAAIAAAxIAAANQABAGACAEQABAFAFACQAEADAJAAIAJgCIAIgCIAEAAIAAAfIgPADIgUABQgaAAgNgLg',
      );
    this.shape_25.setTransform(512.375, 190.225);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#003399')
      .s()
      .p(
        'AgOBHQgPgFgLgJQgKgJgGgOQgGgOAAgTQAAgUAGgOQAHgPALgJQALgJAOgEQANgEAQAAQAMAAAMADQALACAMAGIAAAmIgFAAIgHgFIgIgGQgFgDgGgBQgGgCgIAAQgRAAgIAMQgKALAAAUQAAAVAKALQAJAKARAAQAIAAAHgCIALgEIAHgGIAGgFIAFAAIAAAmIgIAEIgLADIgMADIgPABQgRAAgOgEg',
      );
    this.shape_26.setTransform(500.175, 192.125);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#003399')
      .s()
      .p(
        'Ag1A+QgNgMAAgUQAAgPAGgKQAHgJAMgGQAMgGARgCQAPgCAUgBIAAgBQAAgMgJgEQgJgFgQAAQgIAAgLADQgKADgKAEIgEAAIAAgiIAVgFQAPgCAPAAQAkAAARAMQARAMAAAZIAABgIgtAAIAAgPIgIAHQgDADgHADIgKAFQgGABgKAAQgTAAgMgNgAAEAGIgNAEQgFACgEAEQgDAEAAAHQAAAKAFAEQAGADAKAAQAFAAAGgCQAGgDAFgFIAAgeIgSACg',
      );
    this.shape_27.setTransform(484.975, 192.125);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#003399')
      .s()
      .p(
        'AgvBIIAAiOIAtAAIAAAUIAHgGIAKgHQAFgDAGgDQAHgBAFgBIAFAAIAFABIAAAqIgEAAIgHgBIgLgBQgHAAgHACIgOAFIAABfg',
      );
    this.shape_28.setTransform(472.875, 192.1);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#003399')
      .s()
      .p(
        'AhFBjIAAjBIAtAAIAAAOQAJgIAKgFQAKgGANAAQAYAAAOAUQAOAUAAAhQAAAigRAVQgSAVgZAAQgKAAgIgDQgHgCgJgFIAAA7gAgNg+QgGACgFAEIAABHIAIABIAKABQAOAAAJgKQAHgKAAgWQABgUgHgKQgGgJgNAAQgGAAgGACg',
      );
    this.shape_29.setTransform(458.75, 194.55);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics.f('#003399').s().p('AgVBjIAAjFIArAAIAADFg');
    this.shape_30.setTransform(438.525, 189.375);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics.f('#003399').s().p('AgVBjIAAjFIArAAIAADFg');
    this.shape_31.setTransform(430.675, 189.375);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#003399')
      .s()
      .p('AgVBjIAAiOIAsAAIAACOgAgWg/IAAgjIAuAAIAAAjg');
    this.shape_32.setTransform(422.8, 189.375);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#003399')
      .s()
      .p(
        'AgWBSQgMgLAAgaIAAhBIgRAAIAAgfIARAAIAAgpIArAAIAAApIArAAIAAAfIgrAAIAAAxIAAANQABAGACAEQABAFAFACQAEADAJAAIAJgCIAIgCIAEAAIAAAfIgPADIgUABQgaAAgNgLg',
      );
    this.shape_33.setTransform(413.575, 190.225);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#003399')
      .s()
      .p(
        'AglBIQgOgEgJgEIAAgmIAEAAIAHAGIALAGIAOAFQAIACAJAAQAIAAAIgDQAHgDAAgGQAAgFgDgDQgEgCgJgDIgMgCIgOgEQgRgFgIgJQgJgLAAgQQAAgKAFgIQAFgJAIgGQAJgHAMgDQAMgEAPAAQAPAAANADQAMADAJAEIAAAkIgDAAIgIgFIgJgFIgNgEIgOgCQgJAAgHAEQgGADAAAFQAAAFADADQAEADAJACIAOADQAHABAHADQAPAFAIAIQAIAKAAAQQAAAKgFAJQgEAJgJAGQgJAHgMAEQgNADgQAAQgQAAgOgDg',
      );
    this.shape_34.setTransform(401.55, 192.125);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#003399')
      .s()
      .p(
        'AAWBJIAAhGIgBgRQAAgIgCgEQgCgFgFgCQgEgCgHAAQgFAAgFACQgGACgGAEIAABkIgtAAIAAiNIAtAAIAAAPQALgJAKgFQAJgFANAAQAWAAALAOQAMANAAAaIAABcg',
      );
    this.shape_35.setTransform(378.825, 191.925);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#003399')
      .s()
      .p(
        'Ag1A+QgNgMAAgUQAAgPAGgKQAHgJAMgGQAMgGARgCQAPgCAUgBIAAgBQAAgMgJgEQgJgFgQAAQgIAAgLADQgKADgKAEIgEAAIAAgiIAVgFQAPgCAPAAQAkAAARAMQARAMAAAZIAABgIgtAAIAAgPIgIAHQgDADgHADIgKAFQgGABgKAAQgTAAgMgNgAAEAGIgNAEQgFACgEAEQgDAEAAAHQAAAKAFAEQAGADAKAAQAFAAAGgCQAGgDAFgFIAAgeIgSACg',
      );
    this.shape_36.setTransform(362.225, 192.125);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#003399')
      .s()
      .p(
        'AgOBHQgPgFgLgJQgKgJgGgOQgGgOAAgTQAAgUAGgOQAHgPALgJQALgJAOgEQANgEAQAAQAMAAAMADQALACAMAGIAAAmIgFAAIgHgFIgIgGQgFgDgGgBQgGgCgIAAQgRAAgIAMQgKALAAAUQAAAVAKALQAJAKARAAQAIAAAHgCIALgEIAHgGIAGgFIAFAAIAAAmIgIAEIgLADIgMADIgPABQgRAAgOgEg',
      );
    this.shape_37.setTransform(348.175, 192.125);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#003399')
      .s()
      .p(
        'Ag2A8QgMgOAAgbIAAhbIAtAAIAABGIAAARQABAHACAFQACAFAEACQAFACAHAAQAEAAAGgCQAHgCAFgEIAAhkIAtAAIAACNIgtAAIAAgPQgLAJgKAFQgJAFgNAAQgVAAgMgNg',
      );
    this.shape_38.setTransform(325.225, 192.325);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#003399')
      .s()
      .p(
        'Ag1A4QgUgVAAgjQAAgjAUgUQATgUAiAAQAjAAATAVQAUAUAAAiQAAAjgUAVQgTAUgjAAQgiAAgTgUgAgKgpQgFACgEAFQgEAFgCAJQgCAIAAAMQAAANACAIQACAIAEAFQADAFAGADQAFACAFAAQAGAAAFgCQAGgDADgEQAEgGACgHQACgIAAgOQAAgLgCgJQgCgIgEgFQgEgGgFgCQgFgCgGAAQgFAAgFACg',
      );
    this.shape_39.setTransform(308.925, 192.125);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#003399')
      .s()
      .p('AgrBhIAVg4Ig0iJIAvAAIAdBZIAchZIAtAAIhIDBg');
    this.shape_40.setTransform(293.425, 194.75);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#003399')
      .s()
      .p(
        'AgWBSQgMgLAAgaIAAhBIgRAAIAAgfIARAAIAAgpIArAAIAAApIArAAIAAAfIgrAAIAAAxIAAANQABAGACAEQABAFAFACQAEADAJAAIAJgCIAIgCIAEAAIAAAfIgPADIgUABQgaAAgNgLg',
      );
    this.shape_41.setTransform(273.025, 190.225);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f('#003399')
      .s()
      .p(
        'Ag2A8QgMgOAAgbIAAhbIAtAAIAABGIAAARQABAHACAFQACAFAEACQAFACAHAAQAEAAAGgCQAHgCAFgEIAAhkIAtAAIAACNIgtAAIAAgPQgLAJgKAFQgJAFgNAAQgVAAgMgNg',
      );
    this.shape_42.setTransform(259.175, 192.325);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#003399')
      .s()
      .p(
        'AgIBiQgIgDgJgFIgCAHIgqAAIAAjEIAsAAIAABGQAKgJALgFQAIgFAOAAQAYAAAOATQAOAUAAAhQAAAigSAVQgQAVgbAAQgJAAgIgCgAgNgMQgGACgGAEIAABGIAJADIAJABQAQAAAIgLQAIgLAAgVQgBgVgGgJQgHgJgMAAQgGAAgGACg',
      );
    this.shape_43.setTransform(243.15, 189.525);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics.f('#003399').s().p('AgjAwIAZhgIAuAAIgsBgg');
    this.shape_44.setTransform(606.475, 161.75);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#003399')
      .s()
      .p(
        'AglBIQgOgEgJgEIAAgmIAEAAIAHAGIALAGIAOAFQAIACAJAAQAIAAAIgDQAHgDAAgGQAAgFgDgDQgEgCgJgDIgMgCIgOgEQgRgFgIgJQgJgLAAgQQAAgKAFgIQAFgJAIgGQAJgHAMgDQAMgEAPAAQAPAAANADQAMADAJAEIAAAkIgDAAIgIgFIgKgFIgMgEIgOgCQgJAAgHAEQgGADAAAFQAAAFADADQAEADAJACIAOADQAHABAHADQAPAFAIAIQAIAKAAAQQAAAKgFAJQgEAJgJAGQgJAHgMAEQgNADgQAAQgQAAgOgDg',
      );
    this.shape_45.setTransform(596.4, 154.775);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#003399')
      .s()
      .p(
        'AgvBIIAAiOIAtAAIAAAUIAHgGIAKgHQAFgDAGgDQAHgCAFAAIAFAAIAFABIAAAqIgEAAIgHgBIgLgBQgHAAgHACIgOAFIAABfg',
      );
    this.shape_46.setTransform(584.775, 154.75);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#003399')
      .s()
      .p(
        'AgxA4QgVgUAAgjQAAgiAUgUQAUgWAjABQAhAAARARQAQASAAAgIAAAQIhgAAQAAAJAEAIQADAGAGAEQAGAEAHACQAHABAJAAQAIAAAHgBQAIgCAGgDIALgFIAHgFIAEAAIAAAkIgJAEIgNAEIgPADIgSABQgoAAgWgTgAgSgmQgGAIgBANIA0AAQAAgOgGgHQgGgIgNAAQgMAAgIAIg',
      );
    this.shape_47.setTransform(570.6, 154.75);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#003399')
      .s()
      .p('AATBjIgmg+IgHAJIAAA1IgsAAIAAjFIAsAAIAABuIApg3IA1AAIgyA9IA1BRg');
    this.shape_48.setTransform(556.025, 152.025);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#003399')
      .s()
      .p(
        'AgOBHQgPgFgLgJQgKgJgGgOQgGgOAAgTQAAgUAGgOQAHgPALgJQALgJAOgEQANgEAQAAQAMAAAMADQALACAMAGIAAAmIgFAAIgHgFIgIgGQgFgDgGgBQgGgCgIAAQgRAAgIAMQgKALAAAUQAAAVAKALQAJAKARAAQAIAAAHgCIALgEIAHgGIAGgFIAFAAIAAAmIgIAEIgLADIgMADIgPABQgRAAgOgEg',
      );
    this.shape_49.setTransform(540.475, 154.775);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#003399')
      .s()
      .p('AgVBjIAAiOIAsAAIAACOgAgWg/IAAgjIAtAAIAAAjg');
    this.shape_50.setTransform(529.55, 152.025);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#003399')
      .s()
      .p(
        'AgWBSQgMgLAAgaIAAhBIgRAAIAAgfIARAAIAAgpIArAAIAAApIArAAIAAAfIgrAAIAAAxIAAANQABAGACAEQABAFAFACQAEADAJAAIAJgCIAIgCIAEAAIAAAfIgPADIgUABQgaAAgNgLg',
      );
    this.shape_51.setTransform(520.325, 152.875);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#003399')
      .s()
      .p(
        'AglBIQgOgEgJgEIAAgmIAEAAIAHAGIALAGIAPAFQAHACAJAAQAJAAAHgDQAHgDAAgGQAAgFgDgDQgEgCgJgDIgMgCIgOgEQgQgFgJgJQgJgLABgQQgBgKAFgIQAEgJAJgGQAJgHAMgDQAMgEAPAAQAPAAAMADQANADAJAEIAAAkIgDAAIgIgFIgKgFIgMgEIgOgCQgJAAgHAEQgGADAAAFQAAAFADADQAEADAKACIANADQAHABAHADQAPAFAIAIQAIAKAAAQQAAAKgEAJQgGAJgIAGQgJAHgMAEQgNADgQAAQgQAAgOgDg',
      );
    this.shape_52.setTransform(508.3, 154.775);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#003399')
      .s()
      .p(
        'AggBjIgWgFIAAgkIAFAAIAIADIAJADIALACIAKABQALAAAHgCQAIgDAEgEQADgFACgFQABgHAAgJIAAgCQgHAGgKAEQgJAFgKAAQgcAAgPgSQgPgTAAgjQAAgRAFgOQAEgNAJgJQAHgJAMgFQALgFAMAAQAKAAAIADQAJADAHAFIACgHIArAAIAAB9QAAAUgGAOQgGAOgJAHQgKAIgOAEQgOADgQAAQgOAAgNgBgAgPg3QgIAKAAATIABAPQABAGADAFQADAFAGACQAFACAHABQAGAAAGgCQAFgDAFgDIAAhAIgIgDIgJgBQgPAAgIALg',
      );
    this.shape_53.setTransform(485.175, 157.25);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#003399')
      .s()
      .p(
        'AAWBJIAAhGIgBgRQAAgIgCgEQgCgFgFgCQgEgCgHAAQgFAAgFACQgGACgGAEIAABkIgtAAIAAiNIAtAAIAAAPQALgJAKgFQAJgFANAAQAWAAALAOQAMANAAAaIAABcg',
      );
    this.shape_54.setTransform(469.225, 154.575);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#003399')
      .s()
      .p('AgVBjIAAiOIAsAAIAACOgAgWg/IAAgjIAuAAIAAAjg');
    this.shape_55.setTransform(456.9, 152.025);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#003399')
      .s()
      .p(
        'AAWBJIAAhGIgBgRQAAgIgCgEQgCgFgFgCQgEgCgHAAQgFAAgFACQgGACgGAEIAABkIgtAAIAAiNIAtAAIAAAPQALgJAKgFQAJgFANAAQAWAAALAOQAMANAAAaIAABcg',
      );
    this.shape_56.setTransform(444.725, 154.575);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#003399')
      .s()
      .p(
        'AgvBIIAAiOIAtAAIAAAUIAHgGIAKgHQAFgDAGgDQAHgCAFAAIAFAAIAFABIAAAqIgEAAIgHgBIgLgBQgHAAgHACIgOAFIAABfg',
      );
    this.shape_57.setTransform(431.575, 154.75);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#003399')
      .s()
      .p(
        'Ag1A+QgNgMAAgUQAAgPAGgKQAHgJAMgGQAMgGARgCQAPgCAUgBIAAgBQAAgMgJgEQgJgFgQAAQgIAAgLADQgKADgKAEIgEAAIAAgiIAVgFQAPgCAPAAQAkAAARAMQARAMAAAZIAABgIgtAAIAAgPIgIAHQgDADgHADIgKAFQgGABgKAAQgTAAgMgNgAAEAGIgNAEQgFACgEAEQgDAEAAAHQAAAKAFAEQAGADAKAAQAFAAAGgCQAGgDAFgFIAAgeIgSACg',
      );
    this.shape_58.setTransform(416.875, 154.775);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#003399')
      .s()
      .p(
        'AgxA4QgVgUAAgjQAAgiAUgUQAUgWAjABQAhAAARARQAQASAAAgIAAAQIhgAAQAAAJAEAIQADAGAGAEQAGAEAHACQAHABAJAAQAIAAAHgBQAIgCAGgDIALgFIAHgFIAEAAIAAAkIgKAEIgMAEIgPADIgSABQgoAAgWgTgAgSgmQgGAIgBANIA0AAQAAgOgGgHQgGgIgNAAQgMAAgIAIg',
      );
    this.shape_59.setTransform(401.85, 154.75);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#003399')
      .s()
      .p(
        'Ag3BRQgOgVAAghQAAgTAFgNQAFgOAIgKQAIgJALgFQALgGAMAAQALAAAHADQAHACAJAFIAAg9IAtAAIAADFIgtAAIAAgPIgJAIIgKAGQgFACgFABQgFACgHAAQgYAAgPgUgAgPgEQgIAKAAAUQAAAVAGAKQAGAJAOAAQAGAAAGgCQAFgDAFgEIAAhFIgIgCIgJgBQgPAAgIALg',
      );
    this.shape_60.setTransform(377.825, 152.225);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f('#003399')
      .s()
      .p(
        'AgxA4QgVgUAAgjQAAgiAUgUQAUgWAjABQAhAAARARQAQASAAAgIAAAQIhgAAQABAJADAIQADAGAGAEQAGAEAHACQAHABAJAAQAIAAAHgBQAIgCAGgDIALgFIAHgFIAEAAIAAAkIgKAEIgMAEIgPADIgTABQgnAAgWgTgAgRgmQgIAIAAANIA0AAQAAgOgGgHQgHgIgMAAQgMAAgHAIg',
      );
    this.shape_61.setTransform(362.45, 154.75);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f('#003399')
      .s()
      .p(
        'AAWBjIAAhHIgBgRQAAgJgCgDQgCgFgFgCQgEgCgHAAQgFAAgFACQgGACgGAFIAABkIgtAAIAAjFIAtAAIAABHQALgJAKgGQAJgFANAAQAWAAALAOQAMAOAAAZIAABdg',
      );
    this.shape_62.setTransform(346.425, 152.025);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f('#003399')
      .s()
      .p(
        'AglBIQgOgEgJgEIAAgmIADAAIAIAGIALAGIAOAFQAIACAJAAQAJAAAHgDQAHgDAAgGQAAgFgEgDQgCgCgKgDIgMgCIgNgEQgSgFgIgJQgJgLAAgQQABgKAEgIQAEgJAJgGQAIgHANgDQANgEAOAAQAPAAANADQANADAIAEIAAAkIgDAAIgIgFIgJgFIgNgEIgOgCQgJAAgGAEQgHADAAAFQAAAFADADQADADAKACIAOADQAHABAHADQAQAFAHAIQAIAKAAAQQAAAKgFAJQgEAJgJAGQgJAHgNAEQgMADgQAAQgQAAgOgDg',
      );
    this.shape_63.setTransform(331.5, 154.775);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f('#003399')
      .s()
      .p('AgVBjIAAiOIArAAIAACOgAgXg/IAAgjIAuAAIAAAjg');
    this.shape_64.setTransform(320.7, 152.025);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f('#003399')
      .s()
      .p(
        'AAWBJIAAhGIgBgRQAAgIgCgEQgCgFgFgCQgEgCgHAAQgFAAgFACQgGACgGAEIAABkIgtAAIAAiNIAtAAIAAAPQALgJAKgFQAJgFANAAQAWAAALAOQAMANAAAaIAABcg',
      );
    this.shape_65.setTransform(308.525, 154.575);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f('#003399')
      .s()
      .p('AgVBjIAAiOIArAAIAACOgAgWg/IAAgjIAtAAIAAAjg');
    this.shape_66.setTransform(296.2, 152.025);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f('#003399')
      .s()
      .p(
        'AgiBkIAAhvIgSAAIAAgfIASAAIAAgEQAAgaAOgNQAOgNAaAAIASABIAPABIAAAhIgEAAIgHgDIgLgBQgNABgFAFQgFAEAAAOIAAABIAjAAIAAAfIghAAIAABvg',
      );
    this.shape_67.setTransform(287.875, 151.95);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f('#003399')
      .s()
      .p(
        'AgxA4QgVgUAAgjQAAgiAUgUQAUgWAjABQAhAAARARQAQASAAAgIAAAQIhgAAQABAJADAIQADAGAGAEQAGAEAHACQAHABAJAAQAIAAAHgBQAIgCAGgDIAKgFIAIgFIAEAAIAAAkIgKAEIgMAEIgPADIgTABQgnAAgWgTgAgRgmQgIAIAAANIA0AAQAAgOgGgHQgHgIgMAAQgMAAgHAIg',
      );
    this.shape_68.setTransform(267.05, 154.75);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f('#003399')
      .s()
      .p('AgXBHIgziNIAuAAIAdBdIAchdIAuAAIgzCNg');
    this.shape_69.setTransform(251.775, 154.775);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics.f('#003399').s().p('AgMAlIgIhJIApAAIgIBJg');
    this.shape_70.setTransform(240.675, 145.875);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f('#003399')
      .s()
      .p(
        'Ag2A8QgMgOAAgbIAAhbIAtAAIAABGIAAARQABAHACAFQACAFAEACQAFACAHAAQAEAAAGgCQAHgCAFgEIAAhkIAtAAIAACNIgtAAIAAgPQgLAJgKAFQgJAFgNAAQgVAAgMgNg',
      );
    this.shape_71.setTransform(228.725, 154.975);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f('#003399')
      .s()
      .p(
        'Ag1A4QgUgVAAgjQAAgjAUgUQATgUAiAAQAjAAATAVQAUAUAAAiQAAAjgUAVQgTAUgjAAQgiAAgTgUgAgKgpQgFACgEAFQgEAFgCAJQgCAIAAAMQAAANACAIQACAIAEAFQADAFAGADQAFACAFAAQAGAAAFgCQAGgDADgEQAEgGACgHQACgIAAgOQAAgLgCgJQgCgIgEgFQgEgGgFgCQgFgCgGAAQgFAAgFACg',
      );
    this.shape_72.setTransform(212.425, 154.775);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f('#003399')
      .s()
      .p('AgWBfIAAhNIhDhvIA2AAIAlBDIAkhDIAzAAIhBBsIAABQg');
    this.shape_73.setTransform(195.65, 152.45);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.round1Btn },
            { t: this.round2Btn },
            { t: this.round3Btn },
            { t: this.round4Btn },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(314.05, 425.4);

    this.timeline.addTween(cjs.Tween.get(this.moreBtn).wait(1));

    // swirl
    this.instance = new lib.Menuwatermark();
    this.instance.setTransform(399.95, 269.95);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // bg
    this.continueBtn = new lib.continueBtn();
    this.continueBtn.name = 'continueBtn';
    this.continueBtn.setTransform(501.65, 425.4);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_74.setTransform(400, 280);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_74 }, { t: this.continueBtn }] })
        .wait(1),
    );

    // shadow
    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_75.setTransform(405, 285);

    this.timeline.addTween(cjs.Tween.get(this.shape_75).wait(1));

    // veil
    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_76.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_76).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.PracticeMenu,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsGameFrame = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // veil
    this.veil = new lib.GameFrame_veil();
    this.veil.name = 'veil';
    this.veil.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.veil).wait(1));

    // changeRoundBtn
    this.changeRoundBtn = new lib.Scoreboard_changeRoundBtn();
    this.changeRoundBtn.name = 'changeRoundBtn';
    this.changeRoundBtn.setTransform(672.3, 678.3);

    this.timeline.addTween(cjs.Tween.get(this.changeRoundBtn).wait(1));

    // scoreboard
    this.scoreboard = new lib.comsuntexsymbolsScoreboard();
    this.scoreboard.name = 'scoreboard';
    this.scoreboard.setTransform(355.1, 670.5, 1, 1, 0, 0, 0, 355.1, 13);

    this.timeline.addTween(cjs.Tween.get(this.scoreboard).wait(1));

    // practiceMenu
    this.practiceMenu = new lib.PracticeMenu();
    this.practiceMenu.name = 'practiceMenu';
    this.practiceMenu.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.practiceMenu).wait(1));

    // endScreen
    this.endScreen = new lib.EndScreen();
    this.endScreen.name = 'endScreen';
    this.endScreen.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.endScreen).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsGameFrame,
    new cjs.Rectangle(-5, -5, 810, 704.5),
    null,
  );

  // stage content:
  (lib.VIFGears = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // veil
    this.veil = new lib.Veil();
    this.veil.name = 'veil';
    this.veil.setTransform(349.95, 349.95, 0.7291, 0.7291, 0, 0, 0, 0.2, 0.2);

    this.timeline.addTween(cjs.Tween.get(this.veil).wait(1));

    // congratulations
    this.congratulations = new lib.Congratulations();
    this.congratulations.name = 'congratulations';
    this.congratulations.setTransform(
      291.85,
      218.85,
      0.7291,
      0.7291,
      0,
      0,
      0,
      400.2,
      300.2,
    );

    this.timeline.addTween(cjs.Tween.get(this.congratulations).wait(1));

    // gameStage
    this.gameStage = new lib.GameStage();
    this.gameStage.name = 'gameStage';
    this.gameStage.setTransform(
      349.6,
      365.9,
      0.7291,
      0.7291,
      0,
      0,
      0,
      0.2,
      0.2,
    );

    this.txtPreview = new cjs.Text('', "bold 24px 'Verdana'", '#003399');
    this.txtPreview.name = 'txtPreview';
    this.txtPreview.textAlign = 'center';
    this.txtPreview.lineHeight = 29;
    this.txtPreview.lineWidth = 277;
    this.txtPreview.parent = this;
    this.txtPreview.setTransform(350.15, 19.45, 0.7291, 0.7291);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.txtPreview }, { t: this.gameStage }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(349.3, 349.9, 350.7, 356.80000000000007);
  // library properties:
  lib.properties = {
    id: '93EDC93AE36724438917B68F3EA8A53E',
    width: 700,
    height: 700,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['93EDC93AE36724438917B68F3EA8A53E'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
